export const translations = {
  IT: {
    cnMultiTratta: 'Viaggi a più tappe',
    cnMultiTrattaDesc:
      'Un giro come Milano-Parigi-Londra-Milano diventa una richiesta sola: ogni volo con la sua tratta e un hotel per tappa. Spento, Nora propone di procedere una tratta alla volta.',
    // ── Import dati (pagina admin) — prefisso `id` ──────────────────────────
    idTitolo: 'Import dati',
    idSottotitolo:
      'Dataset esterni che Nora usa: si aggiornano col pulsante o da soli, a intervalli.',
    idRotteTitolo: 'Rotte aeree',
    idRotteTesto:
      'Voli diretti fra aeroporti, dallo scraping di flightsfrom.com: li usa il planner dei viaggi. Un giro completo dura alcune ore.',
    idGeoTitolo: 'Città (GeoNames)',
    idGeoTesto:
      'Località con almeno 1.000 abitanti e i loro nomi in più lingue: Nora riconosce che «Milan» e «Milano» sono lo stesso posto.',
    idAvviaOra: 'Avvia ora',
    idAvviato: 'Import avviato',
    idFerma: 'Ferma',
    idFermaInviato: 'Richiesta di arresto inviata',
    idNonDisponibile: 'Import non disponibile su questa installazione.',
    idInCorso: 'in corso',
    idCompletato: 'completato',
    idFallito: 'fallito',
    idFermato: 'fermato',
    idInterrotto: 'interrotto',
    idDataset: 'Dataset',
    idRighe: 'righe',
    idVuoto: 'vuoto',
    idAggiornato: 'Aggiornato il',
    idUltimoImport: 'Ultimo import',
    idProssimo: 'Prossimo',
    idManuale: 'manuale',
    idPianificato: 'pianificato',
    idAutomatico: 'Aggiorna da solo',
    idOgni: 'ogni',
    idGiorno: 'giorno',
    idGiorni: 'giorni',
    idStorico: 'Storico',
    idStoricoSotto:
      'Gli ultimi import, manuali e pianificati. Una riga con un messaggio si apre col clic.',
    idNessunImport: 'Nessun import ancora.',
    idColQuando: 'Quando',
    idColDataset: 'Dataset',
    idColAvvio: 'Avviato da',
    idColStato: 'Stato',
    idColDurata: 'Durata',
    idColRighe: 'Righe',
    aeFerma: 'Ferma la run',
    aeFermata: 'fermata',
    aeFermaFallito: 'Run non fermata',
    aeNuovaRun: 'Nuova run',
    aeChiudiForm: 'Chiudi',
    aeDettaglio: 'Dettaglio della run',
    aeScegliRun: 'Scegli una run dall’elenco per vederne il dettaglio.',
    // ── Eval dell'agente (pagina admin) — prefisso `ae` ──────────────────────
    aeTitolo: "Eval dell'agente",
    aeSottotitolo:
      "Lancia gli scenari del repo su un environment e confronta le run: cosa cambia quando cambia l'harness o il modello, e quanto è affidabile l'agente.",
    aeLancia: 'Lancia una run',
    aeLanciaSotto:
      'Gli scenari sono file JSON in Executor/API/agentEval/scenari: si modificano lì.',
    aeEnvironment: 'Environment',
    aeScenari: 'Scenari',
    aeTutti: 'tutti',
    aeTuttiApplicabili: 'tutti quelli che girano qui',
    aeScegliEnvPrima: 'Scegli un environment: il suo flusso decide quali scenari hanno senso.',
    aeFlussoEnv: "Flusso dell'environment",
    aeFlussoRun: 'Flusso della run',
    aeFlussoDellEnvironment: "quello dell'environment",
    aeFlussoOverride:
      'La chat simulata nasce con questo flusso. La Configurazione Nora non cambia.',
    aeSoloEsclusivi: 'Solo gli scenari scritti per questo flusso',
    aeCapabilityAccese: 'capability accese',
    aeNessunaCapability: 'nessuna capability',
    aeNonApplicabili: 'Non girano su questo environment',
    aeSoloPer: 'solo per',
    aeCapabilitySpenta: 'capability spenta',
    aeNonAgentico: 'environment senza modalità agentica per l’app',
    aeRichiedeViaggio: 'controlla dati di viaggio, che questo environment non ha',
    aePassaggi: 'Passaggi',
    aeControlli: 'Controlli',
    aeCopione: 'Copione',
    aeAttesa: 'mossa attesa',
    aeVietata: 'mossa vietata',
    aeRifiutoAtteso: 'rifiuto atteso',
    aeNonValido: 'Non valido:',
    aeRipetizioni: 'Ripetizioni',
    aeRipetizioniScenario: 'quelle dello scenario',
    aeRicerca: 'Ricerca',
    aeRicercaFinta: 'Finta (misura l’agente)',
    aeRicercaReale: 'Reale (provider veri, sola lettura)',
    aeNome: 'Nome della run',
    aeNomeEsempio: 'es. sola andata dopo il prompt nuovo',
    aeRipeti: 'Ripeti',
    aeCosto: 'costo',
    aeCostoTotale: 'Costo delle run',
    aeCostoTotaleSotto: 'Somma stimata, divisa per modello e provider, nel periodo scelto.',
    aeCostoSenzaDettaglio: 'Le run di questo periodo non hanno lo spaccato per modello e provider.',
    aeCostoDettaglio: 'Dettaglio costo',
    aePerRun: 'per run',
    aePerPasso: 'per passo',
    aeErroriProvider: 'errori del provider',
    aeRossiAgente: 'rossi dell’agente',
    aeUltimoGiorno: 'Ultimo giorno',
    aeUltimi7: '7 giorni',
    aeUltimi30: '30 giorni',
    aeTutto: 'Tutto',
    aeNessunaInCorso: 'nessuna in corso',
    aePassi: 'Passi eseguiti',
    aeProveClassificate: 'Prove con esito noto',
    aeNonClassificati: 'passi storici non classificati',
    aeScenariSaltati: 'Scenari saltati',
    aeProveSaltate: 'prove saltate',
    aeHarness: 'Harness',
    aeTuttiHarness: 'Tutte le versioni',
    aeSenzaVersione: 'senza versione',
    aeFirma: 'firma',
    aeGuidaApri: 'Come leggere i risultati',
    aeGuidaTitolo: 'Come leggere i risultati',
    aeGuidaIntro:
      'La pagina mostra tre unità diverse: run, scenari ed esecuzioni. I loro numeri non vanno sommati fra loro.',
    aeGuidaSogliaTitolo: 'Sopra e sotto soglia',
    aeGuidaSoglia:
      'La soglia è scritta da chi crea lo scenario nel suo file JSON. Se manca, il sistema usa 80% per le conversazioni e 90% per le decisioni. La quota è esecuzioni riuscite ÷ esecuzioni che contano: PASS se è almeno pari alla soglia, FAIL se è inferiore. Esempio con soglia 80%:',
    aeGuidaEsempioPass: 'raggiunge la soglia',
    aeGuidaEsempioFail: 'sotto la soglia',
    aeGuidaSogliaNota:
      'Anche uno scenario FAIL può contenere esecuzioni verdi. Se non ci sono prove valide, lo scenario non supera la soglia.',
    aeGuidaConteggiTitolo: 'Che cosa conta ogni colonna',
    aeGuidaVerdi: 'Esecuzioni in cui tutti i controlli passano, o la decisione attesa è corretta.',
    aeGuidaRossi: 'Esecuzioni valide che non soddisfano i controlli o la decisione attesa.',
    aeGuidaErrori:
      'Esecuzioni interrotte da un errore tecnico, per esempio un timeout; non sono un rosso del comportamento dell’agente.',
    aeGuidaNonValidi:
      'Punti di decisione il cui copione non ha prodotto il rifiuto atteso. Non entrano nella quota dello scenario.',
    aeGuidaSaltati:
      'Scenari non applicabili al flusso o alle capability. La colonna conta scenari, non ripetizioni.',
    aeGuidaAvanzamento:
      'Esecuzioni svolte più ripetizioni saltate, sul totale previsto. Un salto avanza la run senza generare una prova.',
    aeGuidaStorico:
      'Nelle run precedenti a questi conteggi, rossi e ripetizioni saltate non sono ricostruibili: — significa dato non disponibile.',
    aeAltriFiltri: 'Altri filtri',
    aeAzzeraFiltriExtra: 'Azzera questi filtri',
    aeColQuando: 'Quando',
    aeColNome: 'Nome',
    aeColEnv: 'Environment',
    aeColFlusso: 'Flusso',
    aeColPassi: 'Avanzamento',
    aeColVerdi: 'Prove riuscite',
    aeColErrori: 'Errori tecnici',
    aeColNonValidi: 'Non valide',
    aeColRossi: 'Prove non riuscite',
    aeColCosto: 'Costo',
    aeColEsito: 'Esito',
    aeColScenario: 'Scenario',
    aeColQuota: 'Quota',
    aeColFallite: 'Prove fallite',
    aeColSottoSoglia: 'Run sotto soglia',
    aeColRun: 'Run',
    aeColCade: 'Dove cade',
    aeScenariEseguiti: 'risultati di scenario (run × scenario)',
    aeSottoPieno: 'sotto il 100%',
    aeProveFallite: 'di prove fallite',
    aeDiCuiInterrotte: 'interrotte dal provider',
    aeNessunaDifficolta: 'Nessuno scenario sotto il 100% in questo periodo.',
    aeInCorso: 'in corso',
    aeInCoda: 'in coda',
    aeCompletata: 'completata',
    aeCerca: 'Cerca per nome',
    aeTuttiEnv: 'Tutti gli environment',
    aeTuttiFlussi: 'Tutti i flussi',
    aeTuttiStati: 'Tutti gli esiti',
    aeDal: 'Dal giorno',
    aeAl: 'Al giorno',
    aeNessunaFiltrata: 'Nessuna run con questi filtri.',
    aePaginaPrima: 'Pagina precedente',
    aePaginaDopo: 'Pagina successiva',
    aeAnalisi: 'Scenari in difficoltà',
    aeApriDettaglio: 'Apri il dettaglio',
    aeAnalisiSotto:
      'Sulle run concluse del periodo: uno scenario può comparire in più run. Le quote usano solo le prove che contano per quello scenario; i salti e le decisioni non valide sono esclusi.',
    aeAvvia: 'Avvia la run',
    aeEnvironments: 'Environment',
    aeEnvironmentsAiuto:
      'Scegline uno o più. Con più environment gli scenari comuni girano solo sul primo scelto, quelli di flusso su ciascuno.',
    aePrimoComuni: 'comuni qui',
    aeCatalogoEnvNonLetto:
      'Il catalogo di un environment non si è potuto leggere: controlla la sua Configurazione Nora.',
    aePreset: 'Selezione rapida',
    aePreset_tutti: 'Tutti',
    aePreset_comuni: 'Solo comuni',
    aePreset_flussi: 'Solo di flusso',
    aePreset_falliti: "Falliti nell'ultima run",
    aeNessunFallito: "Nessuno scenario sotto soglia nell'ultima run conclusa",
    aeComuni: 'Comuni',
    aeComuniAiuto:
      'Non dipendono dal flusso: in una campagna girano una volta, sul primo environment.',
    aeDiFlusso: 'Di flusso',
    aeDiFlussoAiuto:
      'Dipendono dal flusso: girano su ogni environment scelto il cui flusso è il loro.',
    aeNonGiraQui: 'non gira sugli environment scelti',
    aeRicercaRealeAvviso:
      'Usa i provider veri: costa di più e può fallire per cause esterne (VPN, disponibilità).',
    aeTrascrizioni:
      'Salva anche le trascrizioni intere su file (agentEval/trascrizioni). Le esecuzioni rosse restano comunque leggibili qui.',
    aeAvviaCampagna: 'Avvia la campagna',
    aeNessunoScelto: 'Scegli almeno un environment',
    aeMinuti: 'min',
    aeNienteDaLanciare: 'Nessuno scenario gira sugli environment scelti',
    aeCampagnaAvviata: 'Campagna avviata',
    aeCampagnaParziale: 'Campagna avviata solo in parte',
    aeCampagna: 'Campagna',
    aeStrumenti: 'Strumenti',
    aeRipetiFalliti: 'Ripeti i falliti',
    aeSottoSoglia: 'Sotto soglia',
    aeSopraSogliaTitolo: 'Sopra soglia',
    aeSaltatiTitolo: 'Saltati',
    aeRunInCorso: 'Run in corso',
    aeRun: 'Run',
    aeRunSotto:
      'Avanzamento = esecuzioni svolte + ripetizioni saltate. Le run storiche non distinguono tutte le categorie.',
    aeNessunaRun: 'Nessuna run ancora.',
    aeFallita: 'fallita',
    aeElimina: 'Elimina la run',
    aeEliminaConferma: 'Eliminare la run',
    aeRunNonEliminata: 'Run non eliminata',
    aeRunAvviata: 'Run avviata',
    aeEsecuzioni: 'esecuzioni',
    aeRunNonAvviata: 'Run non avviata',

    aeExecutorNonRaggiungibile: 'Executor non raggiungibile',
    aeRunIllegibile: 'Run non leggibile.',
    aeFlusso: 'flusso',
    aeSopraSoglia: 'scenari che raggiungono la soglia',
    aeSoglia: 'soglia',
    aePrima: 'prima',
    aeSaltato: 'SALTATO',
    aeInterrotta: 'interrotta',
    aeNessunTool: 'nessun tool',
    aeRichiestaFinale: 'Richiesta finale',
    aeNonConta: 'non conta (copione senza il rifiuto atteso)',
    // ── D28 — pagina «Configurazione Nora» ─────────────────────────────────
    // Prefisso `cn`. Ogni testo visibile della pagina passa da qui.
    cnTitolo: 'Configurazione Nora',
    cnSottotitolo:
      'Scegli se usare Nora, con quali viaggi e quali aggiunte. Ogni salvataggio vale dal turno successivo, anche per le chat aperte.',
    cnSelezionaEnvironment: 'Environment',
    cnNessunEnvironment: 'Seleziona un environment per vedere la configurazione.',
    cnCaricamentoFallito: 'Impossibile caricare la configurazione.',
    cnRiprova: 'Riprova',
    cnModalita: 'Modalità',
    cnModalitaPredefinita: 'Configurazione predefinita',
    cnModalitaPredefinitaHint: 'Vale per tutte le community che non hanno un’eccezione.',
    cnModoProcessUnit: 'Process-Unit',
    cnModoProcessUnitDesc: 'Usa processi, unit e configurazione esistenti.',
    cnModoDynamicDemo: 'Nora · viaggi Demo Dinamico',
    cnModoDynamicDemoBreve: 'Demo Dinamico',
    cnModoDynamicDemoDesc:
      'Cerca offerte reali con Dinamico; la conferma resta locale e non crea pratica né prenotazione.',
    cnModoMidofficeCase: 'Pratica Midoffice',
    cnModoMidofficeCaseDesc:
      'Crea pratica e servizi, cerca con Dinamico e scrive il preventivo nel Midoffice.',
    cnModoGoelettBooking: 'Nora · viaggi Goelett',
    cnModoGoelettBookingBreve: 'Prenotazione Goelett',
    cnModoGoelettBookingDesc: 'Cerca, crea il carrello e prenota su Goelett dopo due conferme.',
    cnModoAssistant: 'Nora · senza viaggi',
    cnMotore: 'Motore',
    cnMotoreNora: 'Nora',
    cnMotoreNoraDesc:
      'Nora risponde in chat con le aggiunte scelte qui sotto; cercare e prenotare viaggi è facoltativo.',
    cnViaggi: 'Viaggi',
    cnViaggiNessuno: 'Nessuno',
    cnViaggiNessunoDesc: 'Nora non cerca né prenota viaggi: risponde e pianifica con le aggiunte.',
    cnAggiunte: 'Aggiunte',
    cnModoAssistantDesc:
      'Risponde con le sole aggiunte (meteo, ricerca web, pianificazione, policy): non cerca né prenota viaggi.',
    cnScriveSistemiEsterni: 'Scrive su sistemi esterni',
    cnNessunaConfigurazioneAgentica:
      'Nessuna configurazione agentica salvata: l’environment usa Process-Unit.',
    cnCapabilities: 'Capabilities',
    cnComportamento: 'Comportamento',
    cnCapabilitiesHint:
      'Aggiunte agentiche facoltative. Si accendono da qui; se una non si riesce a costruire (per esempio manca la chiave Google), Nora funziona senza.',
    cnCapabilitiesProcessUnit: 'Senza un canale agentico le capabilities non si usano.',
    cnCanali: 'Per canale',
    cnCanaliHint:
      'Ogni canale può usare una configurazione diversa; l’app funziona soltanto con Nora.',
    cnCanaliFissi: '{canali}: sempre Process-Unit.',
    cnCanaleComePredefinita: 'Come la configurazione predefinita',
    cnCanaleOggi: 'Oggi: {modalita}',
    cnCanaleNonAbilitato: 'Oggi: canale non abilitato',
    cnCanaleApp: 'App Nora',
    cnCanaleTeams: 'Teams',
    cnCanaleEmail: 'Email',
    cnCanaleMidoffice: 'Midoffice',
    cnCanaleWhatsapp: 'WhatsApp',
    cnCapWeather: 'Meteo',
    cnCapWeatherDesc: 'Previsioni meteo sulla destinazione.',
    cnCapTripPlanner: 'Pianificazione itinerario',
    cnCapTripPlannerDesc: 'Suggerimenti di itinerario e tappe.',
    cnMezziTitolo: 'Mezzi proposti dal planner',
    cnMezziAiuto:
      'Valgono per il viaggio intero. Le tratte brevi per raggiungere stazione o aeroporto restano sempre. Da auto, taxi e pullman non si crea una richiesta di viaggio: si prenotano treno e aereo.',
    cnMezziDefault: 'Nessuna scelta: valgono i mezzi previsti dall installazione.',
    cnMezziAlmenoUno: 'Scegline almeno uno, oppure lasciali tutti deselezionati.',
    cnMezzoVolo: 'Aereo',
    cnMezzoTreno: 'Treno',
    cnMezzoAuto: 'Auto o taxi',
    cnCapTravelPolicy: 'Consultazione policy viaggio',
    cnCapTravelPolicyDesc:
      'Il viaggiatore può consultare le regole aziendali. Il rispetto delle regole resta attivo anche da spento.',
    cnCapWebSearch: 'Ricerca web',
    cnCapWebSearchDesc:
      'Notizie aggiornate sul viaggio: eventi, scioperi, disagi. Serve la chiave Tavily (apiKeyTavily) sull’Executor.',
    cnSalvaEUsa: 'Salva e applica',
    cnSoloNuoveChat: 'Vale dal turno successivo, anche per le chat già aperte.',
    cnSalvato: 'Configurazione salvata',
    cnOperazioneRiuscita: 'Operazione eseguita',
    cnConflitto: 'Configurazione cambiata nel frattempo',
    cnConflittoDettaglio:
      'Qualcun altro l’ha modificata: nulla è stato sovrascritto e la pagina è stata ricaricata. Rivedi e salva di nuovo.',
    cnConfermaScrittureTitolo: 'Conferma scritture su sistemi esterni',
    cnConfermaScritture:
      'Con «{modalita}» le nuove chat scriveranno su {sistema}, destinazione {destinazione}.',
    cnSistemaMidoffice: 'Midoffice e Dinamico',
    cnSistemaGoelett: 'Goelett',
    cnDestinazioneTest: 'Test',
    cnDestinazioneProduzione: 'Produzione',
    cnDestinazioneSandbox: 'Sandbox',
    cnDestinazioneNonConfigurata: 'non ancora configurata',
    cnStatoPronta: 'Pronta',
    cnStatoProntaMancanti: 'Pronta, con aggiunte non disponibili',
    cnStatoNonPronta: 'Non pronta',
    cnStatoSospesa: 'Sospesa',
    cnStatoEffettiArrestati: 'Effetti arrestati',
    cnAggiornataIl: 'Aggiornata il',
    cnRiepilogoTitolo: 'Valori letti da altre fonti',
    cnRiepilogoHint:
      'Nora usa anche questi valori, che non si cambiano da qui: la colonna Provenienza dice dove.',
    cnVoce: 'Voce',
    cnValore: 'Valore',
    cnProvenienza: 'Provenienza',
    cnFonteEnvironment: 'Environment',
    cnFonteCommunity: 'Community',
    cnFonteTecnica: 'Configurazione tecnica',
    cnRigaEnvironment: 'Environment',
    cnRigaDestinazioneDinamico: 'Destinazione Dinamico',
    cnRigaCommunityPredefinita: 'Community predefinita',
    cnRigaPolicyCommunity: 'Servizi, tono e pubblicazione preventivi',
    cnPolicyCommunityValore: 'dal pannello Community',
    cnRigaModelloLimiti: 'Modello di Nora',
    cnGestitiDalDeploy: 'gestiti dal deploy',
    cnModelloSenzaChiave: 'chiave del modello assente',
    cnRigaConnessioneMidoffice: 'Connessione demo Dinamico',
    cnRigaConnessioneGoelett: 'Connessione Goelett',
    cnConnessioneAttiva: 'attiva',
    cnConnessioneRevocata: 'revocata',
    cnConnessioneAssente: 'non ancora creata',
    cnConnessioneMidofficeAuto: 'la crea il server al primo salvataggio che la richiede',
    cnNessuna: 'nessuna',
    cnEccezioniTitolo: 'Eccezioni per community',
    cnEccezioniHint:
      'Di norma ogni community (cliente) usa la configurazione predefinita. Un’eccezione le dà motore, viaggi o aggiunte diverse: per esempio un cliente con i viaggi Goelett mentre gli altri restano sulla Demo Dinamico.',
    cnNessunaCommunity: 'Nessuna community per questo environment.',
    cnCodiceCliente: 'Codice cliente',
    cnPresetPredefinito: 'Predefinita',
    cnInattiva: 'Inattiva',
    cnEredita: 'Eredita dall’environment',
    cnEreditaValore: 'Eredita dall’environment: {modalita}',
    cnDescEredita:
      'L’eccezione viene eliminata: le nuove chat di questa community useranno la modalità dell’environment ({modalita}).',
    cnFissata: 'Fissata',
    cnFissataHint: 'Uguale al default attuale, ma resta così anche se il default cambia.',
    cnEccezione: 'Eccezione',
    cnOverrideNonApplicata: 'Eccezione presente ma non applicata alle nuove chat.',
    cnMotivoDefaultPreset: 'Preset predefinito: usa sempre il default dell’environment.',
    cnMotivoInattiva: 'Community inattiva: nessuna eccezione possibile.',
    cnMotivoSenzaCodice: 'Senza codice cliente: nessuna eccezione possibile.',
    cnMotivoNonAmmessa: 'Nessuna eccezione possibile per questa community.',
    cnImpostaEccezione: 'Imposta eccezione',
    cnModificaEccezione: 'Modifica eccezione',
    cnGoelettTitolo: 'Collegamento Goelett',
    cnGoelettHint:
      'Le credenziali con cui Nora parla con Goelett. Servono solo ai viaggi con Goelett, che non si possono salvare senza. Per aggiornare o riattivare il collegamento compila di nuovo tutti i campi.',
    cnGoelettStato: 'Stato attuale',
    cnGoelettAmbiente: 'Ambiente Goelett',
    cnGoelettBaseUrl: 'URL base',
    cnGoelettBaseUrlHint: 'https, deve terminare con /nora/public.',
    cnGoelettUrlNonValido: 'L’URL base deve iniziare con https:// e terminare con /nora/public.',
    cnGoelettStsUrl: 'URL del servizio token (STS)',
    cnGoelettStsNonValido: 'L’URL STS deve iniziare con https://.',
    cnGoelettScope: 'Scope OAuth (facoltativo)',
    cnGoelettClientId: 'Client ID',
    cnGoelettSecretRef: 'Nome del riferimento al segreto',
    cnGoelettSecretRefHint:
      'Solo il nome: il valore del segreto vive nella configurazione dell’Executor.',
    cnGoelettSalva: 'Salva collegamento',
    cnGoelettSalvato: 'Collegamento Goelett salvato',
    cnRevocaConnessione: 'Revoca collegamento',
    cnDescRevocaConnessione:
      'Il collegamento Goelett non sarà più utilizzabile finché non viene salvato di nuovo.',
    cnAvvisoEffettiInCorso:
      'Attenzione: questo comando può interrompere gli effetti in corso sulle conversazioni aperte.',
    cnOperativoTitolo: 'Freni di emergenza',
    cnOperativoHint:
      'Fermano Nora su questo environment se qualcosa va storto, senza cambiare la configurazione. Di norma restano spenti.',
    cnMostra: 'Mostra',
    cnNascondi: 'Nascondi',
    cnNuoveChat: 'Nuove chat agentiche',
    cnNuoveChatAmmesse: 'ammesse',
    cnNuoveChatSospese: 'sospese',
    cnSospendiNuoveChat: 'Sospendi nuove chat',
    cnRiprendiNuoveChat: 'Riprendi nuove chat',
    cnDescSospendiNuoveChat:
      'Le nuove chat agentiche dell’environment vengono bloccate; le chat aperte proseguono.',
    cnDescRiprendiNuoveChat: 'Le nuove chat agentiche dell’environment tornano ammesse.',
    cnEffettiEsterni: 'Effetti esterni',
    cnEffettiAttivi: 'attivi',
    cnEffettiArrestati: 'arrestati',
    cnArrestaEffetti: 'Arresta effetti',
    cnRiprendiEffetti: 'Riprendi effetti',
    cnDescArrestaEffetti:
      'Blocca le scritture sui sistemi esterni per tutte le chat dell’environment.',
    cnDescRiprendiEffetti: 'Le scritture sui sistemi esterni tornano ammesse.',
    cnSpiegaNuoveChat:
      'Acceso, le nuove chat agentiche di questo environment non partono. Le chat già aperte continuano.',
    cnSpiegaEffetti:
      'Acceso, Nora continua a conversare e a cercare, ma non prenota su Goelett, nemmeno nelle chat già aperte. Ciò che è già stato creato resta.',
    cnAvvisoNuoveChatSospese:
      'Freno attivo: le nuove chat agentiche di questo environment sono sospese.',
    cnAvvisoEffettiArrestati: 'Freno attivo: Nora non prenota su Goelett.',
    cnVaiAiFreni: 'Vai ai freni',
    cnConnessioneNonUsata: 'non usato',
    cnServeGoelett:
      'I viaggi con Goelett richiedono un collegamento Goelett attivo: configuralo e salvalo, poi salva questa configurazione.',
    cnConfiguraGoelett: 'Configura il collegamento',
    cnSalvaBloccatoGoelett: 'Serve prima il collegamento Goelett.',
    cnConteggioEccezioni: '{n} con eccezione',
    cnNessunaCommunityAmmessa:
      'Nessuna community di questo environment può avere un’eccezione: tutte usano la configurazione predefinita.',
    cnCommunityBloccate: 'Altre {n} community non possono avere eccezioni',
    // ── Badge dello scenario di esecuzione ───────────────────────────
    agScenario: 'Scenario',
    agScenarioOfferSelection: 'Ricerca e conferma simulata',
    agScenarioCaseSubmission: 'Pratica in Midoffice',
    agScenarioBooking: 'Prenotazione',
    agScenarioModoSimulate: 'conferma simulata',
    agScenarioModoExecute: 'scritture reali',
    agScenarioModoDeny: 'nessuna scrittura',
    agScenarioDatiFixture: 'dati di esempio',
    // ── Stati di esecuzione delle conversazioni agentiche ──────────────
    // Prefisso `ag`. Sono etichette della LISTA operatore: dicono di chi è la palla,
    // non cosa sta facendo il motore.
    agAttesaOperatore: 'In attesa di operatore',
    agAttesaViaggiatore: 'In attesa del viaggiatore',
    agDaGestire: 'Da gestire',
    agPreventivoDaConfermare: 'Preventivo da confermare',
    gf45Porte: '4-5 porte',
    gfAllInclusive: 'All Inclusive',
    gfAndataRitorno: 'Andata e ritorno',
    gfAutomatico: 'Automatico',
    gfBedAndBreakfast: 'Bed and Breakfast',
    gfBenzina: 'Benzina',
    gfCena: 'Cena',
    gfCentrale: 'Centrale',
    gfCompact: 'Compact',
    gfCorridoio: 'Corridoio',
    gfCrossover: 'Crossover',
    gfDiesel: 'Diesel',
    gfEconomy: 'Economy',
    gfElettrica: 'Elettrica',
    gfFinestrino: 'Finestrino',
    gfFormatoData: 'Formato gg/mm/aaaa',
    gfFullSize: 'Full size',
    gfGpl: 'GPL',
    gfIbrida: 'Ibrida',
    gfIntermediate: 'Intermediate',
    gfLuxury: 'Luxury',
    gfManuale: 'Manuale',
    gfMezzaPensione: 'Mezza pensione',
    gfMini: 'Mini',
    gfMonovolume: 'Monovolume',
    gfNo: 'No',
    gfNonPrecedentePartenza: 'Non può essere precedente alla partenza',
    gfNonSpecificato: 'Non specificato',
    gfPensioneCompleta: 'Pensione completa',
    gfPranzo: 'Pranzo',
    gfPremium: 'Premium',
    gfSi: 'Si',
    gfSolaAndata: 'Sola andata',
    gfSoloNumeri: 'Solo numeri',
    gfSoloStanza: 'Solo stanza',
    gfSportiva: 'Sportiva',
    gfStandard: 'Standard',
    gfStationWagon: 'Station Wagon',
    gfSuv: 'Suv',
    gfVan: 'Van',
    mxAllInclusive: 'All Inclusive',
    mxBedAndBreakfast: 'Bed and Breakfast',
    mxCenaInclusa: 'Cena Inclusa',
    mxCoeffDistanza: 'Coefficiente Distanza',
    mxCoeffDurata: 'Coefficiente Durata',
    mxCoeffScostamento: 'Coefficiente Scostamento',
    mxGruppoBase: 'Base',
    mxGruppoCorporate: 'Corporate',
    mxGruppoLivelliHotel: 'Livelli Hotel Program',
    mxGruppoTrattamento: 'Trattamento',
    mxLivello0: 'Livello 0',
    mxLivello1: 'Livello 1',
    mxLivello2: 'Livello 2',
    mxLivello3: 'Livello 3',
    mxMezzaPensione: 'Mezza Pensione',
    mxPensioneCompleta: 'Pensione Completa',
    mxPranzoIncluso: 'Pranzo Incluso',
    mxRoomOnly: 'Room Only',
    mxTariffaAgenzia: 'Tariffa Agenzia',
    mxTariffaCliente: 'Tariffa Cliente',
    mxTariffaPubblica: 'Tariffa Pubblica',
    pfPreset24h: 'Ultime 24h',
    pfPreset30Giorni: 'Ultimi 30 giorni',
    pfPreset6h: 'Ultime 6h',
    pfPreset7Giorni: 'Ultimi 7 giorni',
    pfPresetUltimaOra: 'Ultima ora',
    pfStatoAttenzione: 'Attenzione',
    pfStatoCritico: 'Critico',
    pfStatoNormale: 'Normale',
    pfStepCompletato: 'Completato',
    admAbilitazioneArrivoEntro: 'Abilitazione arrivo entro',
    admAbilitazioneArrivoEntroDesc:
      "Abilita l'impostazione dell'ora di partenza dei servizi a 00:01 se non è indicata ma è presente l'indicazione di arrivo entro...",
    admAbilitazioneAtlante: 'Abilitazione Atlante',
    admAbilitazioneAtlanteDesc: "Abilita l'utilizzo di Atlante.",
    admAbilitazioneB4B: 'Abilitazione B4B',
    admAbilitazioneB4BDesc: "Abilita l'integrazione con il sistema B4B",
    admAbilitazioneCarnet: 'Abilitazione carnet',
    admAbilitazioneCarnetDesc: "Abilita l'utilizzo dei carnet.",
    admAbilitazioneMidOffice: 'Abilitazione Mid Office',
    admAbilitazioneMidOfficeDesc: "Abilita l'utilizzo di Mid Office.",
    admAbilitazioneRimborsabile: 'Abilitazione gestione rimborsabile',
    admAbilitazioneRimborsabileDesc: 'Abilita la gestione dei treni rimborsabili o meno.',
    admBloccaEmailErroreOperatori: 'Blocca invio email di errore agli operatori',
    admBloccaEmailErroreOperatoriDesc: "Blocca l'invio di email di errore agli operatori",
    admCodiceMastroCliente: 'Codice Mastro Cliente',
    admCodiceMastroClienteDesc:
      'Codice mastro per identificare il cliente (es: 20 1 2 127, il 20 è il mastro)',
    admCodiceOperatore: 'Codice Operatore',
    admCodiceOperatoreDesc: 'Codice operatore per ricerca su ATP Tabelle generiche',
    admCodiceProvenienza: 'Codice Provenienza',
    admCodiceProvenienzaDesc: 'Codice provenienza per ATP Tabelle biglietti',
    admCodiceSocieta: 'Codice Società',
    admCodiceSocietaDesc: 'Codice univoco per identificare la società',
    admCodiceTomcat: 'Codice Tomcat',
    admCodiceTomcatDesc: 'Codice del server Tomcat associato',
    admConfigurazioneEmailReport: 'Configurazione Email Report',
    admConfigurazioneEmailReportDesc:
      'Configurazione JSON per le credenziali e impostazioni di invio email dalla piattaforma. Esempio: {"host": "smtp.gmail.com", "port": 587, "secure": false, "auth": {"user": "email@example.com", "pass": "password"}}',
    admElencoEmailCCReport: 'Elenco Email in CC a report (separati da virgola)',
    admElencoEmailCCReportDesc: 'Lista email in copia per i report (separate da virgola)',
    admDominioEmailOperatore: 'Dominio email operatori',
    admDominioEmailOperatoreDesc:
      'Dominio fisso (es. bcdtravel.it) delle email operatore nelle segnalazioni. Vuoto: email completa.',
    admEstrapolazioneCampi1a10: 'Abilitazione estrapolazione AI campi 1 a 10',
    admEstrapolazioneCampi1a10Desc: "Abilita l'estrapolazione AI per i campi 1-10",
    admFlussoRichiestaInfoGeneriche: 'Abilitazione flusso richiesta informazioni generiche',
    admFlussoRichiestaInfoGenericheDesc: 'Abilita il flusso richiesta informazioni generiche',
    admGestioneAuto: 'Abilitazione gestione auto',
    admGestioneAutoDesc: 'Abilita la gestione delle auto a noleggio.',
    admGestioneGruppiPasseggeri: 'Abilitazione gestione gruppi passeggeri',
    admGestioneGruppiPasseggeriDesc: 'Abilita la gestione dei gruppi di passeggeri.',
    admGoogleApiKey: 'Google API Key',
    admGoogleApiKeyDesc: 'Chiave API per i servizi Google',
    admInviaNotificaFormDati: 'Invia notifica di completamento form dati',
    admInviaNotificaFormDatiDesc: 'Invia notifica di completamento form dati',
    admInvioEmailRiassuntivoOperatore: 'Abilitazione invio email riassuntivo operatore',
    admInvioEmailRiassuntivoOperatoreDesc: "Abilita l'invio di email riassuntive agli operatori",
    admLetturaAllegatiEmail: 'Abilitazione della lettura degli allegati email',
    admLetturaAllegatiEmailDesc: 'Abilita la lettura degli allegati email',
    admLetturaOggettoEmail: 'Abilitazione lettura oggetto email',
    admLetturaOggettoEmailDesc:
      "Abilita la lettura e l'analisi dell'oggetto dell'email e l'eventuale merge con i dati estratti dal corpo del messaggio.",
    admLetturaStoricoViaggiatore: 'Abilitazione lettura dello storico del profilo viaggiatore',
    admLetturaStoricoViaggiatoreDesc: 'Abilita la lettura dello storico del profilo viaggiatore',
    admNomeDbB4B: 'Nome DB B4B',
    admNomeDbB4BDesc: 'Nome del database B4B',
    admNomeDbDinamico: 'Nome DB Dinamico',
    admNomeDbDinamicoDesc: 'Nome del database Dinamico',
    admNomeDesc: 'Nome identificativo della società',
    admNumeroMassimoMessaggiAI: 'Numero massimo messaggi AI',
    admNumeroMassimoMessaggiAIDesc: 'Numero massimo di messaggi AI consentiti (default: 5)',
    admPasswordB4B: 'Password B4B',
    admPasswordB4BDesc: 'Password per il database B4B (password criptata con script esterno)',
    admPasswordDbDinamico: 'Password DB Dinamico',
    admPasswordDbDinamicoDesc:
      'Password per il database Dinamico (password criptata con script esterno)',
    admPasswordJavaWsDinamico: 'Password Java WS Dinamico',
    admPasswordJavaWsDinamicoDesc: 'Password per DynJavaWS (password criptata con script esterno)',
    admPasswordWS: 'Password WS',
    admPasswordWSDesc:
      "Password per l'autenticazione ai web services (password criptata con script esterno)",
    admPortaB4B: 'Porta B4B',
    admPortaB4BDesc: 'Porta del database B4B',
    admPortaDbDinamico: 'Porta DB Dinamico',
    admPortaDbDinamicoDesc: 'Porta del database Dinamico',
    admPresaInCarico: 'Abilitazione "presa in carico"',
    admPresaInCaricoDesc: 'Abilita la funzionalità di poter prendere in carico una conversazione',
    admPuliziaPPI: 'Abilitazione pulizia PPI',
    admPuliziaPPIDesc: 'Abilita la pulizia delle informazioni personali identificabili (PPI).',
    admResocontoOperatore: 'Abilitazione resoconto operatore',
    admResocontoOperatoreDesc:
      "Abilita la creazione del resoconto della trasferta da inviare all'operatore in caso positivo e in caso di errore.",
    admSaltoRicercaTreni: 'Salto ricerca treni su dinamico',
    admSaltoRicercaTreniDesc: 'Salta la ricerca treni su dinamico',
    admSanitizzazioneEmailSenzaAI: 'Abilitazione sanitizzazione email senza AI',
    admSanitizzazioneEmailSenzaAIDesc: "Abilita la sanitizzazione dell'email senza usare AI",
    admTargetPacchettoDinamico: 'Target Pacchetto Dinamico',
    admTargetPacchettoDinamicoDesc: 'Target del pacchetto dinamico (Test/Production)',
    admTelefonoWhatsapp: 'Telefono Whatsapp',
    admTelefonoWhatsappDesc: 'Numero di telefono per WhatsApp',
    admTeamsIdUtente: 'ID Teams',
    admTeamsIdCanale: 'Teams - ID canale',
    admTeamsIdCanaleDesc:
      'ID del canale Teams collegato a Nora (formato 19:...@thread.tacv2). Identifica questa società quando arriva un messaggio: si ricava da Teams con "Ottieni collegamento al canale", decodificando %3A in ":" e %40 in "@".',
    admTeamsIdTeam: 'Teams - ID team',
    admTeamsIdTeamDesc:
      'ID del team che contiene il canale (parametro groupId del collegamento al canale). Serve per pubblicare la risposta di Nora.',
    admTeamsCodCliente: 'Teams - Codice cliente',
    admTeamsCodClienteDesc:
      "Codice cliente dell'azienda proprietaria del canale. Permette di riconoscere da solo un viaggiatore che scrive per la prima volta, cercandone il profilo su Atlante. Se vuoto, ogni viaggiatore va abilitato a mano compilando il suo ID Teams sulla scheda viaggiatore.",
    admTeamsSecretWebhook: 'Teams - Token webhook in uscita',
    admTeamsSecretWebhookDesc:
      "Token di sicurezza generato da Teams alla creazione dell'Outgoing Webhook, usato per verificare che i messaggi arrivino davvero da Teams. Inserirlo cifrato come la password WS di Atlante.",
    admTeamsUrlFlowRisposta: 'Teams - URL flusso di risposta',
    admTeamsUrlFlowRispostaDesc:
      'URL del flusso Power Automate che pubblica la risposta di Nora nel thread del canale. Inserirlo cifrato come la password WS di Atlante.',
    admUrlAtlante: 'Url Atlante',
    admUrlAtlanteDesc: 'URL del servizio Atlante per le prenotazioni',
    admUrlB4B: 'Url B4B',
    admUrlB4BDesc: 'URL del database B4B',
    admUrlDbDinamico: 'Url DB Dinamico',
    admUrlDbDinamicoDesc: 'URL del database Dinamico',
    admUrlDinamicoPhp: 'Url Dinamico PHP',
    admUrlDinamicoPhpDesc: 'URL del servizio PHP Dinamico',
    admUrlJavaWsDinamico: 'Url Java WS Dinamico',
    admUrlJavaWsDinamicoDesc: 'URL del servizio Java WS Dinamico',
    admUtenteB4B: 'Utente B4B',
    admUtenteB4BDesc: 'Username per il database B4B',
    admUtenteDbDinamico: 'Utente DB Dinamico',
    admUtenteDbDinamicoDesc: 'Username per il database Dinamico',
    admUtenteJavaWsDinamico: 'Utente Java WS Dinamico',
    admUtenteJavaWsDinamicoDesc: 'Username per REST Java Dinamico',
    admUtenteWS: 'Utente WS',
    admUtenteWSDesc: "Username per l'autenticazione ai web services",
    admVisualizzaBottoneReport: 'Visualizza bottone report',
    admVisualizzaBottoneReportDesc: 'Mostra il bottone per i report',
    cerca: 'Cerca...',
    conversazioni: 'Conversazioni',
    cpCompilatoDaNora: 'compilato da Nora',
    data: 'Data',
    errAeroportoIATAnotFound: 'IATA Aeroporto non trovato',
    errAttachmentsInEmail: 'Allegati interni in email',
    errCanceled: 'Cancellate da operatore',
    errCarnetError: 'Errore ricerca carnet',
    errDefault: 'Altro',
    errDepartureCarJsonNotFound: 'Dati partenza/arrivo auto non trovati',
    errDestinationHotelNotFound: 'Destinazione hotel non trovata',
    errDuplicazioneProfiloTrovato: 'Duplicazione profilo trovato',
    errEmailMancanteProfiloViaggiatore: 'Email mancante profilo viaggiatore',
    errErroreCreazionePreventivi: 'Errore creazione preventivi',
    errErroreCreazioneServizi: 'Errore creazione servizi',
    errErroreCreazioneTrasferta: 'Errore creazione trasferta',
    errErroreElaborazioneServizi: 'Errore elaborazione servizi',
    errErroreRicercaDinamico: 'Errore ricerca dinamico',
    errErroreRicercaDinamicoVuoto: 'Nessun risultato ricerca servizi',
    errErrorSavingAttachments: 'Errore salvataggio allegati',
    errGenericError: 'Errore generico',
    errLoopError: 'Errore di loop',
    errMaxAIMessagesReachedInGC: 'Contenuto generico (non trasferta)',
    errMoreThanOneTransfer: 'Più di una trasferta trovata',
    errNessunProfiloTrovato: 'Nessun profilo trovato',
    errNessunProfiloTrovatoTA: 'TA mancante sul viaggiatore',
    errNoAirportFound: 'Aeroporto non trovato',
    errNoFinalizzazioneCorretta: 'Finalizzazione non avvenuta',
    errNoKeyServizioGenerato: 'Chiave servizio mancante',
    errNoNoraTransfer: 'Trasferta non creata da Nora',
    errNonTrovatoRiferimentoServizioSuMidOffice: 'Riferimento servizio non trovato su mid office',
    errNoProfileInfoTrovato: 'Profilo non trovato',
    errNoTransferFound: 'Nessuna trasferta trovata',
    errOutOfOffice: 'Out of office',
    errPasseggeriMultipli: 'Passeggeri multipli',
    errProfiloMittenteNonTA: 'Profilo mittente non Travel Arranger',
    errProfiloNoPresenteSuGDS: 'Profilo non presente su GDS',
    errRichiestaAggiornamentoTrasferta: 'Ric. aggiornamento trasferta',
    errRichiestaModificaOCancellazioneTrasferta: 'Ric. mod./canc. trasferta',
    errSollecito: 'Sollecito',
    errTooManyDaysHotel: 'Soggiorno hotel troppo lungo',
    errTooManyMessages: 'Limite messaggi raggiunto',
    errTooMuchServiceBoth: 'Troppi servizi treno e aereo',
    errTooMuchServicePlane: 'Troppi servizi aereo',
    errTooMuchServiceTrain: 'Troppi servizi treno',
    gfDi: 'di',
    gfNumerico: 'numerico',
    gfReturnLeg: 'Ritorno',
    gfSeleziona: 'Seleziona',
    gfSelezionaData: 'Seleziona data',
    gfServizioCopertoDaCarnet: 'Servizio coperto da CARNET',
    gfTransferDepartureDate: 'Data di partenza',
    gfTransferDeparturePlace: 'Luogo di partenza',
    gfTransferDestinationPlace: 'Luogo di destinazione',
    gfTransferNumPax: 'Numero passeggeri',
    gfTransferReturnDate: 'Data di ritorno',
    mcApri: 'apri',
    mcAutotestAggiornato: 'Autotest aggiornato',
    mcConversazioneIniziataIl: 'Conversazione iniziata il',
    mcCopiatoNegliAppunti: 'Copiato negli appunti',
    mcCredenzialiErrate: 'Credenziali errate',
    mcDebug: 'Debug',
    mcErroreImprevisto: 'Spiacenti, si è verificato un errore imprevisto.',
    mcFilenameLabel: 'filename',
    mcMe: 'Io',
    mcNameLabel: 'name',
    mcOggetto: 'Oggetto',
    mcOoops: 'Ooops!',
    mcPayloadCopiato: 'Il payload copiato negli appunti',
    mcRichiestaViaggio: 'Richiesta viaggio',
    mcScriviMessaggio: 'Scrivi un messaggio...',
    mcTestNonTrovato: 'Test non trovato',
    mxErroreImportazioneViaggiatori: "Errore durante l'importazione dei viaggiatori",
    mxGestisciNoraAI: 'Gestisci Nora AI',
    mxTitoloPanelOperations: 'Panel Operations',
    mxTrovati: 'Trovati',
    mxViaggiatori: 'viaggiatori',
    pfCanale: 'canale',
    pfCosto: 'Costo',
    pfDatiCacheProcessOverview:
      'Dati da tabella cache processOverviewHourly (allineata alle conversazioni nel periodo).',
    pfFinalState: 'Stato finale',
    pfInitialState: 'Stato iniziale',
    pfMediaBin: 'Media/bin',
    pfOrdinateDecrescente: 'ordinate decrescente',
    pfProcessi: 'Processi',
    pfScatterCacheHint:
      'Punti da tabella cache processOverviewHourly (campioni per ora). Clicca per aprire il processo.',
    pfScatterCacheHintLong:
      'Punti da tabella cache processOverviewHourly (campioni per ora, max 5000 punti totali). Clicca per aprire il processo.',
    pfStato: 'Stato',
    pfStep: 'step',
    pfTokenRichieste: 'Token/Richieste',
    pfTotaleCache: 'Totale (cache)',
    pfUnitSelezionate: 'unit selezionate',
    stCosto: 'Costo',
    tdAereo: 'Aereo',
    tdAeroportoArrivo: 'Aeroporto arrivo',
    tdAeroportoArrivoNonValido: 'Aeroporto di arrivo non valido',
    tdAeroportoPartenza: 'Aeroporto partenza',
    tdAeroportoPartenzaNonValido: 'Aeroporto di partenza non valido',
    tdAnteprimaRisultatiDinamico: 'Anteprima risultati dinamico',
    tdArrivo: 'Arrivo',
    tdCamera: 'Camera',
    tdCerca: 'Cerca',
    tdCitta: 'Città',
    tdCittaNonValida: 'Città non valida',
    tdClasse: 'Classe',
    tdCompagnia: 'Compagnia',
    tdCoordinate: 'Coordinate',
    tdDataArrivo: 'Data Arrivo',
    tdDataCancellazione: 'Data Cancellazione',
    tdDataCheckIn: 'Data Check In',
    tdDataCheckOut: 'Data Check Out',
    tdDataPartenza: 'Data Partenza',
    tdDistanza: 'Distanza',
    tdDurata: 'Durata',
    tdEchoToken: 'Echo Token',
    tdFormatoDataOraNonValido: 'Formato date/ora non valido',
    tdFormatoDateNonValido: 'Formato date non valido',
    tdHotel: 'Hotel',
    tdIdCommunity: 'Id Community',
    tdIndirizzo: 'Indirizzo',
    tdKgBagaglio: 'Kg Bagaglio',
    tdLat: 'Lat',
    tdLatitudine: 'Latitudine',
    tdLng: 'Lng',
    tdLongitudine: 'Longitudine',
    tdMetri: 'metri',
    tdMiniRules: 'Mini Rules',
    tdOraArrivo: 'Ora Arrivo',
    tdOraPartenza: 'Ora Partenza',
    tdPartenza: 'Partenza',
    tdPreferenzaPosto: 'Preferenza posto',
    tdPrezzo: 'Prezzo',
    tdPrezzoAncillary: 'Prezzo + Ancillary',
    tdRisultati: 'risultati',
    tdServiziAggiuntivi: 'Servizi aggiuntivi',
    tdSottotitoloAnteprima: 'Visualizza i risultati grezzi restituiti dal motore di ricerca',
    tdStazioneArrivo: 'Stazione Arrivo',
    tdStazioneArrivoNonValida: 'Stazione di arrivo non valida',
    tdStazionePartenza: 'Stazione Partenza',
    tdStazionePartenzaNonValida: 'Stazione di partenza non valida',
    tdTariffa: 'Tariffa',
    tdTipo: 'Tipo',
    tdTipoRicerca: 'Tipo Ricerca',
    tdTratta: 'Tratta',
    tdTrattamento: 'Trattamento',
    tdTrattaN: 'Tratta N°',
    tdTreno: 'Treno',
    tdTypeRoom: 'TypeRoom',
    abilitaMessaggiFirmati: 'Abilita messaggi firmati con nome Nora',
    abilitaMessaggiFirmatiDescrizione:
      "Se attivato, i messaggi inviati all'utente saranno firmati con il nome 'Nora' per garantire un'esperienza più personalizzata.",
    abilitaMessaggioFinale: 'Abilita invio di un messaggio finale al richiedente della trasferta',
    abilitaMessaggioFinaleDescrizione:
      'Se attivato, viene inviato un messaggio informativo al richiedente della trasferta al termine della procedura. (testuale o con il link in caso di preventivi generati automaticamente)',
    abilitato: 'Abilitato',
    abilitazioneStepAvanzamento: 'Abilitazione step di avanzamento:',
    active: 'Attivo',
    aggiungiFarreTreno: 'Aggiungi tariffa',
    aggiungiInformazioniMeteo: 'Aggiungi le informazioni meteo al messaggio',
    aggiungiInformazioniMeteoDescrizione:
      'Se attivato, il messaggio includerà le previsioni meteo relative al periodo della trasferta, fornendo dettagli utili per la pianificazione.',
    aggiungiServizio: 'Aggiungi Servizio',
    aereo: 'Aereo',
    aic: 'AIC',
    adminCoefficients: 'Admin Coefficienti',
    annulla: 'Annulla',
    attachmentsInEmail: "Allegati nell'email",
    auto: 'Auto',
    autoTest: 'Test Automatico',
    azioni: 'Azioni',
    bestBuy: 'Best buy',
    cancellata: 'Cancellata',
    caricamento: 'Caricamento...',
    chat: 'Chat',
    chooseClientGroupClient: 'Cliente',
    chooseClientGroupDefault: 'Seleziona una voce...',
    chooseClientGroupGroup: 'Gruppo',
    clickToPreviewMessage:
      'Clicca "Anteprima messaggio" per visualizzare il corpo in una nuova finestra',
    codice: 'Codice',
    codiceCliente: 'Codice Cliente',
    codiceGruppo: 'Codice Gruppo',
    communityPanel: 'Pannello Community',
    communityPresetsList: 'Lista Community Preset',
    compagniaTreno: 'Compagnia Treno',
    compilareCampiObbligatori: 'Compilare tutti i campi obbligatori',
    conferma: 'Conferma',
    confermaInvio: 'Conferma Invio',
    conto: 'Conto',
    controllaPreventivi: 'Controlla preventivi',
    controllaPreventiviDescrizione:
      "Se attivo, i preventivi non vengono inviati al viaggiatore, ma vengono creati nello stato 'in lavorazione' per essere visionati",
    conversations: 'Conversazioni',
    createNew: 'Crea Nuovo',
    creationDate: 'Data creazione',
    creato: 'Creato',
    creazionePreventivo: 'Creazione preventivo',
    creazioneTrasfertaServizi: 'Creazione trasferta e servizi',
    currentIsola: 'Isola corrente',
    datiTrasferta: 'Dati trasferta',
    datiViaggiatore: 'Dati Viaggiatore',
    defaultPreset: 'Default Preset',
    deleteDefaultPresetError: 'Impossibile eliminare il preset di default',
    deleteServiceHeader: 'Cancellazione Servizio',
    deleteServiceLabel: 'Vuoi cancellare questo servizio?',
    deleteSuccess: 'Eliminazione effettuata',
    descrizione: 'Descrizione',
    distance: 'Distanza',
    duplicazioneProfiloTrovato: 'Duplicazione profilo viaggiatore, trovata omonimia',
    duration: 'Durata',
    dynamicTest: 'Test Dinamico',
    elaborazioneMessaggioInCorso: 'Elaborazione messaggio in corso',
    elaborazioneMessaggioInCorsoDetails:
      'Elaborazione messaggio in corso... attendere il completamento.',
    error: 'Errore',
    errore: 'Errore',
    escludiNora: 'Escludi Nora',
    formale: 'Formale',
    formaleDefault: 'formale (default)',
    gestireDaMidoffice: 'Gestire da Midoffice',
    gestireManualmente: 'Gestire manualmente da Midoffice',
    gestisciNoraAI: 'Gestisci Nora AI',
    gruppo: 'Gruppo',
    hotel: 'Hotel',
    hotelAutomatico: 'Hotel automatico',
    hotelAutomaticoDescrizione:
      "Nel caso in cui la trasferta duri più giorni, viene aggiunto in automatico l'hotel.",
    id: 'Id',
    identificativoAnno: 'Identificativo Anno',
    identificativoPratica: 'Identificativo Pratica',
    identificativoRichiesta: 'Identificativo Richiesta',
    ignorata: 'Ignorata',
    impostazionePreventiviGenerati: 'Impostazione preventivi generati',
    impostazioni: 'Impostazioni',
    impostazioniSistema: 'Impostazioni Sistema',
    salvataggioEffettuato: 'Salvataggio effettuato',
    stateDiffDescrizione:
      'Se attivo, le nuove conversazioni utilizzeranno il formato State Diff per lo storico dei processi. Le conversazioni esistenti non vengono modificate.',
    nessunRecordSistema: 'Nessun record system trovato nel database.',
    inAttesaDiConferma: 'In attesa di conferma',
    inEsecuzione: 'In esecuzione',
    inactive: 'Disattivo',
    indicateFormalityLevel: 'Indicare livello di formalità',
    indietro: 'Indietro',
    informale: 'Informale',
    inserireDatiViaggiatore: 'Inserire i dati del viaggiatore',
    logicaCameraNonInPenale: 'Logica camera non in penale',
    logicaCameraNonInPenaleDescrizione1:
      "Se l'hotel è soggetto a penale, verrà cercata la disponibilità della prima camera non soggetta a penale dello stesso hotel.",
    logicaCameraNonInPenaleDescrizione2:
      "Nel caso in cui questa non sia disponibile, verrà selezionata la camera 'best buy'.",
    login: 'Login',
    logout: 'Logout',
    mastro: 'Mastro',
    messaggioLink: "All'interno del messaggio dove compare:",
    messaggioLinkPreventivi: "- '#link': verrà inserito il link per visualizzare i preventivi",
    messaggioMeteo:
      '- \'#meteo\': verranno inserite le informazioni sul meteo (se richiesta viaggio è entro 5 gg dalla partenza). Per far visualizzare la frase è necessario abilitare il flag "Inclusione informazioni meteo"',
    messaggioPreimpostatoUtente: 'Messaggio preimpostato per utente',
    messaggioPreimpostatoUtenteDescrizione:
      'Se selezionato verrà notificato il viaggiatore che la sua richiesta è presa in carico da un operatore reale.',
    messaggioPreventivi: 'Messaggio per preventivi:',
    messaggioReindirizzamentoOperatore: 'Messaggio per reindirizzamento operatore:',
    messaggioReindirizzamentoOperatoreDescrizione:
      "Messaggio preimpostato da inviare all'utente in caso di reindirizzamento all'operatore",
    modificaViaggiatore: 'Modifica viaggiatore',
    moltoFormale: 'Molto formale',
    nProposte: 'N. Proposte',
    nessunProfiloTrovato: 'Profilo non trovato',
    nessunProfiloTrovatoTA: 'Legame viaggiatore e TA non trovato',
    profiloMittenteNonTA: 'Profilo mittente non Travel Arranger',
    nessunServizioInserito: 'Nessun servizio inserito',
    nessunServizioTrenoInserito: 'Nessun servizio treno inserito',
    nessunServizioHotelInserito: 'Nessun servizio hotel inserito',
    nessunServizioAereoInserito: 'Nessun servizio aereo inserito',
    nessunServizioAutoInserito: 'Nessun servizio auto inserito',
    servizioEmptyHint: 'Aggiungilo solo se richiesto in conversazione',
    no: 'No',
    noConversationsFound: 'Nessuna conversazione trovata',
    noPresetFound: 'Nessun preset trovato',
    noProfileInfoTrovato: 'Profilo viaggiatore non trovato',
    noraEsclusa: 'Nora Esclusa',
    operations: 'Operazioni',
    operatoreCreazionePratica: 'Operatore creazione pratica',
    outOfOffice: 'Out of office',
    sollecito: 'Sollecito',
    maxAIMessagesReachedInGC: 'Contenuto generico (non trasferta)',
    panelOperations: 'Pannello operazioni',
    performanceMonitor: 'Performance Monitor',
    passeggeriMultipli: 'Passeggeri multipli identificati',
    pocoFormale: 'poco formale',
    prendiInCarico: 'Prendi in carico',
    presetAbilitato: 'Preset abilitato',
    previewMessage: 'Anteprima messaggio',
    price: 'Prezzo',
    processes: 'Processi',
    prontoARipartire: 'In esecuzione',
    pubblicaLoStesso: 'Pubblica lo stesso',
    pubblicaLoStessoDescrizione:
      'Se non vengono trovati risultati in uno dei servizi richiesti, i preventivi vengono comunque pubblicati',
    raccoltaInformazioni: 'Raccolta informazioni',
    ragioneSociale: 'Ragione Sociale',
    requester: 'Richiedente',
    ricercaCliente: 'Ricerca cliente',
    ricercaGruppo: 'Ricerca gruppo',
    ricercaPer: 'Ricerca per',
    richiediMezzoTrasporto: 'Richiedi il mezzo di trasporto se non specificato',
    richiediMezzoTrasportoDescrizione:
      "Se attivato, verrà chiesto all'utente se desidera un servizio aereo o ferroviario per raggiungere la destinazione nel caso in cui non sia già stato indicato.",
    richiestaModificaOCancellazioneTrasferta: 'Richiesta modifica o cancellazione trasferta',
    richiestaAggiornamentoTrasferta: 'Richiesta aggiornamento informazioni trasferta',
    salva: 'Salva',
    selectEmail: 'Seleziona Email',
    selectEmailRedirect: 'Seleziona Email Redirect To Operator',
    selectEnvironment: 'Seleziona Environment',
    selectEnvironmentPlaceholder: 'Seleziona Environment',
    selectFormalityLevel: 'Seleziona livello di formalità',
    selectPID: 'Seleziona PID',
    selectUnit: 'Seleziona unit da eseguire',
    selectUnitToExecute: 'Seleziona unit da eseguire',
    selectedDate: 'Data selezionata',
    seleziona: 'Seleziona',
    selezionaPrioritaServizio: 'Seleziona la priorità del servizio',
    selezionaPrioritaTariffa: 'Seleziona la priorità della tariffa treno',
    selezionaRicerca: 'Seleziona ricerca',
    tariffeRimborsabili: 'Tariffe Rimborsabili',
    tariffeNonRimborsabili: 'Tariffe Non Rimborsabili',
    selezionato: 'Selezionato',
    serviziAereo: 'Servizi Aereo',
    serviziAuto: 'Servizi Auto',
    serviziHotel: 'Servizi Hotel',
    serviziTreno: 'Servizi Treno',
    servizio: 'Servizio',
    societyList: 'Elenco Società',
    soloCamereNonInPenale: 'Solo camere non in penale',
    soloCamereNonInPenaleDescrizione:
      "Nel caso in cui non si trovino camere non soggette a penale in un determinato hotel, passare all'hotel successivo e ripetere fino a 10 tentativi.",
    sottoConto: 'Sotto Conto',
    state: 'Stato',
    stepNascostoB4B:
      "Questo step è selezionato ma l'integrazione B4B è disattivata. Seleziona un altro step o riattiva il B4B.",
    statistics: 'Statistiche',
    success: 'Success',
    terminato: 'Terminato',
    time: 'Orario',
    tipo: 'Tipo',
    tipologiaTariffa: 'Tipologia Tariffa',
    titolo: 'Titolo',
    titoloPreset: 'Titolo Preset',
    tolleranzaGiorniPenale: 'Tolleranza Giorni Penale',
    tonoEmail: 'Tono email:',
    tornaIndietro: 'Torna Indietro',
    trasfertaCreata: 'Trasferta creata',
    travellersList: 'Elenco Viaggiatori',
    treno: 'Treno',
    usaPresetDefault: 'Usa preset come default',
    userList: 'Elenco Utenti',
    users: 'Utenti',
    verificaConfermaDatiIA: "Verifica e conferma i dati generati dall'IA",
    verificaConfermaDatiIADescrizione:
      "Dopo la raccolta dei dati, l'operatore dovrà controllare e confermare le informazioni inserite dall'intelligenza artificiale nella sezione 'Form Operatore'",
    vuoiConfermareDati: 'Vuoi confermare i dati?',
    gfRifaiRicerca: 'Rifai la ricerca',
    gfRifaiRicercaTitolo: 'Rifare la ricerca?',
    gfRifaiRicercaConferma:
      'Verrà fatta una nuova ricerca con i dati del form e il viaggiatore riceverà un nuovo preventivo. Vuoi continuare?',
    vuoiPrendereInCarico: 'Vuoi prendere in carico la conversazione?',
    gfAttendiCompletamentoTrasferta: 'Attendi il completamento per modificare la trasferta',
    gfAvviata: 'Avviata',
    gfCampi: 'campi',
    gfCampiDaCompilare: 'da compilare',
    gfCampiDaRivedere: 'da rivedere',
    gfCampiObbligatoriDaCompilare: 'obbligatori da compilare',
    gfCampiObbligatoriMancanti: 'CAMPI OBBLIGATORI MANCANTI',
    gfCampiPersonalizzati: 'Campi personalizzati',
    gfSezioneBloccataAgentica:
      'Conversazione agentica: questa sezione non è gestita dal form operatore. I dati non si salvano da qui.',
    gfCampo: 'campo',
    gfCampoObbligatorio: 'Campo obbligatorio',
    gfCampoObbligatorioMancante: 'CAMPO OBBLIGATORIO MANCANTE',
    gfCaricamentoProfilo: 'Caricamento profilo',
    gfCaricamentoProfiloDettaglio: 'Attendi mentre recupero i dati del viaggiatore selezionato…',
    gfCerca: 'Cerca',
    gfChiudiAnteprima: 'Chiudi anteprima',
    gfAllegati: 'Allegati',
    gfAllegatoFile: 'File',
    gfAllegatiNelCorpoEmail:
      'Immagini nel corpo email (di solito visibili anche inline nel messaggio sopra)',
    gfInCorpoEmail: 'corpo email',
    gfChatComposerPlaceholder: 'Scrivi un messaggio… Invio per inviare, Maiusc+Invio per a capo',
    gfChatSend: 'Invia messaggio',
    gfAudio: 'Audio',
    gfComprimi: 'Comprimi',
    gfContieneErrori: 'contiene errori',
    gfContieneErroriTitle: 'Contiene errori',
    gfConversazioneNonTrovata: 'Conversazione non trovata',
    gfDaRivedere: 'Da rivedere',
    gfEspandi: 'Espandi',
    gfImmagine: 'Immagine',
    gfLetto: 'letto',
    gfConversazione: 'Conversazione',
    gfConversazioneConNora: 'Conversazione con Nora',
    gfConversazionePrecedente: 'Conversazione precedente',
    gfConversazioneSuccessiva: 'Conversazione successiva',
    gfConv: 'Conv.',
    gfCreaTest: 'Crea test',
    gfDa: 'da',
    gfDeleteServiceLabelIrreversible:
      "Vuoi cancellare questo servizio? L'operazione non può essere annullata.",
    gfEliminaServizio: 'Elimina servizio',
    gfElaborazioneInCorso: 'Elaborazione in corso',
    gfErroreAggiornamentoState: 'Errore aggiornamento state',
    gfErroreCaricamentoViaggiatore: 'Errore durante il caricamento del viaggiatore',
    gfErroreConfermaForm: 'Errore conferma form',
    gfRispostaOperatore: 'Risposta di un operatore',
    gfErroreCreazioneTest: 'Si è verificato un errore durante la creazione del test',
    gfErroreInvioSegnalazione: "Errore durante l'invio della segnalazione",
    gfErroreRicercaViaggiatore: 'Errore durante la ricerca del viaggiatore',
    gfEsclusioneNora: 'Esclusione nora',
    gfEscludiNoraSub: 'I prossimi messaggi dovranno essere gestiti solamente da middle office.',
    gfFiltrato: 'Filtrato',
    gfFormInviatoSuccesso: 'Form inviato con successo',
    gfHaPrecompilato: 'ha precompilato',
    gfHintRicercaViaggiatore: 'Inserisci nome e cognome e/o email per effettuare la ricerca',
    gfInvia: 'Invia',
    gfInviaSegnalazione: 'Invia segnalazione',
    gfModificaTrasferta: 'Modifica trasferta',
    gfMostraTutteSezioni: 'Mostra tutte le sezioni',
    gfMostraSoloSezioniDaRivedere: 'Mostra solo sezioni con campi da rivedere',
    gfNessunViaggiatoreTrovato: 'Nessun viaggiatore trovato',
    gfNessunViaggiatoreTrovatoHint: 'Prova a modificare nome, cognome o email e ripeti la ricerca.',
    gfNoteSegnalazione: 'Note segnalazione',
    gfEmailOperatoreSegnalazione: 'La tua email',
    gfEmailOperatoreSegnalazioneHint:
      'Useremo questo indirizzo per risponderti. Lo ricorderemo per le prossime segnalazioni.',
    gfEmailOperatoreSegnalazioneNonValida: 'Inserisci un indirizzo email valido',
    gfNuovaTrasferta: 'Nuova trasferta',
    gfNuovaConversazione: 'Nuova conversazione',
    gfOperazioneSuccesso: 'Operazione avvenuta con successo',
    gfPerCreareTrasferta: 'per creare la trasferta',
    gfPerModificareConversazione: 'Per modificare la conversazione prendila in carico',
    gfProntaDaCreare: 'Pronta da creare',
    gfProcessi: 'Processi',
    gfPulisciCampi: 'Pulisci campi',
    gfRicercaInCorso: 'Ricerca in corso',
    gfRicercaInCorsoDettaglio: 'Sto cercando i profili corrispondenti ai criteri inseriti…',
    gfRicercaPuntini: 'Ricerca…',
    gfRicercaViaggiatore: 'RICERCA VIAGGIATORE',
    gfRimuovi: 'Rimuovi',
    gfRimuoviServizio: 'Rimuovi servizio',
    gfRisultatoTrovato: 'risultato trovato',
    gfRisultatiTrovati: 'risultati trovati',
    gfRisolviErroriIn: 'Risolvi gli errori in',
    gfSalvaBozza: 'Salva bozza',
    gfSelezionaViaggiatore: 'Seleziona un viaggiatore',
    gfSegnalazioneInviata: 'Segnalazione inviata',
    gfSegnalazioneInviataSuccesso: 'La segnalazione è stata inviata con successo',
    gfSezioniForm: 'Sezioni del form',
    gfServizio: 'servizio',
    gfServizi: 'servizi',
    gfVuoto: 'Vuoto',
    gfSolaLettura: 'sola lettura',
    gfSoloDaRivedere: 'Solo da rivedere',
    gfStateAggiornatoSuccesso: 'State aggiornato con successo',
    gfTestCreato: 'Test creato',
    gfTestCreatoSuccesso: 'Il test è stato creato con successo',
    gfTrasferta: 'Trasferta',
    gfTuttiCampiObbligatoriCompilati: 'Tutti i campi obbligatori sono compilati.',
    gfVaiAProcessi: 'Vai a processi',
    gfViaggiatore: 'Viaggiatore',
    gfVuoiEscludereNora: 'Vuoi escludere Nora dalla conversazione?',
    // Login
    loginTitle: 'Accedi al Sistema',
    loginButton: 'Accedi',
    poweredBy: 'Powered by',
    // Admin lists
    societyListTitle: 'Lista Società',
    societyCode: 'Codice Società',
    societyNameCol: 'Nome società',
    urlAtlante: 'Url Atlante',
    noSocietyFound: 'Nessuna società trovata',
    deleteSocietyHeader: 'Cancellazione Società',
    deleteSocietyMessage: 'Vuoi cancellare questa società?',
    userListTitle: 'Lista Utenti',
    noUserFound: 'Nessun utente trovato',
    deleteUserHeader: 'Cancellazione Utente',
    deleteUserMessage: 'Vuoi cancellare questo utente?',
    travellersListTitle: 'Lista Viaggiatori',
    noTravellerFound: 'Nessun viaggiatore trovato',
    deleteTravellerHeader: 'Cancellazione Viaggiatore',
    deleteTravellerMessage: 'Vuoi cancellare questo viaggiatore?',
    importTravellers: 'Importa viaggiatori',
    phone: 'Telefono',
    client: 'Cliente',
    // Process
    processListTitle: 'Lista Processi',
    agentTurnsTitle: 'Turni agente',
    agentIntent: 'Intento',
    agentFirstToken: 'Primo riscontro',
    agentTurnsToQuote: 'Turni al preventivo',
    quoteSolutions: 'Soluzioni proposte',
    agentTurnDetail: 'Dettaglio della run',
    agentNoSteps: 'Nessun passo registrato',
    agentProviderError: 'Guasto del provider',
    agentProviderAirports: 'Aeroporti non risolti (TravelCore): non è un «nessun volo»',
    agentProviderDinamico: 'Il Dinamico non ha risposto in tempo',
    agentProviderUnknown: 'Servizio esterno non disponibile',
    agentLimitations: 'Limiti del piano',
    agentTrace: 'Traccia del turno',
    agentTraceUser: 'Messaggio del viaggiatore',
    agentTraceReply: 'Risposta di Nora',
    agentTraceInput: 'Input',
    agentTraceOutput: 'Output',
    agentTraceNotRecorded:
      'Input e output non registrati: il turno è precedente al registro completo delle chiamate',
    agentTraceTruncated: 'Output troppo grande: non salvato per intero',
    agentTraceService: 'servizio',
    agentTraceOrigin: 'origine',
    agentTraceWidgets: 'schede',
    agentTraceProviderCalls: 'chiamate ai fornitori',
    agentTraceRetryable: 'ritentabile',
    agentTraceNotRetryable: 'non ritentabile',
    agentTraceNone: 'Nessuna traccia salvata: il turno non ha scritto messaggi',
    agentTraceNoTools: 'Nessun tool chiamato',
    agentTraceEmpty: 'Nessun passo in questo turno',
    agentTracePhase: 'fase interna',
    agentTraceExternal: 'chiamata esterna',
    agentTraceOrderSaved: 'Turno precedente a questa vista: ordine di registrazione, non di tempo',
    agentTraceFromTurn: 'Il turno non ha scritto messaggi: i tool sono quelli salvati nel turno',
    agentTraceSummary: 'Riepilogo del contenuto',
    agentTraceLangfuse: 'Apri la trace su Langfuse',
    agentTraceReads: 'letture',
    agentTraceAttempts: 'tentativi',
    agentTraceOffers: 'offerte',
    agentTraceSolutions: 'soluzioni',
    agentTraceClosed: 'chiusa',
    agentTraceOpen: 'ancora in corso',
    agentTraceOmitted: 'chiamate oltre il tetto, non mostrate',
    quoteConfirmed: 'confermato',
    quoteTotal: 'Totale',
    agentTurnsEmpty: 'Nessun turno agentico per questa conversazione',
    agentTurnsUnavailable: 'Lettura dei turni non riuscita',
    agentTurnTrigger: 'Innesco',
    agentTurnTriggerMessage: 'messaggio',
    agentTurnTriggerAction: 'pulsante',
    agentTurnTriggerWakeup: 'sveglia',
    agentTurnAttempt: '° tentativo',
    agentTurnId: 'Turno',
    agentOutcomeCompleted: 'completato',
    agentOutcomeActionSilent: 'azione silenziosa',
    agentOutcomeTripSwitched: 'viaggio cambiato',
    agentOutcomeTripSwitchWithoutMessage: 'cambio viaggio senza messaggio',
    agentOutcomeCanceled: 'annullato',
    agentOutcomeError: 'errore',
    agentErrorSessionLoadFailed: 'Sessione non caricata',
    agentErrorModelTimeout: 'Il modello non ha risposto in tempo',
    agentErrorModelRateLimited: 'Il modello ha limitato le richieste',
    agentErrorModelUnavailable: 'Il modello non è raggiungibile',
    agentErrorModelRejected: 'Il modello ha rifiutato la richiesta',
    agentErrorModelCallLimit: 'Troppe chiamate al modello',
    agentErrorModelEmptyResponse: 'Il modello non ha scritto nulla',
    agentErrorCommitFailed: 'Salvataggio della risposta non riuscito',
    agentErrorRunError: 'Errore del turno',
    agentErrorToolServiceUnavailable: 'Servizio dei tool non disponibile',
    agentTurn: 'Turno',
    agentOutcome: 'Esito',
    agentModel: 'Modello',
    agentCalls: 'Chiamate',
    agentTokens: 'Token',
    agentCost: 'Costo LLM',
    agentProviderCost: 'Costo provider',
    agentTotalCost: 'Costo totale',
    agentDuration: 'Durata',
    agentQueueState: 'Coda',
    goToForm: 'Vai a form',
    pricing: 'Pricing',
    noProcessFound: 'Nessun processo trovato',
    processId: 'Id Processo',
    openStep: 'Apri step',
    conversation: 'Conversazione',
    messages: 'messaggi',
    readOnly: 'Sola lettura',
    continueExecution: 'Prosegui esecuzione',
    processErrors: 'Errori Processi',
    processStats: 'Statistiche Processo',
    processComparison: 'Confronto Processo',
    // Filters
    filters: 'Filtri',
    date: 'Data',
    island: 'Isola',
    allIslands: 'Tutte le isole',
    allStates: 'Tutti gli stati',
    search: 'Ricerca',
    searchPlaceholder: 'Cerca per nome, email, AIC...',
    searchConversations: 'Ricerca globale conversazioni',
    clearSearch: 'Pulisci ricerca',
    resetFilters: 'Reset filtri',
    removeAllFilters: 'Rimuovi tutti i filtri',
    activeFilterOne: 'attivo',
    activeFilterMany: 'attivi',
    // Conversation actions
    viewDetail: 'Vedi dettaglio conversazione',
    open: 'Apri',
    warningConversationPending: 'Attenzione: conversazione in attesa',
    conversationPending: 'Conversazione in attesa',
    tripsInProgress: 'Lista trasferte in lavorazione',
    // Theme
    switchToLight: 'Passa al tema chiaro',
    switchToDark: 'Passa al tema scuro',
    // Menu
    dashboardPricing: 'Dashboard Pricing',
    prompts: 'Prompts',
    home: 'Home',
    // ActiveFilterChips
    conversationSingular: 'conversazione',
    conversationPlural: 'conversazioni',
    removeFilterDate: 'Rimuovi filtro data',
    removeFilterIsland: 'Rimuovi filtro isola',
    removeFilterState: 'Rimuovi filtro stato',
    removeSearch: 'Rimuovi ricerca',
    // Community alerts
    linkMissing: 'Link mancante',
    linkMissingDetail: "Nel messaggio per preventivi manca '#link'",
    weatherInfoMissing: 'Info meteo mancanti',
    weatherInfoMissingDetail: "Nel messaggio per preventivi manca '#meteo'",
    titleMissing: 'Titolo mancante',
    selectGroupOrClient:
      'Selezionare un gruppo o un cliente oppure selezionare come default preset',
    groupNotFound: 'Gruppo non trovato',
    // Chat
    testChat: 'Chat di test',
    testChatSubtitle: "Esegui un'unit specifica simulando una conversazione completa",
    testParameters: 'Parametri test',
    testConversation: 'Conversazione di test',
    // Debug Console
    dbcTitle: 'Debug Console',
    dbcSubtitle: 'Console completa per testare tutti i flussi, canali e parametri di Nora',
    dbcEnvironment: 'Ambiente & Identità',
    dbcCodSociety: 'Cod. Società',
    dbcTomcatCode: 'Tomcat Code',
    dbcUserEmail: 'Email Utente',
    dbcOperatorEmail: 'Email Operatore',
    dbcExecution: 'Esecuzione',
    dbcCallType: 'Tipo Chiamata',
    dbcUnit: 'Unit / Processo',
    dbcSearchUnit: 'Cerca unit...',
    dbcChannel: 'Canale Comunicazione',
    dbcIsDebug: 'Debug Mode (no DB)',
    dbcPdfQuotes: 'PDF Quotes',
    dbcChannelParams: 'Parametri Canale',
    dbcIdConversazione: 'ID Conversazione BTM',
    dbcCodiceCliente: 'Codice Cliente',
    dbcIsola: 'Isola',
    dbcWhatsappFrom: 'WhatsApp From',
    dbcWhatsappId: 'WhatsApp ID',
    dbcMailRefId: 'ID Conversazione Email',
    dbcMailRefIsola: 'Email Isola',
    dbcMailRefSubject: 'Subject Email',
    dbcSubject: 'Subject',
    dbcBody: 'Body',
    dbcAdvanced: 'Avanzato',
    dbcCustomJson: 'JSON Custom (sovrascrive campi payload)',
    dbcAudioMessage: 'Audio Message',
    dbcShowPreview: 'Mostra Payload Preview',
    dbcPayloadPreview: 'Preview Payload',
    dbcNoResponse: 'Nessuna risposta ancora. Invia un messaggio.',
    dbcSending: 'Invio...',
    dbcCopyJson: 'Copia JSON',
    dbcCopied: 'Copiato',
    dbcCopiedJson: 'JSON copiato negli appunti',
    dbcCopyFailed: 'Impossibile copiare',
    dbcSentPayload: 'Payload Inviato',
    dbcElapsed: 'Tempo risposta',
    dbcTokens: 'Token',
    dbcConvId: 'Conversation ID',
    dbcOpenConversation: 'Apri dettaglio conversazione',
    dbcSteps: 'Process Steps',
    dbcMessageToSend: 'Messaggio generato',
    dbcSelectPreset: 'Seleziona preset...',
    dbcLoad: 'Carica',
    dbcDelete: 'Elimina',
    dbcSave: 'Salva',
    dbcCancel: 'Annulla',
    dbcSavePreset: 'Salva Preset',
    dbcPresetName: 'Nome preset...',
    dbcReset: 'Reset',
    dbcClearChat: 'Svuota Chat',
    dbcPresetLoaded: 'Preset caricato',
    dbcPresetSaved: 'Preset salvato',
    dbcPresetDeleted: 'Preset eliminato',
    campiObbligatori: 'Campi mancanti',
    attenzione: 'Attenzione',
    warning: '⚠️',
    yes: 'Sì',
    // Common
    modifica: 'Modifica',
    elimina: 'Elimina',
    chiudi: 'Chiudi',
    dataInizio: 'Data inizio',
    dataFine: 'Data fine',
    giornoPrecedente: 'Giorno precedente',
    giornoSuccessivo: 'Giorno successivo',
    dataDa: 'Data da',
    dataA: 'Data a',
    periodo: 'Periodo',
    tutti: 'Tutti',
    media: 'Media',
    errori: 'Errori',
    nessunDatoDisponibile: 'Nessun dato disponibile',
    totale: 'Totale',
    processo: 'Processo',
    rimuovi: 'Rimuovi',
    secondi: 'secondi',
    minuti: 'minuti',
    eWord: 'e',
    nonTerminato: 'Non terminato',
    // Gigi FilterBar
    filtraPerDataIsolaStato: 'Filtra per data, isola, stato o ricerca libera',
    // Process/Conversations
    listaConversazioni: 'Lista Conversazioni',
    gestioneConversazioniPerData: 'Gestione conversazioni per data',
    filtraPerData: 'Filtra per data',
    viaggiatore: 'Viaggiatore',
    conversazioneChiusa: 'Conversazione chiusa',
    erroreChiusuraConversazione: 'Errore chiusura conversazione',
    // Process/Editor
    processStepsVisualizer: 'Process Steps Visualizer',
    differenzeStati: 'Differenze Stati',
    statoStep: 'Stato step',
    selezionaTipoOperazione: 'Seleziona il tipo di operazione',
    workflow: 'Workflow',
    riesecuzioneUnit: 'Riesecuzione unit',
    selezionaRieseguiStep: 'Seleziona Riesegui su uno step',
    finalState: 'Final State',
    rieseguiUnaUnit: 'Riesegui una unit',
    esecuzioneInCorso: 'Esecuzione in corso…',
    rieseguiUnit: 'Riesegui unit',
    visualizzaErrore: 'Visualizza errore',
    errorePrefix: 'Errore: ',
    logLabel: 'Logs',
    initialState: 'Initial State',
    initialStack: 'Initial Stack',
    finalStack: 'Final Stack',
    inCorso: 'in corso…',
    // Process/ErrorStats
    statisticheErroriPerIntervallo: 'Statistiche errori per intervallo date',
    intervalloDate: 'Intervallo date',
    processiInErrore: 'Processi in errore',
    unitInErrore: 'Unit in errore',
    nonCiSonoErrori: 'Non ci sono errori',
    dettaglioProcessiErrore: 'Dettaglio processi in errore',
    // Process/Performance
    panoramica: 'Panoramica',
    performanceUnitTab: 'Performance Unit',
    trendAnalisi: 'Trend & Analisi',
    statisticheErrori: 'Statistiche errori',
    selezionaRange: 'Seleziona un range oppure usa i preset rapidi',
    cacheAggiornata: 'Cache aggiornata',
    erroreBackfillCache: 'Errore backfill cache',
    erroreSconosciuto: 'errore sconosciuto',
    nessunDatoCache:
      'Nessun dato in cache processOverviewHourly per questo intervallo. Esegui «Backfill cache» con lo stesso range (o attendi il cron ogni 10 minuti per le ultime ore).',
    backfillCache: 'Backfill cache',
    aggiornamentoCache: 'Aggiornamento cache...',
    backfillCacheStatistiche: 'Backfill cache statistiche',
    precomputaDescrizione:
      'Precomputa unitStatsHourly e processOverviewHourly (cache performance e panoramica).',
    preset: 'Preset',
    oreCustom: 'Ore custom',
    rangePagina: 'Range pagina',
    oreDaRicalcolare: 'Ore da ricalcolare',
    eseguiBackfill: 'Esegui backfill',
    selezioneGrafico: 'Selezione grafico: usa il bottone "Grafico" nella tabella.',
    caricamentoDatiCache: 'Caricamento dati cache…',
    cache: 'Cache',
    unit: 'unit',
    // Process/Performance DrillDown
    dettaglio: 'Dettaglio:',
    mostraTutti: 'Mostra tutti',
    soloLenti: 'Solo lenti',
    nessunaEsecuzioneTrovata: 'Nessuna esecuzione trovata',
    tempo: 'Tempo',
    inizio: 'Inizio',
    conv: 'Conv.',
    // Process/Performance UnitStatsTable
    statistichePerUnit: 'Statistiche per Unit',
    unitNelPeriodo: 'unit nel periodo',
    legenda: 'Legenda',
    cercaUnit: 'Cerca unit...',
    evidenziazioneRighe: 'Evidenziazione righe',
    tutte: 'Tutte',
    soloEvidenziate: 'Solo evidenziate',
    soloNonEvidenziate: 'Solo non evidenziate',
    aggiungiAlGrafico: 'Aggiungi al grafico',
    drillDown: 'Drill down',
    legendaColoriRegole: 'Legenda colori e regole',
    nelPeriodo: 'Nel periodo',
    deltaVsMediaComplessiva: 'Δ vs media complessiva',
    colAzioni: 'Azioni',
    colN: 'N.',
    colErrPerc: 'Err%',
    colP90Media: 'P90÷Media',
    colDeltaMedia: 'Δ Media',
    colDeltaP50: 'Δ P50',
    colDeltaP90: 'Δ P90',
    colDeltaP95: 'Δ P95',
    colDeltaP99: 'Δ P99',
    // Process/Pricing
    costoLlmProcessi: 'Costo LLM per i processi della conversazione',
    filtraProvider: 'Filtra provider',
    selezionaProviderVisualizzare: 'Seleziona i provider da visualizzare',
    dettaglioCostiUnit: 'Dettaglio costi per unit',
    ripartizioneCosti: 'Ripartizione costi',
    perProvider: 'Per provider',
    nessunCostoVisualizzare: 'Nessun costo da visualizzare per i provider selezionati.',
    // Process/Stats
    statoProcessSteps: 'Stato process steps',
    processStepsInErrore: 'Process Steps in errore',
    riepilogoCosti: 'Riepilogo Costi',
    tempiDiEsecuzione: 'Tempi di esecuzione',
    tempoDiEsecuzione: 'Tempo di esecuzione:',
    tempiUnit: 'Tempi unit',
    min: 'Min',
    max: 'Max',
    sommaUnit: 'Somma unit:',
    ordineEsecuzione: 'Ordine esecuzione',
    durata: 'Durata',
    // Prompts
    prompt: 'Prompt',
    campo: 'Campo',
    spiegazione: 'Spiegazione',
    nessunPromptInserito: 'Nessun prompt inserito',
    // Statistics
    selezionaPeriodoAnalisi: 'Seleziona il periodo di analisi o usa i preset rapidi',
    selezionaPeriodoLabel: 'Seleziona periodo:',
    filtraPerIsolaUnitaCliente: 'Filtra per isola, unità operativa o cliente',
    unitaOperativa: 'Unità operativa',
    tutteLeUnitaOp: 'Tutte le unità op.',
    tuttiIClienti: 'Tutti i clienti',
    cercaCliente: 'Cerca cliente...',
    reset: 'Reset',
    totaleFatturatiNelPeriodo: 'Totale fatturati nel periodo',
    nConversazioni: 'n° conversazioni:',
    costoAConversazione: 'Costo a conversazione:',
    gestiteDaNora: 'Gestite da Nora',
    escluseConversazioniInoltrate: "* escluse le conversazioni inoltrate all'operatore",
    nessunaConversazioneNelPeriodo: 'Nessuna conversazione nel periodo',
    costoTotale: 'Costo totale',
    conversazioniTotali: 'Conversazioni totali',
    elaborate: 'Elaborate:',
    inoltrate: 'Inoltrate:',
    // Test/AutoTest
    datiChatNonDisponibili: 'Dati chat non disponibili',
    importazioneCompletata: 'Importazione completata',
    conversazioniInserite: 'conversazioni inserite',
    saltateGiaPresenti: 'saltate (già presenti)',
    erroreDuranteImportazione: "Errore durante l'importazione o l'esecuzione dei test:",
    autoTestTitle: 'Auto Test',
    autoTestSubtitle: "Test automatici per validare l'estrazione dei dati dalle conversazioni",
    caricamentoInCorso: 'Caricamento in corso...',
    caricaTestConv: 'Carica TESTCONV.json',
    lanciaTuttiITest: 'Lancia tutti i test',
    test: 'Test',
    nessunTestTrovato: 'Nessun test trovato',
    messaggio: 'Messaggio',
    fileAllegati: 'File allegati',
    allegaFile: 'Allega file',
    messaggioBozzaNora: 'Messaggio bozza di Nora: ',
    copia: 'Copia',
    nessunMessaggio: 'Nessun messaggio',
    leggiJson: 'Leggi JSON',
    risultatoElaborazione: 'Risultato Elaborazione',
    step: 'Step',
    combTariffaCompagniaDuplicata: 'Questa combinazione di tariffa e compagnia esiste già',
    duplicato: 'Duplicato',
    apriChiudiMenu: 'Apri o chiudi menu di navigazione',
    chiudiMenu: 'Chiudi menu di navigazione',
    nuovaProposta: 'NUOVA PROPOSTA',
    formatoDataPlaceholder: 'gg/mm/aaaa',
    executionTime: 'Execution Time',
    // Statistics
    stPresetOggi: 'Oggi',
    stPreset7Giorni: '7 giorni',
    stPreset30Giorni: '30 giorni',
    stPresetQuestoMese: 'Questo mese',
    stPreset3Mesi: '3 mesi',
    stPresetAnno: 'Anno',
    stStatusAperta: 'Aperta',
    stStatusTerminata: 'Terminata',
    stStatusGestitaOperatore: 'Gestita da operatore',
    stChartTrasferteCreate: 'Trasferte create',
    stChartInoltrateOperatore: 'Inoltrate ad operatore',
    stChartNoraEsclusa: 'Nora esclusa',
    stChartConversazioniIgnorate: 'Conversazioni ignorate',
    stChartInCaricoOperatore: 'In carico ad un operatore',
    stChartCorrettamenteGestite: 'Correttamente gestite',
    stCardElaborate: 'Conversazioni elaborate',
    stCardConsegnateGestioneManuale: 'Consegnate gestione manuale',
    stCardEscluseErrori: 'Escluse / errori',
    stDettagliElaborate: 'Dettagli % elaborate',
    stDettagliInoltrate: 'Dettagli % inoltrate',
    stDettagliErrori: 'Dettagli % errori',
    stPercTotale: 'Perc. sul totale conv.',
    stPeriodoSelezionato: 'Periodo selezionato:',
    stDashboardEuro: 'Dashboard €',
    stEsportaReport: 'Esporta Report',
    stSegnaFatturato: 'Segna come fatturato',
    stPieGenerale: 'Generale',
    stPieOpenPausa: 'Open o in pausa',
    stPieErroriGestiti: 'Errori gestiti',
    stPieNoraEsclusaOp: 'Nora esclusa da op.',
    stTornaStatistiche: 'Torna a Statistiche',
    stCostoConversazioniTempo: 'Costo conversazioni nel tempo',
    stCostoMedioPeriodo: 'Costo medio nel periodo:',
    // Process Performance
    pfStatoProcessi: 'Stato processi',
    pfProcessiLower: 'processi',
    pfProcessiCreatiPerOra: 'Processi creati per ora',
    pfNessunDatoNelPeriodo: 'Nessun dato nel periodo',
    pfServerCanali: 'Server & canali',
    pfStatoInTempoReale: 'Stato in tempo reale',
    pfOperatori: 'operatori',
    pfTokenMin: 'Token/min',
    pfRichiesteMin: 'Richieste/min',
    pfInCoda: 'In coda:',
    pfNessunDatoServer: 'Nessun dato server disponibile',
    pfConnSuffix: ' conn.',
    pfLegendaRosso: '- **Rosso**: `Err% > 10` (molti errori).',
    pfLegendaGiallo:
      '- **Giallo**: `P90÷Media ≥ ${threshold}` (varianza alta: coda lenta vs media).',
    pfVarianzaP90Media: 'Varianza P90 ÷ Media',
    pfRapportoP90Media: 'Rapporto tra P90 e media aritmetica sul periodo selezionato.',
    pfValoriAltiCoda: 'Valori alti indicano coda lenta rispetto al tempo medio.',
    pfMediaAssolutaColonne: 'Media assoluta e colonne Δ (ms)',
    pfBaselineCalcolata:
      'La baseline è calcolata sugli ultimi 12 mesi di cache oraria, escludendo i bucket del periodo selezionato.',
    pfColonneDeltaMostrano:
      'Le colonne Δ mostrano (periodo − baseline) in ms: positivo = più lento, negativo = più veloce.',
    pfAndamentoNelTempo: 'Andamento nel tempo',
    pfSelezionaUnitTabella: 'Seleziona unit dalla tabella',
    pfSelezionaUnaPiuUnit: 'Seleziona una o più unit dalla tabella per visualizzare il grafico',
    pfNessunDatoNelPeriodoSelezionato: 'Nessun dato nel periodo selezionato',
    pfEsecuzioniSommaUnit: 'Esecuzioni (somma unit):',
    pfMedia: 'media',
    pfAndamentoGiornaliero: 'Andamento giornaliero',
    pfSelezionaUnaPiuUnitGiornaliero: 'Seleziona una o più unit per il grafico giornaliero',
    pfBarreEsecuzioniLinee: 'Barre: esecuzioni · Linee: tempo medio ± deviazione standard',
    pfEsecuzioni: 'Esecuzioni',
    pfTempoMedioMs: 'Tempo medio (ms)',
    pfEsecuzioniSigmaUnit: 'Esecuzioni (Σ unit)',
    pfNessunDatoGiornaliero:
      'Nessun dato giornaliero nel periodo (prova un backfill cache o un range piu ampio)',
    pfTempoMedioPerUnit: 'Tempo medio per unit',
    pfSecondiTop: 'Secondi · top',
    pfDistribuzioneTempiProcessi: 'Distribuzione tempi processi',
    pfOgniPuntoProcesso:
      'Ogni punto rappresenta un processo completato. Clicca per aprire il dettaglio.',
    pfProcessoHash: 'Processo #',
    pfTempo: 'Tempo: ',
    pfNessunProcessoTempo: 'Nessun processo con tempo di esecuzione nel periodo',
    pfVolumeProcessiPanoramica: 'Volume processi · panoramica giornaliera',
    pfTreViste: 'Tre viste sullo stesso intervallo: step per unit, tempi medi, process completati',
    pfGrafici12Prime:
      'Grafici 1 e 2: prime ${max} unit per volume nel periodo su ${total} totali; lo stack include "Altre unit" per il resto.',
    pfStepPerUnitStack: '1 · Step per unit (stack giornaliero)',
    pfColonneImpilate:
      'Colonne impilate: per ogni giorno, quanti step sono stati eseguiti per ciascuna unit in evidenza; la fascia grigia somma le altre unit.',
    pfAltreUnit: 'Altre unit',
    pfTempoMedioEsecuzionePerUnit: '2 · Tempo medio di esecuzione per unit',
    pfLineeMediaGiornaliera:
      'Linee: media giornaliera del tempo di step; barre verticali ± deviazione standard campionaria.',
    pfStepNelGiorno: 'Step nel giorno (tutte le unit):',
    pfProcessCompletatiPerGiorno: '3 · Process completati per giorno',
    pfConteggioProcessEndTime:
      'Conteggio process con endTime nel giorno e state 3 (ok) o 5 (errore). Giorni senza chiusure mostrano 0.',
    pfProcess: 'Process',
    pfProcessCompletati: 'Process completati',
    pfNessunGiornoNelRange: 'Nessun giorno nel range',
    pfMediaRecente: 'Media recente',
    pfBaseline: 'Baseline',
    pfRapporto: 'Rapporto',
    pfErroriRecenti: 'Errori recenti: ',
    pfBaselineInfix: ' (baseline: ',
    pfTuttiSistemiNormali: 'Tutti i sistemi operativi normalmente',
    pfAnomalieRilevate: 'anomalie rilevate',
    pfVistaForm: 'Vista Form',
    pfVistaJson: 'Vista json',
    pfRieseguiUnit: 'Riesegui unit',
    pfConfermaRieseguiUnit:
      'Vuoi rieseguire questa unit con lo stato iniziale dello step selezionato?',
    pfStepPrecedente: 'Step precedente',
    pfStepSuccessivo: 'Step successivo',
    pfRisultatoPrecedente: 'Precedente',
    pfRisultatoSuccessivo: 'Successivo',
    pfCerca: 'Cerca...',
    pfToken: 'Token ',
    tutteEsecuzioni: 'Tutte',
    nessunErroreTrovato: 'Nessun errore trovato nel periodo',
    nomeProcesso: 'Nome',
    ggRoomSingola: 'Singola (1 adulto)',
    ggRoomDoppia: 'Doppia (2 adulti)',
    ggRoomTripla: 'Tripla (3 adulti)',
    ggComposizioneCamere: 'Composizione camere',
    ggAggiungiOpzione: 'Aggiungi opzione',
    ggNessunaPreferenzaCamere: 'Nessuna preferenza camere (verranno usati i default)',
    ggOpzione: 'Opzione',
    ggCamera: 'Camera',
    ggTipoCamera: 'Tipo camera',
    ggCampiPersonalizzati: 'CAMPI PERSONALIZZATI',
    ggErroreRicercaCliente: 'Errore ricerca cliente',
    ggPulisci: 'Pulisci',
    ggNessunaOpzione: 'Nessuna opzione disponibile',
    gfMonthNames: [
      'Gennaio',
      'Febbraio',
      'Marzo',
      'Aprile',
      'Maggio',
      'Giugno',
      'Luglio',
      'Agosto',
      'Settembre',
      'Ottobre',
      'Novembre',
      'Dicembre'
    ],
    gfDayNamesShort: ['Dom', 'Lun', 'Mar', 'Mer', 'Gio', 'Ven', 'Sab'],
    admDisabilitato: 'Disabilitato',
    admSezioneInfoBase: 'Informazioni Base',
    admSezioneImpostazioniAI: 'Impostazioni AI',
    admSezioneIntegrazioneB4B: 'Integrazione B4B',
    admSezioneIntegrazioneAtlante: 'Integrazione Atlante',
    admSezioneIntegrazioneDinamico: 'Integrazione Dinamico (PHP e WSDynPkg)',
    admSezioneEmailComunicazioni: 'Email e Comunicazioni',
    admSezioneGoelett: 'Preventivo Goelett',
    admGoelettPinPreventivo: 'PIN di sblocco del preventivo',
    admGoelettPinPreventivoDesc:
      'Se attivo, il preventivo Goelett si apre solo con il codice recapitato al viaggiatore. Se spento, la pagina si apre dal link.',
    admGoelettScadenzaPreventivo: 'Scadenza del preventivo (minuti)',
    admGoelettScadenzaPreventivoDesc:
      'Minuti di vita del preventivo dalla ricerca, con il timer in pagina. -1 = non scade. Le offerte Goelett vivono circa 15 minuti.',
    admCreaSocieta: 'Crea Nuova Società',
    admModificaSocieta: 'Modifica Società',
    admSottotitoloSocieta: 'Configura le impostazioni e le integrazioni per la società',
    admEspandiTutto: 'Espandi tutto',
    admChiudiTutto: 'Chiudi tutto',
    admUsername: 'Username',
    admPassword: 'Password',
    admIdEnvironment: 'Id Environment',
    admRuolo: 'Ruolo',
    admAnagraficaUtente: 'Anagrafica utente',
    admCreaUtente: 'Crea Utente',
    admModificaUtente: 'Modifica Utente',
    admPID: 'PID',
    admEmail: 'Email',
    admTelefono: 'Telefono',
    admNome: 'Nome',
    admCognome: 'Cognome',
    admAnagraficaViaggiatore: 'Anagrafica viaggiatore',
    admCreaViaggiatore: 'Crea Viaggiatore',
    admModificaViaggiatore: 'Modifica Viaggiatore',
    admImportaViaggiatori: 'Importa viaggiatori',
    admSottotitoloImport: "Carica un file CSV per importare in blocco l'anagrafica viaggiatori",
    admCaricaCSV: 'Carica CSV',
    admCaricaSuDB: 'Carica su DB',
    admAnteprimaFile: 'Anteprima file caricato',
    admViaggiatoriDaImportare: ' viaggiatori da importare',
    admNienteDaVisualizzare: 'Niente da visualizzare',
    admTutorialUpload: "Effettua l'upload di un file CSV contentente i viaggiatori da aggiungere.",
    admTutorialStruttura: 'Il file CSV deve essere così strutturato: ',
    admTutorialIntestazione:
      'Nella prima riga di intestazione devono essere inseriti i campi pid, email, cellulare, codice cliente.',
    admTutorialDati: 'Dalla seconda riga devono essere inseriti i dati dei vari clienti.',
    admTutorialEsempio: 'Ecco un file di esempio da editare e caricare.',
    admScarica: 'Scarica',
    admAggiornaLabelErrori: 'Aggiorna label errori',
    admAggiornaLabelErroriHint:
      'Aggiorna la label degli errori per categorizzarli con la versione più recente del classificatore.',
    admAggiornaErroriTAProfile: 'Aggiorna errori TA profile',
    admAggiornaErroriTAProfileHint:
      'Ricalcola gli errori legati al profilo TA (anagrafica viaggiatori).',
    admAggiornaErroriOutOfOffice: 'Aggiorna errori out of office',
    admAggiornaErroriOutOfOfficeHint: 'Aggiorna la classificazione delle email out-of-office.',
    admSottotitoloPanel: 'Operazioni manutentive sui dati',
    admOperazioniManutenzione: 'Operazioni di manutenzione',
    admSottotitoloManutenzione: 'Eseguili con cautela · azioni non reversibili',
    admEsegui: 'Esegui',
    controlliIA: 'Controlli IA',
    cpDuplica: 'Duplica',
    cpSottotitoloPanel: 'Community Panel · Preset configurazione Nora',
    cpAggiungiFiltri: 'Aggiungi filtri',
    cpAggiungiFiltro: 'Aggiungi filtro…',
    cpNRimborsabili: 'N. rimborsabili',
    cpNNonRimborsabili: 'N. non rimborsabili',
    cpInserisciParametroRicerca: 'Inserire almeno un parametro di ricerca',
    cpErroreRicercaGruppo: 'Errore nella ricerca del gruppo',
    cpGruppoNonTrovato: 'Gruppo non trovato',
    cpPresetEsistente: 'Preset esistente',
    cpGruppoConfigurazioneEsistente: 'Questo gruppo ha già una configurazione salvata',
    cpClienteNonTrovato: 'Cliente non trovato',
    cpClienteConfigurazioneEsistente: 'Questo cliente ha già una configurazione salvata',
    cpCreaPreset: 'Crea Community Preset',
    cpModificaPreset: 'Modifica Community Preset',
    mxElencoPrompts: 'Elenco Prompts',
    mxPromptLLMSubtitle: 'Prompt LLM utilizzati per estrarre i campi delle conversazioni',
    mxCompilaCampi: 'Compilare tutti i campi',
    mxPromptCreato: 'Prompt creato',
    mxCreazionePrompt: 'Creazione Prompt',
    mxModificaPrompt: 'Modifica Prompt',
    mxConfigurazionePrompt: 'Configurazione prompt',
    mxChiaveCampoJson: 'Chiave campo JSON',
    mxSpiegazioneCampo: 'Spiegazione campo (basePrompt)',
    mxValidaTestLabel: "Vuoi validare il test? Il risultato dell'autotest verrà aggiornato",
    mxTestIdPrefix: 'Test ID: ',
    mxValidazioneEstrazione: 'Validazione estrazione dati conversazione',
    mxTestPrecedente: 'Test precedente',
    mxTestSuccessivo: 'Test successivo',
    mxEseguiTest: 'Esegui Test',
    mxValidaTest: 'Valida Test',
    mxConversazioneTest: 'Conversazione test',
    mxMessaggiSuffix: ' messaggi',
    mxRisultatoAtteso: 'Risultato atteso',
    mxRisultatoOttenuto: 'Risultato ottenuto',
    mxInEsecuzione: 'In esecuzione',
    mxImpostazioneCoefficienti: 'Impostazione coefficienti ricerca',
    mxImpostaCoefficientiPer: 'Imposta coefficienti per ',
    mxTipoPreventivo: 'Tipo Preventivo ',
    // Demo Goelett
    dgTitle: 'Nora — Goelett Integration',
    dgSubtitle: 'Demo flusso email → elaborazione AI → preventivo interattivo',
    dgPresetLoaded: 'Preset Goelett caricato',
    dgEmailPanel: 'Email in arrivo',
    dgFrom: 'Da',
    dgSubject: 'Oggetto',
    dgBody: 'Corpo email',
    dgBodyPlaceholder:
      'Scrivi il contenuto della mail...\n\nes. Buongiorno, avrei bisogno di un viaggio\nMilano → Londra il 15 ottobre,\nritorno il 18 ottobre.\nPreferisco volo diretto se possibile.\nGrazie',
    dgSend: 'Invia email a Nora',
    dgSending: 'Invio in corso...',
    dgContinue: 'Rispondi',
    dgNewConversation: 'Nuova conversazione',
    dgReset: 'Reset conversazione',
    dgConversation: 'Conversazione Nora',
    dgStatusWaiting: 'In attesa',
    dgStatusLoading: 'Elaborazione...',
    dgStatusSuccess: 'Connesso',
    dgStatusError: 'Errore',
    dgEmpty: "Nessun messaggio. Invia un'email per iniziare.",
    dgAsyncMessage: '[Async] Richiesta ricevuta. Elaborazione in corso...',
    dgMissingBody: 'Scrivi il contenuto della mail',
    dgSendError: "Errore durante l'invio",
    dgMenuLabel: 'Demo Goelett',
    dgFromPlaceholder: 'email@esempio.com',
    dgSubjectPlaceholder: 'es. Richiesta viaggio Milano - Londra',
    dgOpenConversation: 'Apri conversazione',
    dgPresetLabel: 'Preset',
    dgPresetGroupClient: 'Configurazioni client',
    dgPresetGroupSaved: 'Preset salvati',
    dgSavedPreset: 'Preset salvato'
  },
  EN: {
    cnMultiTratta: 'Multi-stop trips',
    cnMultiTrattaDesc:
      'A trip like Milan-Paris-London-Milan becomes a single request: each flight with its own leg and a hotel per stop. Off, Nora proposes to proceed one leg at a time.',
    // ── Import dati (pagina admin) — prefisso `id` ──────────────────────────
    idTitolo: 'Data import',
    idSottotitolo:
      'External datasets Nora uses: refresh them with the button or automatically, at intervals.',
    idRotteTitolo: 'Airline routes',
    idRotteTesto:
      'Direct flights between airports, scraped from flightsfrom.com: used by the trip planner. A full run takes a few hours.',
    idGeoTitolo: 'Cities (GeoNames)',
    idGeoTesto:
      'Places with at least 1,000 inhabitants and their names in several languages: Nora recognises that «Milan» and «Milano» are the same place.',
    idAvviaOra: 'Run now',
    idAvviato: 'Import started',
    idFerma: 'Stop',
    idFermaInviato: 'Stop requested',
    idNonDisponibile: 'Import not available on this installation.',
    idInCorso: 'running',
    idCompletato: 'completed',
    idFallito: 'failed',
    idFermato: 'stopped',
    idInterrotto: 'interrupted',
    idDataset: 'Dataset',
    idRighe: 'rows',
    idVuoto: 'empty',
    idAggiornato: 'Updated on',
    idUltimoImport: 'Last import',
    idProssimo: 'Next',
    idManuale: 'manual',
    idPianificato: 'scheduled',
    idAutomatico: 'Refresh automatically',
    idOgni: 'every',
    idGiorno: 'day',
    idGiorni: 'days',
    idStorico: 'History',
    idStoricoSotto: 'Latest imports, manual and scheduled. Click a row with a message to open it.',
    idNessunImport: 'No imports yet.',
    idColQuando: 'When',
    idColDataset: 'Dataset',
    idColAvvio: 'Started by',
    idColStato: 'Status',
    idColDurata: 'Duration',
    idColRighe: 'Rows',
    aeFerma: 'Stop run',
    aeFermata: 'stopped',
    aeFermaFallito: 'Run not stopped',
    aeNuovaRun: 'New run',
    aeChiudiForm: 'Close',
    aeDettaglio: 'Run detail',
    aeScegliRun: 'Pick a run from the list to see its details.',
    // ── Eval dell'agente (pagina admin) — prefisso `ae` ──────────────────────
    aeTitolo: 'Agent eval',
    aeSottotitolo:
      'Run the repository scenarios on an environment and compare runs: what changes when the harness or the model changes, and how reliable the agent is.',
    aeLancia: 'Start a run',
    aeLanciaSotto: 'Scenarios are JSON files in Executor/API/agentEval/scenari: edit them there.',
    aeEnvironment: 'Environment',
    aeScenari: 'Scenarios',
    aeTutti: 'all',
    aeTuttiApplicabili: 'all that run here',
    aeScegliEnvPrima: 'Choose an environment: its flow decides which scenarios make sense.',
    aeFlussoEnv: 'Environment flow',
    aeFlussoRun: 'Run flow',
    aeFlussoDellEnvironment: 'the environment’s',
    aeFlussoOverride:
      'The simulated chat is born with this flow. Nora Configuration does not change.',
    aeSoloEsclusivi: 'Only scenarios written for this flow',
    aeCapabilityAccese: 'capabilities on',
    aeNessunaCapability: 'no capabilities',
    aeNonApplicabili: 'Not run on this environment',
    aeSoloPer: 'only for',
    aeCapabilitySpenta: 'capability off',
    aeNonAgentico: 'environment without an agentic mode for the app',
    aeRichiedeViaggio: 'checks travel data, which this environment does not have',
    aePassaggi: 'Steps',
    aeControlli: 'Checks',
    aeCopione: 'Script',
    aeAttesa: 'expected move',
    aeVietata: 'forbidden move',
    aeRifiutoAtteso: 'expected refusal',
    aeNonValido: 'Invalid:',
    aeRipetizioni: 'Repetitions',
    aeRipetizioniScenario: 'as declared by the scenario',
    aeRicerca: 'Search',
    aeRicercaFinta: 'Fake (measures the agent)',
    aeRicercaReale: 'Real (live providers, read only)',
    aeNome: 'Run name',
    aeNomeEsempio: 'e.g. one-way after the new prompt',
    aeRipeti: 'Repeat',
    aeCosto: 'cost',
    aeCostoTotale: 'Run cost',
    aeCostoTotaleSotto: 'Estimated sum, split by model and provider, in the chosen period.',
    aeCostoSenzaDettaglio: 'Runs in this period have no split by model and provider.',
    aeCostoDettaglio: 'Cost detail',
    aePerRun: 'per run',
    aePerPasso: 'per step',
    aeErroriProvider: 'provider errors',
    aeRossiAgente: 'agent failures',
    aeUltimoGiorno: 'Last day',
    aeUltimi7: '7 days',
    aeUltimi30: '30 days',
    aeTutto: 'All',
    aeNessunaInCorso: 'none in progress',
    aePassi: 'Steps run',
    aeProveClassificate: 'Trials with known outcome',
    aeNonClassificati: 'unclassified historical steps',
    aeScenariSaltati: 'Skipped scenarios',
    aeProveSaltate: 'skipped trials',
    aeHarness: 'Harness',
    aeTuttiHarness: 'All versions',
    aeSenzaVersione: 'unversioned',
    aeFirma: 'signature',
    aeGuidaApri: 'How to read results',
    aeGuidaTitolo: 'How to read results',
    aeGuidaIntro:
      'This page has three different units: runs, scenarios and executions. Their counts should not be added together.',
    aeGuidaSogliaTitolo: 'Above and below threshold',
    aeGuidaSoglia:
      'The scenario author sets the threshold in its JSON file. If omitted, it defaults to 80% for conversations and 90% for decisions. The rate is successful executions ÷ executions that count: PASS when it meets or exceeds the threshold, FAIL when below. Example with an 80% threshold:',
    aeGuidaEsempioPass: 'meets the threshold',
    aeGuidaEsempioFail: 'below the threshold',
    aeGuidaSogliaNota:
      'A FAIL scenario can still contain passed executions. A scenario with no valid trials does not pass.',
    aeGuidaConteggiTitolo: 'What each column counts',
    aeGuidaVerdi: 'Executions where all checks pass, or the expected decision is correct.',
    aeGuidaRossi: 'Valid executions that miss a check or the expected decision.',
    aeGuidaErrori:
      'Executions interrupted by a technical error, such as a timeout; these are not agent behavior failures.',
    aeGuidaNonValidi:
      'Decision points whose setup did not produce the expected refusal. They are excluded from the scenario rate.',
    aeGuidaSaltati:
      'Scenarios inapplicable to the flow or capabilities. This column counts scenarios, not repetitions.',
    aeGuidaAvanzamento:
      'Completed executions plus skipped repetitions, out of those planned. A skip advances the run without producing a trial.',
    aeGuidaStorico:
      'For older runs, failed and skipped repetitions cannot be reconstructed: — means unavailable.',
    aeAltriFiltri: 'More filters',
    aeAzzeraFiltriExtra: 'Clear these filters',
    aeColQuando: 'When',
    aeColNome: 'Name',
    aeColEnv: 'Environment',
    aeColFlusso: 'Flow',
    aeColPassi: 'Progress',
    aeColVerdi: 'Passed trials',
    aeColErrori: 'Technical errors',
    aeColNonValidi: 'Invalid',
    aeColRossi: 'Failed trials',
    aeColCosto: 'Cost',
    aeColEsito: 'Outcome',
    aeColScenario: 'Scenario',
    aeColQuota: 'Rate',
    aeColFallite: 'Failed trials',
    aeColSottoSoglia: 'Runs below threshold',
    aeColRun: 'Runs',
    aeColCade: 'Where it fails',
    aeScenariEseguiti: 'scenario results (run × scenario)',
    aeSottoPieno: 'below 100%',
    aeProveFallite: 'of trials failed',
    aeDiCuiInterrotte: 'cut off by the provider',
    aeNessunaDifficolta: 'No scenario below 100% in this period.',
    aeInCorso: 'in progress',
    aeInCoda: 'queued',
    aeCompletata: 'completed',
    aeCerca: 'Search by name',
    aeTuttiEnv: 'All environments',
    aeTuttiFlussi: 'All flows',
    aeTuttiStati: 'All outcomes',
    aeDal: 'From',
    aeAl: 'To',
    aeNessunaFiltrata: 'No runs match these filters.',
    aePaginaPrima: 'Previous page',
    aePaginaDopo: 'Next page',
    aeAnalisi: 'Scenarios in trouble',
    aeApriDettaglio: 'Open detail',
    aeAnalisiSotto:
      'Finished runs in the period: a scenario can appear in multiple runs. Rates use only trials eligible for that scenario; skips and invalid decisions are excluded.',
    aeAvvia: 'Start run',
    aeEnvironments: 'Environments',
    aeEnvironmentsAiuto:
      'Pick one or more. With several environments the shared scenarios run only on the first one chosen, the flow scenarios on each.',
    aePrimoComuni: 'shared here',
    aeCatalogoEnvNonLetto:
      "An environment's catalogue could not be read: check its Nora Configuration.",
    aePreset: 'Quick selection',
    aePreset_tutti: 'All',
    aePreset_comuni: 'Shared only',
    aePreset_flussi: 'Flow only',
    aePreset_falliti: 'Failed in the last run',
    aeNessunFallito: 'No scenario below threshold in the last finished run',
    aeComuni: 'Shared',
    aeComuniAiuto:
      'They do not depend on the flow: in a campaign they run once, on the first environment.',
    aeDiFlusso: 'Flow',
    aeDiFlussoAiuto:
      'They depend on the flow: they run on every chosen environment whose flow is theirs.',
    aeNonGiraQui: 'does not run on the chosen environments',
    aeRicercaRealeAvviso:
      'Uses the real providers: it costs more and can fail for external reasons (VPN, availability).',
    aeTrascrizioni:
      'Also save full transcripts to files (agentEval/transcripts). Red executions stay readable here anyway.',
    aeAvviaCampagna: 'Start campaign',
    aeNessunoScelto: 'Choose at least one environment',
    aeMinuti: 'min',
    aeNienteDaLanciare: 'No scenario runs on the chosen environments',
    aeCampagnaAvviata: 'Campaign started',
    aeCampagnaParziale: 'Campaign only partly started',
    aeCampagna: 'Campaign',
    aeStrumenti: 'Tools',
    aeRipetiFalliti: 'Repeat failed',
    aeSottoSoglia: 'Below threshold',
    aeSopraSogliaTitolo: 'Above threshold',
    aeSaltatiTitolo: 'Skipped',
    aeRunInCorso: 'Run in progress',
    aeRun: 'Runs',
    aeRunSotto:
      'Progress = completed executions + skipped repetitions. Historical runs do not distinguish every category.',
    aeNessunaRun: 'No runs yet.',
    aeFallita: 'failed',
    aeElimina: 'Delete run',
    aeEliminaConferma: 'Delete run',
    aeRunNonEliminata: 'Run not deleted',
    aeRunAvviata: 'Run started',
    aeEsecuzioni: 'executions',
    aeRunNonAvviata: 'Run not started',

    aeExecutorNonRaggiungibile: 'Executor unreachable',
    aeRunIllegibile: 'Run not readable.',
    aeFlusso: 'flow',
    aeSopraSoglia: 'scenarios meeting the threshold',
    aeSoglia: 'threshold',
    aePrima: 'before',
    aeSaltato: 'SKIPPED',
    aeInterrotta: 'interrupted',
    aeNessunTool: 'no tool',
    aeRichiestaFinale: 'Final request',
    aeNonConta: 'does not count (script without the expected rejection)',
    // ── D28 — «Nora configuration» page ────────────────────────────────────
    // Prefix `cn`. Every visible text on the page goes through here.
    cnTitolo: 'Nora configuration',
    cnSottotitolo:
      'Choose whether to use Nora, with which travel and which add-ons. Every save applies from the next turn, open chats included.',
    cnSelezionaEnvironment: 'Environment',
    cnNessunEnvironment: 'Select an environment to see its configuration.',
    cnCaricamentoFallito: 'Unable to load the configuration.',
    cnRiprova: 'Retry',
    cnModalita: 'Mode',
    cnModalitaPredefinita: 'Default configuration',
    cnModalitaPredefinitaHint: 'Applies to every community without an exception.',
    cnModoProcessUnit: 'Process-Unit',
    cnModoProcessUnitDesc: 'Uses existing processes, units and configuration.',
    cnModoDynamicDemo: 'Nora · Dinamico demo travel',
    cnModoDynamicDemoBreve: 'Dinamico demo',
    cnModoDynamicDemoDesc:
      'Searches real offers with Dinamico; confirmation stays local and creates no case or booking.',
    cnModoMidofficeCase: 'Midoffice case',
    cnModoMidofficeCaseDesc:
      'Creates case and services, searches with Dinamico and writes the quote to the Midoffice.',
    cnModoGoelettBooking: 'Nora · Goelett travel',
    cnModoGoelettBookingBreve: 'Goelett booking',
    cnModoGoelettBookingDesc:
      'Searches, creates the cart and books on Goelett after two confirmations.',
    cnModoAssistant: 'Nora · no travel',
    cnMotore: 'Engine',
    cnMotoreNora: 'Nora',
    cnMotoreNoraDesc:
      'Nora answers in chat with the add-ons chosen below; searching and booking travel is optional.',
    cnViaggi: 'Travel',
    cnViaggiNessuno: 'None',
    cnViaggiNessunoDesc:
      'Nora does not search or book travel: it answers and plans with the add-ons.',
    cnAggiunte: 'Add-ons',
    cnModoAssistantDesc:
      'Answers with add-ons only (weather, web search, planning, policy): it does not search or book travel.',
    cnScriveSistemiEsterni: 'Writes to external systems',
    cnNessunaConfigurazioneAgentica:
      'No agentic configuration saved: the environment uses Process-Unit.',
    cnCapabilities: 'Capabilities',
    cnComportamento: 'Behaviour',
    cnCapabilitiesHint:
      'Optional agentic add-ons. They are turned on here; if one cannot be built (for example the Google key is missing), Nora works without it.',
    cnCapabilitiesProcessUnit: 'Without an agentic channel the capabilities are not used.',
    cnCanali: 'Per channel',
    cnCanaliHint: 'Each channel can use a different configuration; the app works only with Nora.',
    cnCanaliFissi: '{canali}: always Process-Unit.',
    cnCanaleComePredefinita: 'Same as the default configuration',
    cnCanaleOggi: 'Today: {modalita}',
    cnCanaleNonAbilitato: 'Today: channel not enabled',
    cnCanaleApp: 'Nora app',
    cnCanaleTeams: 'Teams',
    cnCanaleEmail: 'Email',
    cnCanaleMidoffice: 'Midoffice',
    cnCanaleWhatsapp: 'WhatsApp',
    cnCapWeather: 'Weather',
    cnCapWeatherDesc: 'Weather forecast for the destination.',
    cnCapTripPlanner: 'Itinerary planning',
    cnCapTripPlannerDesc: 'Itinerary and stop suggestions.',
    cnMezziTitolo: 'Travel modes proposed by the planner',
    cnMezziAiuto:
      'They apply to the whole trip. Short legs to reach a station or airport always remain. A trip request cannot be created from car, taxi or coach: train and flight are the bookable ones.',
    cnMezziDefault: 'No choice made: the modes configured for this installation apply.',
    cnMezziAlmenoUno: 'Pick at least one, or leave them all unselected.',
    cnMezzoVolo: 'Flight',
    cnMezzoTreno: 'Train',
    cnMezzoAuto: 'Car or taxi',
    cnCapTravelPolicy: 'Travel policy lookup',
    cnCapTravelPolicyDesc:
      'The traveller can look up company rules. Rule compliance stays active even when off.',
    cnCapWebSearch: 'Web search',
    cnCapWebSearchDesc:
      'Up-to-date news about the trip: events, strikes, disruptions. Needs the Tavily key (apiKeyTavily) on the Executor.',
    cnSalvaEUsa: 'Save and apply',
    cnSoloNuoveChat: 'Applies from the next turn, open chats included.',
    cnSalvato: 'Configuration saved',
    cnOperazioneRiuscita: 'Operation completed',
    cnConflitto: 'Configuration changed in the meantime',
    cnConflittoDettaglio:
      'Someone else changed it: nothing was overwritten and the page was reloaded. Review and save again.',
    cnConfermaScrittureTitolo: 'Confirm writes to external systems',
    cnConfermaScritture:
      'With “{modalita}” new chats will write to {sistema}, destination {destinazione}.',
    cnSistemaMidoffice: 'Midoffice and Dinamico',
    cnSistemaGoelett: 'Goelett',
    cnDestinazioneTest: 'Test',
    cnDestinazioneProduzione: 'Production',
    cnDestinazioneSandbox: 'Sandbox',
    cnDestinazioneNonConfigurata: 'not configured yet',
    cnStatoPronta: 'Ready',
    cnStatoProntaMancanti: 'Ready, with unavailable add-ons',
    cnStatoNonPronta: 'Not ready',
    cnStatoSospesa: 'Suspended',
    cnStatoEffettiArrestati: 'Effects stopped',
    cnAggiornataIl: 'Updated on',
    cnRiepilogoTitolo: 'Values read from other sources',
    cnRiepilogoHint:
      'Nora also uses these values, which are not changed here: the Source column says where.',
    cnVoce: 'Item',
    cnValore: 'Value',
    cnProvenienza: 'Source',
    cnFonteEnvironment: 'Environment',
    cnFonteCommunity: 'Community',
    cnFonteTecnica: 'Technical configuration',
    cnRigaEnvironment: 'Environment',
    cnRigaDestinazioneDinamico: 'Dinamico destination',
    cnRigaCommunityPredefinita: 'Default community',
    cnRigaPolicyCommunity: 'Services, tone and quote publishing',
    cnPolicyCommunityValore: 'from the Community panel',
    cnRigaModelloLimiti: 'Nora model',
    cnGestitiDalDeploy: 'managed by the deployment',
    cnModelloSenzaChiave: 'model key missing',
    cnRigaConnessioneMidoffice: 'Dinamico demo connection',
    cnRigaConnessioneGoelett: 'Goelett connection',
    cnConnessioneAttiva: 'active',
    cnConnessioneRevocata: 'revoked',
    cnConnessioneAssente: 'not created yet',
    cnConnessioneMidofficeAuto: 'the server creates it on the first save that needs it',
    cnNessuna: 'none',
    cnEccezioniTitolo: 'Community exceptions',
    cnEccezioniHint:
      'Normally every community (customer) uses the default configuration. An exception gives it a different engine, travel or add-ons: for example one customer with Goelett travel while the others stay on the Dinamico demo.',
    cnNessunaCommunity: 'No community for this environment.',
    cnCodiceCliente: 'Customer code',
    cnPresetPredefinito: 'Default',
    cnInattiva: 'Inactive',
    cnEredita: 'Inherit from environment',
    cnEreditaValore: 'Inherits from environment: {modalita}',
    cnDescEredita:
      'The exception is deleted: new chats of this community will use the environment mode ({modalita}).',
    cnFissata: 'Pinned',
    cnFissataHint: 'Same as the current default, but stays like this even if the default changes.',
    cnEccezione: 'Exception',
    cnOverrideNonApplicata: 'Exception present but not applied to new chats.',
    cnMotivoDefaultPreset: 'Default preset: always uses the environment default.',
    cnMotivoInattiva: 'Inactive community: no exception possible.',
    cnMotivoSenzaCodice: 'No customer code: no exception possible.',
    cnMotivoNonAmmessa: 'No exception possible for this community.',
    cnImpostaEccezione: 'Set exception',
    cnModificaEccezione: 'Edit exception',
    cnGoelettTitolo: 'Goelett connection',
    cnGoelettHint:
      'The credentials Nora uses to talk to Goelett. Only needed by Goelett travel, which cannot be saved without them. To update or reactivate the connection fill in all fields again.',
    cnGoelettStato: 'Current status',
    cnGoelettAmbiente: 'Goelett environment',
    cnGoelettBaseUrl: 'Base URL',
    cnGoelettBaseUrlHint: 'https, must end with /nora/public.',
    cnGoelettUrlNonValido: 'The base URL must start with https:// and end with /nora/public.',
    cnGoelettStsUrl: 'Token service URL (STS)',
    cnGoelettStsNonValido: 'The STS URL must start with https://.',
    cnGoelettScope: 'OAuth scope (optional)',
    cnGoelettClientId: 'Client ID',
    cnGoelettSecretRef: 'Secret reference name',
    cnGoelettSecretRefHint: 'Name only: the secret value lives in the Executor configuration.',
    cnGoelettSalva: 'Save connection',
    cnGoelettSalvato: 'Goelett connection saved',
    cnRevocaConnessione: 'Revoke connection',
    cnDescRevocaConnessione:
      'The Goelett connection can no longer be used until it is saved again.',
    cnAvvisoEffettiInCorso:
      'Warning: this command may interrupt in-flight effects on open conversations.',
    cnOperativoTitolo: 'Emergency brakes',
    cnOperativoHint:
      'They stop Nora on this environment if something goes wrong, without changing the configuration. Normally they stay off.',
    cnMostra: 'Show',
    cnNascondi: 'Hide',
    cnNuoveChat: 'New agentic chats',
    cnNuoveChatAmmesse: 'allowed',
    cnNuoveChatSospese: 'suspended',
    cnSospendiNuoveChat: 'Suspend new chats',
    cnRiprendiNuoveChat: 'Resume new chats',
    cnDescSospendiNuoveChat:
      'New agentic chats of the environment are blocked; open chats continue.',
    cnDescRiprendiNuoveChat: 'New agentic chats of the environment are allowed again.',
    cnEffettiEsterni: 'External effects',
    cnEffettiAttivi: 'active',
    cnEffettiArrestati: 'stopped',
    cnArrestaEffetti: 'Stop effects',
    cnRiprendiEffetti: 'Resume effects',
    cnDescArrestaEffetti: 'Blocks writes to external systems for every chat of the environment.',
    cnDescRiprendiEffetti: 'Writes to external systems are allowed again.',
    cnSpiegaNuoveChat:
      'When on, new agentic chats of this environment do not start. Chats already open continue.',
    cnSpiegaEffetti:
      'When on, Nora keeps talking and searching but makes no bookings on Goelett, not even in chats already open. What was already created stays.',
    cnAvvisoNuoveChatSospese: 'Brake on: new agentic chats of this environment are suspended.',
    cnAvvisoEffettiArrestati: 'Brake on: Nora does not book on Goelett.',
    cnVaiAiFreni: 'Go to brakes',
    cnConnessioneNonUsata: 'not used',
    cnServeGoelett:
      'Goelett travel needs an active Goelett connection: configure and save it, then save this configuration.',
    cnConfiguraGoelett: 'Configure connection',
    cnSalvaBloccatoGoelett: 'The Goelett connection is needed first.',
    cnConteggioEccezioni: '{n} with exception',
    cnNessunaCommunityAmmessa:
      'No community of this environment can have an exception: they all use the default configuration.',
    cnCommunityBloccate: '{n} more communities cannot have exceptions',
    // ── Execution scenario badge ─────────────────────────────────────
    agScenario: 'Scenario',
    agScenarioOfferSelection: 'Search and simulated confirmation',
    agScenarioCaseSubmission: 'Midoffice case',
    agScenarioBooking: 'Booking',
    agScenarioModoSimulate: 'simulated confirmation',
    agScenarioModoExecute: 'real writes',
    agScenarioModoDeny: 'no writes',
    agScenarioDatiFixture: 'sample data',
    agAttesaOperatore: 'Waiting for operator',
    agAttesaViaggiatore: 'Waiting for traveller',
    agDaGestire: 'Needs review',
    agPreventivoDaConfermare: 'Quote awaiting confirmation',
    gf45Porte: '4-5 doors',
    gfAllInclusive: 'All Inclusive',
    gfAndataRitorno: 'Round trip',
    gfAutomatico: 'Automatic',
    gfBedAndBreakfast: 'Bed and Breakfast',
    gfBenzina: 'Petrol',
    gfCena: 'Dinner',
    gfCentrale: 'Middle',
    gfCompact: 'Compact',
    gfCorridoio: 'Aisle',
    gfCrossover: 'Crossover',
    gfDiesel: 'Diesel',
    gfEconomy: 'Economy',
    gfElettrica: 'Electric',
    gfFinestrino: 'Window',
    gfFormatoData: 'Format dd/mm/yyyy',
    gfFullSize: 'Full size',
    gfGpl: 'LPG',
    gfIbrida: 'Hybrid',
    gfIntermediate: 'Intermediate',
    gfLuxury: 'Luxury',
    gfManuale: 'Manual',
    gfMezzaPensione: 'Half board',
    gfMini: 'Mini',
    gfMonovolume: 'Minivan',
    gfNo: 'No',
    gfNonPrecedentePartenza: 'Cannot be earlier than departure',
    gfNonSpecificato: 'Not specified',
    gfPensioneCompleta: 'Full board',
    gfPranzo: 'Lunch',
    gfPremium: 'Premium',
    gfSi: 'Yes',
    gfSolaAndata: 'One way',
    gfSoloNumeri: 'Numbers only',
    gfSoloStanza: 'Room only',
    gfSportiva: 'Sports car',
    gfStandard: 'Standard',
    gfStationWagon: 'Station Wagon',
    gfSuv: 'SUV',
    gfVan: 'Van',
    mxAllInclusive: 'All Inclusive',
    mxBedAndBreakfast: 'Bed and Breakfast',
    mxCenaInclusa: 'Dinner included',
    mxCoeffDistanza: 'Distance coefficient',
    mxCoeffDurata: 'Duration coefficient',
    mxCoeffScostamento: 'Deviation coefficient',
    mxGruppoBase: 'Base',
    mxGruppoCorporate: 'Corporate',
    mxGruppoLivelliHotel: 'Hotel Program Levels',
    mxGruppoTrattamento: 'Treatment',
    mxLivello0: 'Level 0',
    mxLivello1: 'Level 1',
    mxLivello2: 'Level 2',
    mxLivello3: 'Level 3',
    mxMezzaPensione: 'Half board',
    mxPensioneCompleta: 'Full board',
    mxPranzoIncluso: 'Lunch included',
    mxRoomOnly: 'Room Only',
    mxTariffaAgenzia: 'Agency fare',
    mxTariffaCliente: 'Client fare',
    mxTariffaPubblica: 'Public fare',
    pfPreset24h: 'Last 24h',
    pfPreset30Giorni: 'Last 30 days',
    pfPreset6h: 'Last 6h',
    pfPreset7Giorni: 'Last 7 days',
    pfPresetUltimaOra: 'Last hour',
    pfStatoAttenzione: 'Warning',
    pfStatoCritico: 'Critical',
    pfStatoNormale: 'Normal',
    pfStepCompletato: 'Completed',
    admAbilitazioneArrivoEntro: 'Enable arrive-by',
    admAbilitazioneArrivoEntroDesc:
      'Enables setting the departure time of services to 00:01 if it is not specified but the arrive-by indication is present...',
    admAbilitazioneAtlante: 'Enable Atlante',
    admAbilitazioneAtlanteDesc: 'Enables the use of Atlante.',
    admAbilitazioneB4B: 'Enable B4B',
    admAbilitazioneB4BDesc: 'Enables integration with the B4B system',
    admAbilitazioneCarnet: 'Enable carnet',
    admAbilitazioneCarnetDesc: 'Enables the use of carnets.',
    admAbilitazioneMidOffice: 'Enable Mid Office',
    admAbilitazioneMidOfficeDesc: 'Enables the use of Mid Office.',
    admAbilitazioneRimborsabile: 'Enable refundable management',
    admAbilitazioneRimborsabileDesc:
      'Enables the management of refundable or non-refundable trains.',
    admBloccaEmailErroreOperatori: 'Block sending error emails to operators',
    admBloccaEmailErroreOperatoriDesc: 'Blocks sending error emails to operators',
    admCodiceMastroCliente: 'Customer Master Code',
    admCodiceMastroClienteDesc:
      'Master code to identify the customer (e.g.: 20 1 2 127, where 20 is the master)',
    admCodiceOperatore: 'Operator Code',
    admCodiceOperatoreDesc: 'Operator code for searching ATP generic tables',
    admCodiceProvenienza: 'Origin Code',
    admCodiceProvenienzaDesc: 'Origin code for ATP ticket tables',
    admCodiceSocieta: 'Company Code',
    admCodiceSocietaDesc: 'Unique code to identify the company',
    admCodiceTomcat: 'Tomcat Code',
    admCodiceTomcatDesc: 'Code of the associated Tomcat server',
    admConfigurazioneEmailReport: 'Email Report Configuration',
    admConfigurazioneEmailReportDesc:
      'JSON configuration for the credentials and settings for sending email from the platform. Example: {"host": "smtp.gmail.com", "port": 587, "secure": false, "auth": {"user": "email@example.com", "pass": "password"}}',
    admElencoEmailCCReport: 'List of CC emails for reports (comma-separated)',
    admElencoEmailCCReportDesc: 'List of CC emails for reports (comma-separated)',
    admDominioEmailOperatore: 'Operator email domain',
    admDominioEmailOperatoreDesc:
      'Fixed domain (e.g. bcdtravel.it) of operator emails in reports. Empty: full email.',
    admEstrapolazioneCampi1a10: 'Enable AI extraction of fields 1 to 10',
    admEstrapolazioneCampi1a10Desc: 'Enables AI extraction for fields 1-10',
    admFlussoRichiestaInfoGeneriche: 'Enable generic information request flow',
    admFlussoRichiestaInfoGenericheDesc: 'Enables the generic information request flow',
    admGestioneAuto: 'Enable car management',
    admGestioneAutoDesc: 'Enables the management of rental cars.',
    admGestioneGruppiPasseggeri: 'Enable passenger group management',
    admGestioneGruppiPasseggeriDesc: 'Enables the management of passenger groups.',
    admGoogleApiKey: 'Google API Key',
    admGoogleApiKeyDesc: 'API key for Google services',
    admInviaNotificaFormDati: 'Send data form completion notification',
    admInviaNotificaFormDatiDesc: 'Sends a data form completion notification',
    admInvioEmailRiassuntivoOperatore: 'Enable sending operator summary email',
    admInvioEmailRiassuntivoOperatoreDesc: 'Enables sending summary emails to operators',
    admLetturaAllegatiEmail: 'Enable reading of email attachments',
    admLetturaAllegatiEmailDesc: 'Enables reading of email attachments',
    admLetturaOggettoEmail: 'Enable reading of email subject',
    admLetturaOggettoEmailDesc:
      'Enables reading and analysis of the email subject and the possible merge with the data extracted from the message body.',
    admLetturaStoricoViaggiatore: 'Enable reading of the traveller profile history',
    admLetturaStoricoViaggiatoreDesc: 'Enables reading of the traveller profile history',
    admNomeDbB4B: 'B4B DB Name',
    admNomeDbB4BDesc: 'Name of the B4B database',
    admNomeDbDinamico: 'Dynamic DB Name',
    admNomeDbDinamicoDesc: 'Name of the Dynamic database',
    admNomeDesc: 'Identifying name of the company',
    admNumeroMassimoMessaggiAI: 'Maximum number of AI messages',
    admNumeroMassimoMessaggiAIDesc: 'Maximum number of allowed AI messages (default: 5)',
    admPasswordB4B: 'B4B Password',
    admPasswordB4BDesc:
      'Password for the B4B database (password encrypted with an external script)',
    admPasswordDbDinamico: 'Dynamic DB Password',
    admPasswordDbDinamicoDesc:
      'Password for the Dynamic database (password encrypted with an external script)',
    admPasswordJavaWsDinamico: 'Dynamic Java WS Password',
    admPasswordJavaWsDinamicoDesc:
      'Password for DynJavaWS (password encrypted with an external script)',
    admPasswordWS: 'WS Password',
    admPasswordWSDesc:
      'Password for web service authentication (password encrypted with an external script)',
    admPortaB4B: 'B4B Port',
    admPortaB4BDesc: 'Port of the B4B database',
    admPortaDbDinamico: 'Dynamic DB Port',
    admPortaDbDinamicoDesc: 'Port of the Dynamic database',
    admPresaInCarico: 'Enable "take charge"',
    admPresaInCaricoDesc: 'Enables the ability to take charge of a conversation',
    admPuliziaPPI: 'Enable PPI cleaning',
    admPuliziaPPIDesc: 'Enables the cleaning of personally identifiable information (PPI).',
    admResocontoOperatore: 'Enable operator report',
    admResocontoOperatoreDesc:
      'Enables the creation of the business trip report to be sent to the operator both in case of success and in case of error.',
    admSaltoRicercaTreni: 'Skip train search on dynamic',
    admSaltoRicercaTreniDesc: 'Skips the train search on dynamic',
    admSanitizzazioneEmailSenzaAI: 'Enable email sanitization without AI',
    admSanitizzazioneEmailSenzaAIDesc: 'Enables email sanitization without using AI',
    admTargetPacchettoDinamico: 'Dynamic Package Target',
    admTargetPacchettoDinamicoDesc: 'Target of the dynamic package (Test/Production)',
    admTelefonoWhatsapp: 'WhatsApp Phone',
    admTelefonoWhatsappDesc: 'Phone number for WhatsApp',
    admTeamsIdUtente: 'Teams ID',
    admTeamsIdCanale: 'Teams - Channel ID',
    admTeamsIdCanaleDesc:
      'ID of the Teams channel connected to Nora (format 19:...@thread.tacv2). It identifies this company when a message arrives: get it from Teams via "Get link to channel", decoding %3A to ":" and %40 to "@".',
    admTeamsIdTeam: 'Teams - Team ID',
    admTeamsIdTeamDesc:
      "ID of the team containing the channel (the groupId parameter of the channel link). Required to publish Nora's reply.",
    admTeamsCodCliente: 'Teams - Customer code',
    admTeamsCodClienteDesc:
      'Customer code of the company owning the channel. It lets Nora recognise a traveller writing for the first time by looking up their Atlante profile. If empty, each traveller must be enabled manually by filling in their Teams ID on the traveller record.',
    admTeamsSecretWebhook: 'Teams - Outgoing webhook token',
    admTeamsSecretWebhookDesc:
      'Security token generated by Teams when creating the Outgoing Webhook, used to verify that messages really come from Teams. Enter it encrypted, like the Atlante WS password.',
    admTeamsUrlFlowRisposta: 'Teams - Reply flow URL',
    admTeamsUrlFlowRispostaDesc:
      "URL of the Power Automate flow that publishes Nora's reply in the channel thread. Enter it encrypted, like the Atlante WS password.",
    admUrlAtlante: 'Atlante URL',
    admUrlAtlanteDesc: 'URL of the Atlante service for bookings',
    admUrlB4B: 'B4B URL',
    admUrlB4BDesc: 'URL of the B4B database',
    admUrlDbDinamico: 'Dynamic DB URL',
    admUrlDbDinamicoDesc: 'URL of the Dynamic database',
    admUrlDinamicoPhp: 'Dynamic PHP URL',
    admUrlDinamicoPhpDesc: 'URL of the Dynamic PHP service',
    admUrlJavaWsDinamico: 'Dynamic Java WS URL',
    admUrlJavaWsDinamicoDesc: 'URL of the Dynamic Java WS service',
    admUtenteB4B: 'B4B User',
    admUtenteB4BDesc: 'Username for the B4B database',
    admUtenteDbDinamico: 'Dynamic DB User',
    admUtenteDbDinamicoDesc: 'Username for the Dynamic database',
    admUtenteJavaWsDinamico: 'Dynamic Java WS User',
    admUtenteJavaWsDinamicoDesc: 'Username for Dynamic Java REST',
    admUtenteWS: 'WS User',
    admUtenteWSDesc: 'Username for web service authentication',
    admVisualizzaBottoneReport: 'Show report button',
    admVisualizzaBottoneReportDesc: 'Shows the button for reports',
    cerca: 'Search...',
    conversazioni: 'Conversations',
    cpCompilatoDaNora: 'filled in by Nora',
    data: 'Date',
    errAeroportoIATAnotFound: 'Airport IATA not found',
    errAttachmentsInEmail: 'Internal attachments in email',
    errCanceled: 'Cancelled by operator',
    errCarnetError: 'Carnet search error',
    errDefault: 'Other',
    errDepartureCarJsonNotFound: 'Car departure/arrival data not found',
    errDestinationHotelNotFound: 'Hotel destination not found',
    errDuplicazioneProfiloTrovato: 'Duplicate profile found',
    errEmailMancanteProfiloViaggiatore: 'Missing traveler profile email',
    errErroreCreazionePreventivi: 'Quotes creation error',
    errErroreCreazioneServizi: 'Services creation error',
    errErroreCreazioneTrasferta: 'Trip creation error',
    errErroreElaborazioneServizi: 'Services processing error',
    errErroreRicercaDinamico: 'Dynamic search error',
    errErroreRicercaDinamicoVuoto: 'No service search results',
    errErrorSavingAttachments: 'Error saving attachments',
    errGenericError: 'Generic error',
    errLoopError: 'Loop error',
    errMaxAIMessagesReachedInGC: 'Generic content (not a trip)',
    errMoreThanOneTransfer: 'More than one trip found',
    errNessunProfiloTrovato: 'No profile found',
    errNessunProfiloTrovatoTA: 'TA missing on traveler',
    errNoAirportFound: 'Airport not found',
    errNoFinalizzazioneCorretta: 'Finalization did not occur',
    errNoKeyServizioGenerato: 'Missing service key',
    errNoNoraTransfer: 'Trip not created by Nora',
    errNonTrovatoRiferimentoServizioSuMidOffice: 'Service reference not found in mid office',
    errNoProfileInfoTrovato: 'Profile not found',
    errNoTransferFound: 'No trip found',
    errOutOfOffice: 'Out of office',
    errPasseggeriMultipli: 'Multiple passengers',
    errProfiloMittenteNonTA: 'Sender profile is not Travel Arranger',
    errProfiloNoPresenteSuGDS: 'Profile not present on GDS',
    errRichiestaAggiornamentoTrasferta: 'Trip update request',
    errRichiestaModificaOCancellazioneTrasferta: 'Trip modify/cancel request',
    errSollecito: 'Reminder',
    errTooManyDaysHotel: 'Hotel stay too long',
    errTooManyMessages: 'Message limit reached',
    errTooMuchServiceBoth: 'Too many train and plane services',
    errTooMuchServicePlane: 'Too many plane services',
    errTooMuchServiceTrain: 'Too many train services',
    gfDi: 'of',
    gfNumerico: 'numeric',
    gfReturnLeg: 'Return leg',
    gfSeleziona: 'Select',
    gfSelezionaData: 'Select date',
    gfServizioCopertoDaCarnet: 'Service covered by CARNET',
    gfTransferDepartureDate: 'Departure date',
    gfTransferDeparturePlace: 'Place of departure',
    gfTransferDestinationPlace: 'Place of destination',
    gfTransferNumPax: 'Number of passengers',
    gfTransferReturnDate: 'Return date',
    mcApri: 'open',
    mcAutotestAggiornato: 'Autotest updated',
    mcConversazioneIniziataIl: 'Conversation started on',
    mcCopiatoNegliAppunti: 'Copied to clipboard',
    mcCredenzialiErrate: 'Wrong credentials',
    mcDebug: 'Debug',
    mcErroreImprevisto: 'Sorry, an unexpected error occurred.',
    mcFilenameLabel: 'filename',
    mcMe: 'Me',
    mcNameLabel: 'name',
    mcOggetto: 'Subject',
    mcOoops: 'Ooops!',
    mcPayloadCopiato: 'The payload was copied to the clipboard',
    mcRichiestaViaggio: 'Travel request',
    mcScriviMessaggio: 'Write a message...',
    mcTestNonTrovato: 'Test not found',
    mxErroreImportazioneViaggiatori: 'Error while importing travellers',
    mxGestisciNoraAI: 'Manage Nora AI',
    mxTitoloPanelOperations: 'Panel Operations',
    mxTrovati: 'Found',
    mxViaggiatori: 'travellers',
    pfCanale: 'channel',
    pfCosto: 'Cost',
    pfDatiCacheProcessOverview:
      'Data from the processOverviewHourly cache table (aligned to conversations in the period).',
    pfFinalState: 'Final State',
    pfInitialState: 'Initial State',
    pfMediaBin: 'Avg/bin',
    pfOrdinateDecrescente: 'sorted descending',
    pfProcessi: 'Processes',
    pfScatterCacheHint:
      'Points from the processOverviewHourly cache table (samples per hour). Click to open the process.',
    pfScatterCacheHintLong:
      'Points from the processOverviewHourly cache table (samples per hour, max 5000 total points). Click to open the process.',
    pfStato: 'State',
    pfStep: 'steps',
    pfTokenRichieste: 'Tokens/Requests',
    pfTotaleCache: 'Total (cache)',
    pfUnitSelezionate: 'units selected',
    stCosto: 'Cost',
    tdAereo: 'Plane',
    tdAeroportoArrivo: 'Arrival airport',
    tdAeroportoArrivoNonValido: 'Invalid arrival airport',
    tdAeroportoPartenza: 'Departure airport',
    tdAeroportoPartenzaNonValido: 'Invalid departure airport',
    tdAnteprimaRisultatiDinamico: 'Dynamic results preview',
    tdArrivo: 'Arrival',
    tdCamera: 'Room',
    tdCerca: 'Search',
    tdCitta: 'City',
    tdCittaNonValida: 'Invalid city',
    tdClasse: 'Class',
    tdCompagnia: 'Company',
    tdCoordinate: 'Coordinates',
    tdDataArrivo: 'Arrival Date',
    tdDataCancellazione: 'Cancellation Date',
    tdDataCheckIn: 'Check In Date',
    tdDataCheckOut: 'Check Out Date',
    tdDataPartenza: 'Departure Date',
    tdDistanza: 'Distance',
    tdDurata: 'Duration',
    tdEchoToken: 'Echo Token',
    tdFormatoDataOraNonValido: 'Invalid date/time format',
    tdFormatoDateNonValido: 'Invalid date format',
    tdHotel: 'Hotel',
    tdIdCommunity: 'Community Id',
    tdIndirizzo: 'Address',
    tdKgBagaglio: 'Baggage Kg',
    tdLat: 'Lat',
    tdLatitudine: 'Latitude',
    tdLng: 'Lng',
    tdLongitudine: 'Longitude',
    tdMetri: 'meters',
    tdMiniRules: 'Mini Rules',
    tdOraArrivo: 'Arrival Time',
    tdOraPartenza: 'Departure Time',
    tdPartenza: 'Departure',
    tdPreferenzaPosto: 'Seat preference',
    tdPrezzo: 'Price',
    tdPrezzoAncillary: 'Price + Ancillary',
    tdRisultati: 'results',
    tdServiziAggiuntivi: 'Additional services',
    tdSottotitoloAnteprima: 'View the raw results returned by the search engine',
    tdStazioneArrivo: 'Arrival Station',
    tdStazioneArrivoNonValida: 'Invalid arrival station',
    tdStazionePartenza: 'Departure Station',
    tdStazionePartenzaNonValida: 'Invalid departure station',
    tdTariffa: 'Fare',
    tdTipo: 'Type',
    tdTipoRicerca: 'Search Type',
    tdTratta: 'Route',
    tdTrattamento: 'Treatment',
    tdTrattaN: 'Route No.',
    tdTreno: 'Train',
    tdTypeRoom: 'Room type',
    abilitaMessaggiFirmati: 'Enable messages signed with Nora name',
    abilitaMessaggiFirmatiDescrizione:
      "If enabled, messages sent to the user will be signed with the name 'Nora' to ensure a more personalized experience.",
    abilitaMessaggioFinale: 'Enable sending a final message to the trip requester',
    abilitaMessaggioFinaleDescrizione:
      'If enabled, an informational message is sent to the trip requester at the end of the procedure. (textual or with the link in case of automatically generated quotes)',
    abilitato: 'Enabled',
    abilitazioneStepAvanzamento: 'Enable progress steps:',
    active: 'Active',
    aggiungiFarreTreno: 'Add fare',
    aggiungiInformazioniMeteo: 'Add weather information to the message',
    aggiungiInformazioniMeteoDescrizione:
      'If enabled, the message will include weather forecasts for the trip period, providing useful details for planning.',
    aggiungiServizio: 'Add Service',
    aereo: 'Plane',
    aic: 'AIC',
    adminCoefficients: 'Admin Coefficients',
    annulla: 'Cancel',
    attachmentsInEmail: 'Attachments in email',
    auto: 'Car',
    autoTest: 'Auto Test',
    azioni: 'Actions',
    bestBuy: 'Best buy',
    cancellata: 'Canceled',
    caricamento: 'Loading...',
    chat: 'Chat',
    chooseClientGroupClient: 'Client',
    chooseClientGroupDefault: 'Select an option...',
    chooseClientGroupGroup: 'Group',
    clickToPreviewMessage: "Click 'Preview message' to view the body in a new window",
    codice: 'Code',
    codiceCliente: 'Client Code',
    codiceGruppo: 'Group Code',
    communityPanel: 'Community Panel',
    communityPresetsList: 'Community Preset List',
    compagniaTreno: 'Train Company',
    compilareCampiObbligatori: 'Fill in all required fields',
    conferma: 'Confirm',
    confermaInvio: 'Confirm Send',
    conto: 'Account',
    controllaPreventivi: 'Check quotes',
    controllaPreventiviDescrizione:
      "If enabled, the quotes are not sent to the traveler but are created in the 'in progress' state for review",
    conversations: 'Conversations',
    createNew: 'Create New',
    creationDate: 'Creation Date',
    creato: 'Created',
    creazionePreventivo: 'Create quote',
    creazioneTrasfertaServizi: 'Create trip and services',
    currentIsola: 'Current Island',
    datiTrasferta: 'Trip Data',
    datiViaggiatore: 'Traveler Data',
    defaultPreset: 'Default Preset',
    deleteDefaultPresetError: 'Cannot delete the default preset',
    deleteServiceHeader: 'Service Deletion',
    deleteServiceLabel: 'Do you want to delete this service?',
    deleteSuccess: 'Deletion successful',
    descrizione: 'Description',
    distance: 'Distance',
    duplicazioneProfiloTrovato: 'Duplicate traveler profile, homonymy found',
    duration: 'Duration',
    dynamicTest: 'Dynamic Test',
    elaborazioneMessaggioInCorso: 'Processing message in progress',
    elaborazioneMessaggioInCorsoDetails: 'Processing message in progress... wait for completion.',
    error: 'Error',
    errore: 'Error',
    escludiNora: 'Exclude Nora',
    formale: 'Formal',
    formaleDefault: 'formal (default)',
    gestireDaMidoffice: 'Handle from Midoffice',
    gestireManualmente: 'Handle manually from Midoffice',
    gestisciNoraAI: 'Manage Nora AI',
    gruppo: 'Group',
    hotel: 'Hotel',
    hotelAutomatico: 'Automatic hotel',
    hotelAutomaticoDescrizione:
      'If the trip lasts multiple days, the hotel is automatically added.',
    id: 'Id',
    identificativoAnno: 'Year Identifier',
    identificativoPratica: 'Practice Identifier',
    identificativoRichiesta: 'Request Identifier',
    ignorata: 'Ignored',
    impostazionePreventiviGenerati: 'Generated quotes setting',
    impostazioni: 'Settings',
    impostazioniSistema: 'System Settings',
    salvataggioEffettuato: 'Save successful',
    stateDiffDescrizione:
      'If enabled, new conversations will use the State Diff format for process history. Existing conversations are not affected.',
    nessunRecordSistema: 'No system record found in the database.',
    inAttesaDiConferma: 'Awaiting confirmation',
    inEsecuzione: 'In progress',
    inactive: 'Inactive',
    indicateFormalityLevel: 'Indicate formality level',
    indietro: 'Back',
    informale: 'Informal',
    inserireDatiViaggiatore: 'Enter traveler data',
    logicaCameraNonInPenale: 'Non-penalty room logic',
    logicaCameraNonInPenaleDescrizione1:
      'If the hotel is subject to penalties, the first non-penalty room in the same hotel will be searched.',
    logicaCameraNonInPenaleDescrizione2: "If unavailable, the 'best buy' room will be selected.",
    login: 'Login',
    logout: 'Logout',
    mastro: 'Ledger',
    messaggioLink: 'Within the message where it appears:',
    messaggioLinkPreventivi: "-'#link': the link to view the quotes will be inserted",
    messaggioMeteo:
      '-\'#meteo\': weather information will be inserted (if the trip request is within 5 days of departure). To display the phrase, the "Include weather information" flag must be enabled.',
    messaggioPreimpostatoUtente: 'Predefined message for user',
    messaggioPreimpostatoUtenteDescrizione:
      'If selected, the traveler will be notified that their request is being handled by a real operator.',
    messaggioPreventivi: 'Message for quotes:',
    messaggioReindirizzamentoOperatore: 'Message for operator redirection:',
    messaggioReindirizzamentoOperatoreDescrizione:
      'Predefined message to send to the user in case of redirection to the operator',
    modificaViaggiatore: 'Edit traveler',
    moltoFormale: 'Very formal',
    nProposte: 'N. Quotes',
    nessunProfiloTrovato: 'Profile not found',
    nessunProfiloTrovatoTA: 'Traveler and TA link not found',
    profiloMittenteNonTA: 'Sender profile not Travel Arranger',
    nessunServizioInserito: 'No service entered',
    nessunServizioTrenoInserito: 'No train service entered',
    nessunServizioHotelInserito: 'No hotel service entered',
    nessunServizioAereoInserito: 'No flight service entered',
    nessunServizioAutoInserito: 'No car service entered',
    servizioEmptyHint: 'Add it only if requested in the conversation',
    no: 'No',
    noConversationsFound: 'No conversations found',
    noPresetFound: 'No preset found',
    noProfileInfoTrovato: 'Traveler profile not found',
    noraEsclusa: 'Nora Excluded',
    operations: 'Operations',
    operatoreCreazionePratica: 'Practice creation operator',
    outOfOffice: 'Out of office',
    sollecito: 'Follow-up reminder',
    maxAIMessagesReachedInGC: 'Generic content (not a travel request)',
    panelOperations: 'Panel Operations',
    performanceMonitor: 'Performance Monitor',
    passeggeriMultipli: 'Multiple passengers identified',
    pocoFormale: 'Not formal',
    prendiInCarico: 'Take charge',
    presetAbilitato: 'Preset enabled',
    previewMessage: 'Preview Message',
    price: 'Price',
    processes: 'Processes',
    prontoARipartire: 'In progress',
    pubblicaLoStesso: 'Publish anyway',
    pubblicaLoStessoDescrizione:
      'If no results are found for one of the requested services, the quotes are still published',
    raccoltaInformazioni: 'Information gathering',
    ragioneSociale: 'Company Name',
    requester: 'Requester',
    ricercaCliente: 'Client Search',
    ricercaGruppo: 'Group Search',
    ricercaPer: 'Search by',
    richiediMezzoTrasporto: 'Request transport if not specified',
    richiediMezzoTrasportoDescrizione:
      'If enabled, the user will be asked if they want an air or rail service to reach the destination if not already specified.',
    richiestaModificaOCancellazioneTrasferta: 'Request to modify or cancel trip',
    richiestaAggiornamentoTrasferta: 'Request trip information update',
    salva: 'Save',
    selectEmail: 'Select Email',
    selectEmailRedirect: 'Select Email Redirect To Operator',
    selectEnvironment: 'Select Environment',
    selectEnvironmentPlaceholder: 'Select Environment',
    selectFormalityLevel: 'Select formality level',
    selectPID: 'Select PID',
    selectUnit: 'Select unit to execute',
    selectUnitToExecute: 'Select unit to execute',
    selectedDate: 'Selected Date',
    seleziona: 'Select',
    selezionaPrioritaServizio: 'Select service priority',
    selezionaPrioritaTariffa: 'Select train fare priority',
    selezionaRicerca: 'Select search',
    tariffeRimborsabili: 'Refundable Fares',
    tariffeNonRimborsabili: 'Non-Refundable Fares',
    selezionato: 'Selected',
    serviziAereo: 'Air Services',
    serviziAuto: 'Car Services',
    serviziHotel: 'Hotel Services',
    serviziTreno: 'Train Services',
    servizio: 'Service',
    societyList: 'Company List',
    soloCamereNonInPenale: 'Only non-penalty rooms',
    soloCamereNonInPenaleDescrizione:
      'If no non-penalty rooms are found in a hotel, move to the next hotel and repeat up to 10 attempts.',
    sottoConto: 'Sub Account',
    state: 'Status',
    stepNascostoB4B:
      'This step is selected but B4B integration is disabled. Select another step or re-enable B4B.',
    statistics: 'Statistics',
    success: 'Success',
    terminato: 'Completed',
    time: 'Time',
    tipo: 'Type',
    tipologiaTariffa: 'Fare Type',
    titolo: 'Title',
    titoloPreset: 'Preset Title',
    tolleranzaGiorniPenale: 'Penalty Days Tolerance',
    tonoEmail: 'Email tone:',
    tornaIndietro: 'Go Back',
    trasfertaCreata: 'Trip created',
    travellersList: 'Travelers List',
    treno: 'Train',
    usaPresetDefault: 'Use preset as default',
    userList: 'User List',
    users: 'Users',
    verificaConfermaDatiIA: 'Verify and confirm AI-generated data',
    verificaConfermaDatiIADescrizione:
      "After data collection, the operator must review and confirm the information entered by the AI in the 'Operator Form' section.",
    vuoiConfermareDati: 'Do you want to confirm the data?',
    gfRifaiRicerca: 'Search again',
    gfRifaiRicercaTitolo: 'Search again?',
    gfRifaiRicercaConferma:
      'A new search will be run with the form data and the traveller will receive a new quote. Do you want to continue?',
    vuoiPrendereInCarico: 'Do you want to take charge of the conversation?',
    gfAttendiCompletamentoTrasferta: 'Wait for completion to edit the trip',
    gfAvviata: 'Started',
    gfCampi: 'fields',
    gfCampiDaCompilare: 'to fill in',
    gfCampiDaRivedere: 'to review',
    gfCampiObbligatoriDaCompilare: 'required to fill in',
    gfCampiObbligatoriMancanti: 'REQUIRED FIELDS MISSING',
    gfCampiPersonalizzati: 'Custom fields',
    gfSezioneBloccataAgentica:
      'Agentic conversation: this section is not handled by the operator form. Data is not saved from here.',
    gfCampo: 'field',
    gfCampoObbligatorio: 'Required field',
    gfCampoObbligatorioMancante: 'REQUIRED FIELD MISSING',
    gfCaricamentoProfilo: 'Loading profile',
    gfCaricamentoProfiloDettaglio: 'Please wait while the selected traveler data is retrieved…',
    gfCerca: 'Search',
    gfChiudiAnteprima: 'Close preview',
    gfAllegati: 'Attachments',
    gfAllegatoFile: 'File',
    gfAllegatiNelCorpoEmail:
      'Images embedded in the email body (usually shown inline in the message above)',
    gfInCorpoEmail: 'email body',
    gfChatComposerPlaceholder: 'Write a message… Enter to send, Shift+Enter for new line',
    gfChatSend: 'Send message',
    gfAudio: 'Audio',
    gfComprimi: 'Collapse',
    gfContieneErrori: 'contains errors',
    gfContieneErroriTitle: 'Contains errors',
    gfConversazioneNonTrovata: 'Conversation not found',
    gfDaRivedere: 'To review',
    gfEspandi: 'Expand',
    gfImmagine: 'Image',
    gfLetto: 'read',
    gfConversazione: 'Conversation',
    gfConversazioneConNora: 'Conversation with Nora',
    gfConversazionePrecedente: 'Previous conversation',
    gfConversazioneSuccessiva: 'Next conversation',
    gfConv: 'Conv.',
    gfCreaTest: 'Create test',
    gfDa: 'from',
    gfDeleteServiceLabelIrreversible:
      'Do you want to delete this service? This action cannot be undone.',
    gfEliminaServizio: 'Delete service',
    gfElaborazioneInCorso: 'Processing in progress',
    gfErroreAggiornamentoState: 'State update error',
    gfErroreCaricamentoViaggiatore: 'Error loading traveler',
    gfErroreConfermaForm: 'Form confirmation error',
    gfRispostaOperatore: 'Reply from an operator',
    gfErroreCreazioneTest: 'An error occurred while creating the test',
    gfErroreInvioSegnalazione: 'Error sending report',
    gfErroreRicercaViaggiatore: 'Error searching for traveler',
    gfEsclusioneNora: 'Exclude Nora',
    gfEscludiNoraSub: 'Upcoming messages must be handled by mid-office only.',
    gfFiltrato: 'Filtered',
    gfFormInviatoSuccesso: 'Form submitted successfully',
    gfHaPrecompilato: 'prefilled',
    gfHintRicercaViaggiatore: 'Enter first name and last name and/or email to search',
    gfInvia: 'Send',
    gfInviaSegnalazione: 'Send report',
    gfModificaTrasferta: 'Edit trip',
    gfMostraTutteSezioni: 'Show all sections',
    gfMostraSoloSezioniDaRivedere: 'Show only sections with fields to review',
    gfNessunViaggiatoreTrovato: 'No traveler found',
    gfNessunViaggiatoreTrovatoHint: 'Try changing first name, last name or email and search again.',
    gfNoteSegnalazione: 'Report notes',
    gfEmailOperatoreSegnalazione: 'Your email',
    gfEmailOperatoreSegnalazioneHint:
      'We will use this address to reply to you. It will be remembered for future reports.',
    gfEmailOperatoreSegnalazioneNonValida: 'Enter a valid email address',
    gfNuovaTrasferta: 'New trip',
    gfNuovaConversazione: 'New conversation',
    gfOperazioneSuccesso: 'Operation completed successfully',
    gfPerCreareTrasferta: 'to create the trip',
    gfPerModificareConversazione: 'Take charge of the conversation to edit it',
    gfProntaDaCreare: 'Ready to create',
    gfProcessi: 'Processes',
    gfPulisciCampi: 'Clear fields',
    gfRicercaInCorso: 'Searching',
    gfRicercaInCorsoDettaglio: 'Searching for profiles matching your criteria…',
    gfRicercaPuntini: 'Searching…',
    gfRicercaViaggiatore: 'TRAVELER SEARCH',
    gfRimuovi: 'Remove',
    gfRimuoviServizio: 'Remove service',
    gfRisultatoTrovato: 'result found',
    gfRisultatiTrovati: 'results found',
    gfRisolviErroriIn: 'Fix errors in',
    gfSalvaBozza: 'Save draft',
    gfSelezionaViaggiatore: 'Select a traveler',
    gfSegnalazioneInviata: 'Report sent',
    gfSegnalazioneInviataSuccesso: 'The report was sent successfully',
    gfSezioniForm: 'Form sections',
    gfServizio: 'service',
    gfServizi: 'services',
    gfSolaLettura: 'read only',
    gfSoloDaRivedere: 'Review only',
    gfStateAggiornatoSuccesso: 'State updated successfully',
    gfTestCreato: 'Test created',
    gfTestCreatoSuccesso: 'The test was created successfully',
    gfTrasferta: 'Trip',
    gfTuttiCampiObbligatoriCompilati: 'All required fields are filled in.',
    gfVaiAProcessi: 'Go to processes',
    gfViaggiatore: 'Traveler',
    gfVuoiEscludereNora: 'Do you want to exclude Nora from the conversation?',
    gfVuoto: 'Empty',
    // Login
    loginTitle: 'Sign-in to Dashboard',
    loginButton: 'Login',
    poweredBy: 'Powered by',
    // Admin lists
    societyListTitle: 'Company List',
    societyCode: 'Company Code',
    societyNameCol: 'Company Name',
    urlAtlante: 'Atlante Url',
    noSocietyFound: 'No company found',
    deleteSocietyHeader: 'Company Deletion',
    deleteSocietyMessage: 'Do you want to delete this company?',
    userListTitle: 'User List',
    noUserFound: 'No user found',
    deleteUserHeader: 'User Deletion',
    deleteUserMessage: 'Do you want to delete this user?',
    travellersListTitle: 'Travelers List',
    noTravellerFound: 'No traveler found',
    deleteTravellerHeader: 'Traveler Deletion',
    deleteTravellerMessage: 'Do you want to delete this traveler?',
    importTravellers: 'Import travelers',
    phone: 'Phone',
    client: 'Client',
    // Process
    processListTitle: 'Process List',
    agentTurnsTitle: 'Agent turns',
    agentIntent: 'Intent',
    agentFirstToken: 'First reply',
    agentTurnsToQuote: 'Turns to quote',
    quoteSolutions: 'Proposed solutions',
    agentTurnDetail: 'Run detail',
    agentNoSteps: 'No step recorded',
    agentProviderError: 'Provider failure',
    agentProviderAirports: 'Airports not resolved (TravelCore): not a real "no flights"',
    agentProviderDinamico: 'Dinamico did not answer in time',
    agentProviderUnknown: 'External service unavailable',
    agentLimitations: 'Plan limitations',
    agentTrace: 'Turn trace',
    agentTraceUser: 'Traveller message',
    agentTraceReply: 'Nora reply',
    agentTraceInput: 'Input',
    agentTraceOutput: 'Output',
    agentTraceNotRecorded: 'Input and output not recorded: this turn predates the full call log',
    agentTraceTruncated: 'Output too large: not stored in full',
    agentTraceService: 'service',
    agentTraceOrigin: 'origin',
    agentTraceWidgets: 'cards',
    agentTraceProviderCalls: 'provider calls',
    agentTraceRetryable: 'retryable',
    agentTraceNotRetryable: 'not retryable',
    agentTraceNone: 'No trace stored: the turn wrote no messages',
    agentTraceNoTools: 'No tool called',
    agentTraceFromTurn: 'The turn wrote no messages: these are the tools stored on the turn',
    agentTraceSummary: 'Content summary',
    agentTraceLangfuse: 'Open the trace on Langfuse',
    agentTraceReads: 'reads',
    agentTraceAttempts: 'attempts',
    agentTraceOffers: 'offers',
    agentTraceSolutions: 'solutions',
    agentTraceClosed: 'closed',
    agentTraceOpen: 'still running',
    agentTraceOmitted: 'calls over the cap, not shown',
    quoteConfirmed: 'confirmed',
    quoteTotal: 'Total',
    agentTurnsEmpty: 'No agentic turn for this conversation',
    agentTurnsUnavailable: 'Could not read the turns',
    agentTurnTrigger: 'Trigger',
    agentTurnTriggerMessage: 'message',
    agentTurnTriggerAction: 'button',
    agentTurnTriggerWakeup: 'wakeup',
    agentTurnAttempt: 'attempt',
    agentTurnId: 'Turn',
    agentOutcomeCompleted: 'completed',
    agentOutcomeActionSilent: 'silent action',
    agentOutcomeTripSwitched: 'trip switched',
    agentOutcomeTripSwitchWithoutMessage: 'trip switch without a message',
    agentOutcomeCanceled: 'canceled',
    agentOutcomeError: 'error',
    agentErrorSessionLoadFailed: 'Session could not be loaded',
    agentErrorModelTimeout: 'The model did not answer in time',
    agentErrorModelRateLimited: 'The model rate-limited the request',
    agentErrorModelUnavailable: 'The model is unreachable',
    agentErrorModelRejected: 'The model rejected the request',
    agentErrorModelCallLimit: 'Too many model calls',
    agentErrorModelEmptyResponse: 'The model wrote nothing',
    agentErrorCommitFailed: 'The reply could not be saved',
    agentErrorRunError: 'Turn error',
    agentErrorToolServiceUnavailable: 'Tool service unavailable',
    agentTurn: 'Turn',
    agentOutcome: 'Outcome',
    agentModel: 'Model',
    agentCalls: 'Calls',
    agentTokens: 'Tokens',
    agentCost: 'LLM cost',
    agentProviderCost: 'Provider cost',
    agentTotalCost: 'Total cost',
    agentDuration: 'Duration',
    agentQueueState: 'Queue',
    goToForm: 'Go to form',
    pricing: 'Pricing',
    noProcessFound: 'No process found',
    processId: 'Process Id',
    openStep: 'Open step',
    conversation: 'Conversation',
    messages: 'messages',
    readOnly: 'Read only',
    continueExecution: 'Continue execution',
    processErrors: 'Process Errors',
    processStats: 'Process Statistics',
    processComparison: 'Process Comparison',
    // Filters
    filters: 'Filters',
    date: 'Date',
    island: 'Island',
    allIslands: 'All islands',
    allStates: 'All states',
    search: 'Search',
    searchPlaceholder: 'Search by name, email, AIC...',
    searchConversations: 'Global conversations search',
    clearSearch: 'Clear search',
    resetFilters: 'Reset filters',
    removeAllFilters: 'Remove all filters',
    activeFilterOne: 'active',
    activeFilterMany: 'active',
    // Conversation actions
    viewDetail: 'View conversation detail',
    open: 'Open',
    warningConversationPending: 'Warning: conversation pending',
    conversationPending: 'Conversation pending',
    tripsInProgress: 'Trips in progress',
    // Theme
    switchToLight: 'Switch to light theme',
    switchToDark: 'Switch to dark theme',
    // Menu
    dashboardPricing: 'Dashboard Pricing',
    prompts: 'Prompts',
    home: 'Home',
    // ActiveFilterChips
    conversationSingular: 'conversation',
    conversationPlural: 'conversations',
    removeFilterDate: 'Remove date filter',
    removeFilterIsland: 'Remove island filter',
    removeFilterState: 'Remove state filter',
    removeSearch: 'Remove search',
    // Community alerts
    linkMissing: 'Link missing',
    linkMissingDetail: "Missing '#link' in quotes message",
    weatherInfoMissing: 'Weather info missing',
    weatherInfoMissingDetail: "Missing '#meteo' in quotes message",
    titleMissing: 'Title missing',
    selectGroupOrClient: 'Select a group or a client or select as default preset',
    groupNotFound: 'Group not found',
    // Chat
    testChat: 'Test Chat',
    testChatSubtitle: 'Execute a specific unit simulating a complete conversation',
    testParameters: 'Test parameters',
    testConversation: 'Test conversation',
    // Debug Console
    dbcTitle: 'Debug Console',
    dbcSubtitle: 'Full console to test all Nora flows, channels and parameters',
    dbcEnvironment: 'Environment & Identity',
    dbcCodSociety: 'Society Code',
    dbcTomcatCode: 'Tomcat Code',
    dbcUserEmail: 'User Email',
    dbcOperatorEmail: 'Operator Email',
    dbcExecution: 'Execution',
    dbcCallType: 'Call Type',
    dbcUnit: 'Unit / Process',
    dbcSearchUnit: 'Search unit...',
    dbcChannel: 'Communication Channel',
    dbcIsDebug: 'Debug Mode (no DB)',
    dbcPdfQuotes: 'PDF Quotes',
    dbcChannelParams: 'Channel Parameters',
    dbcIdConversazione: 'BTM Conversation ID',
    dbcCodiceCliente: 'Client Code',
    dbcIsola: 'Island',
    dbcWhatsappFrom: 'WhatsApp From',
    dbcWhatsappId: 'WhatsApp ID',
    dbcMailRefId: 'Email Conversation ID',
    dbcMailRefIsola: 'Island Email',
    dbcMailRefSubject: 'Email Subject',
    dbcSubject: 'Subject',
    dbcBody: 'Body',
    dbcAdvanced: 'Advanced',
    dbcCustomJson: 'Custom JSON (overrides payload fields)',
    dbcAudioMessage: 'Audio Message',
    dbcShowPreview: 'Show Payload Preview',
    dbcPayloadPreview: 'Payload Preview',
    dbcNoResponse: 'No response yet. Send a message.',
    dbcSending: 'Sending...',
    dbcCopyJson: 'Copy JSON',
    dbcCopied: 'Copied',
    dbcCopiedJson: 'JSON copied to clipboard',
    dbcCopyFailed: 'Copy failed',
    dbcSentPayload: 'Sent Payload',
    dbcElapsed: 'Response time',
    dbcTokens: 'Tokens',
    dbcConvId: 'Conversation ID',
    dbcOpenConversation: 'Open conversation detail',
    dbcSteps: 'Process Steps',
    dbcMessageToSend: 'Generated message',
    dbcSelectPreset: 'Select preset...',
    dbcLoad: 'Load',
    dbcDelete: 'Delete',
    dbcSave: 'Save',
    dbcCancel: 'Cancel',
    dbcSavePreset: 'Save Preset',
    dbcPresetName: 'Preset name...',
    dbcReset: 'Reset',
    dbcClearChat: 'Clear Chat',
    dbcPresetLoaded: 'Preset loaded',
    dbcPresetSaved: 'Preset saved',
    dbcPresetDeleted: 'Preset deleted',
    campiObbligatori: 'Missing fields',
    attenzione: 'Warning',
    warning: '⚠️',
    yes: 'Yes',
    // Common
    modifica: 'Edit',
    elimina: 'Delete',
    chiudi: 'Close',
    dataInizio: 'Start date',
    dataFine: 'End date',
    giornoPrecedente: 'Previous day',
    giornoSuccessivo: 'Next day',
    dataDa: 'Date from',
    dataA: 'Date to',
    periodo: 'Period',
    tutti: 'All',
    media: 'Average',
    errori: 'Errors',
    nessunDatoDisponibile: 'No data available',
    totale: 'Total',
    processo: 'Process',
    rimuovi: 'Remove',
    secondi: 'seconds',
    minuti: 'minutes',
    eWord: 'and',
    nonTerminato: 'Not completed',
    // Gigi FilterBar
    filtraPerDataIsolaStato: 'Filter by date, island, state or free search',
    // Process/Conversations
    listaConversazioni: 'Conversations List',
    gestioneConversazioniPerData: 'Manage conversations by date',
    filtraPerData: 'Filter by date',
    viaggiatore: 'Traveler',
    conversazioneChiusa: 'Conversation closed',
    erroreChiusuraConversazione: 'Error closing conversation',
    // Process/Editor
    processStepsVisualizer: 'Process Steps Visualizer',
    differenzeStati: 'State Differences',
    statoStep: 'Step state',
    selezionaTipoOperazione: 'Select the type of operation',
    workflow: 'Workflow',
    riesecuzioneUnit: 'Unit re-execution',
    selezionaRieseguiStep: 'Select Re-execute on a step',
    finalState: 'Final State',
    rieseguiUnaUnit: 'Re-execute a unit',
    esecuzioneInCorso: 'Execution in progress…',
    rieseguiUnit: 'Re-execute unit',
    visualizzaErrore: 'View error',
    errorePrefix: 'Error: ',
    logLabel: 'Logs',
    initialState: 'Initial State',
    initialStack: 'Initial Stack',
    finalStack: 'Final Stack',
    inCorso: 'in progress…',
    // Process/ErrorStats
    statisticheErroriPerIntervallo: 'Error statistics by date range',
    intervalloDate: 'Date range',
    processiInErrore: 'Processes with errors',
    unitInErrore: 'Units with errors',
    nonCiSonoErrori: 'No errors found',
    dettaglioProcessiErrore: 'Error processes detail',
    // Process/Performance
    panoramica: 'Overview',
    performanceUnitTab: 'Unit Performance',
    trendAnalisi: 'Trends & Analysis',
    statisticheErrori: 'Error statistics',
    selezionaRange: 'Select a range or use quick presets',
    cacheAggiornata: 'Cache updated',
    erroreBackfillCache: 'Cache backfill error',
    erroreSconosciuto: 'unknown error',
    nessunDatoCache:
      'No data in processOverviewHourly cache for this range. Run "Backfill cache" with the same range (or wait for the cron every 10 minutes for the latest hours).',
    backfillCache: 'Backfill cache',
    aggiornamentoCache: 'Updating cache...',
    backfillCacheStatistiche: 'Statistics cache backfill',
    precomputaDescrizione:
      'Precompute unitStatsHourly and processOverviewHourly (performance and overview cache).',
    preset: 'Preset',
    oreCustom: 'Custom hours',
    rangePagina: 'Page range',
    oreDaRicalcolare: 'Hours to recalculate',
    eseguiBackfill: 'Execute backfill',
    selezioneGrafico: 'Chart selection: use the "Chart" button in the table.',
    caricamentoDatiCache: 'Loading cache data…',
    cache: 'Cache',
    unit: 'unit',
    // Process/Performance DrillDown
    dettaglio: 'Detail:',
    mostraTutti: 'Show all',
    soloLenti: 'Slow only',
    nessunaEsecuzioneTrovata: 'No execution found',
    tempo: 'Time',
    inizio: 'Start',
    conv: 'Conv.',
    // Process/Performance UnitStatsTable
    statistichePerUnit: 'Statistics by Unit',
    unitNelPeriodo: 'units in period',
    legenda: 'Legend',
    cercaUnit: 'Search unit...',
    evidenziazioneRighe: 'Row highlighting',
    tutte: 'All',
    soloEvidenziate: 'Highlighted only',
    soloNonEvidenziate: 'Not highlighted only',
    aggiungiAlGrafico: 'Add to chart',
    drillDown: 'Drill down',
    legendaColoriRegole: 'Color legend and rules',
    nelPeriodo: 'In period',
    deltaVsMediaComplessiva: 'Δ vs overall average',
    colAzioni: 'Actions',
    colN: 'N.',
    colErrPerc: 'Err%',
    colP90Media: 'P90÷Avg',
    colDeltaMedia: 'Δ Avg',
    colDeltaP50: 'Δ P50',
    colDeltaP90: 'Δ P90',
    colDeltaP95: 'Δ P95',
    colDeltaP99: 'Δ P99',
    // Process/Pricing
    costoLlmProcessi: 'LLM cost for conversation processes',
    filtraProvider: 'Filter providers',
    selezionaProviderVisualizzare: 'Select providers to display',
    dettaglioCostiUnit: 'Cost details by unit',
    ripartizioneCosti: 'Cost breakdown',
    perProvider: 'By provider',
    nessunCostoVisualizzare: 'No cost to display for selected providers.',
    // Process/Stats
    statoProcessSteps: 'Process steps status',
    processStepsInErrore: 'Process Steps with errors',
    riepilogoCosti: 'Cost Summary',
    tempiDiEsecuzione: 'Execution times',
    tempoDiEsecuzione: 'Execution time:',
    tempiUnit: 'Unit times',
    min: 'Min',
    max: 'Max',
    sommaUnit: 'Unit sum:',
    ordineEsecuzione: 'Execution order',
    durata: 'Duration',
    // Prompts
    prompt: 'Prompt',
    campo: 'Field',
    spiegazione: 'Explanation',
    nessunPromptInserito: 'No prompt found',
    // Statistics
    selezionaPeriodoAnalisi: 'Select the analysis period or use quick presets',
    selezionaPeriodoLabel: 'Select period:',
    filtraPerIsolaUnitaCliente: 'Filter by island, operational unit or client',
    unitaOperativa: 'Operational unit',
    tutteLeUnitaOp: 'All operational units',
    tuttiIClienti: 'All clients',
    cercaCliente: 'Search client...',
    reset: 'Reset',
    totaleFatturatiNelPeriodo: 'Total invoiced in period',
    nConversazioni: 'n° conversations:',
    costoAConversazione: 'Cost per conversation:',
    gestiteDaNora: 'Handled by Nora',
    escluseConversazioniInoltrate: '* excluding conversations forwarded to operator',
    nessunaConversazioneNelPeriodo: 'No conversations in period',
    costoTotale: 'Total cost',
    conversazioniTotali: 'Total conversations',
    elaborate: 'Processed:',
    inoltrate: 'Forwarded:',
    // Test/AutoTest
    datiChatNonDisponibili: 'Chat data not available',
    importazioneCompletata: 'Import completed',
    conversazioniInserite: 'conversations inserted',
    saltateGiaPresenti: 'skipped (already present)',
    erroreDuranteImportazione: 'Error during import or test execution:',
    autoTestTitle: 'Auto Test',
    autoTestSubtitle: 'Automated tests to validate data extraction from conversations',
    caricamentoInCorso: 'Loading...',
    caricaTestConv: 'Load TESTCONV.json',
    lanciaTuttiITest: 'Run all tests',
    test: 'Test',
    nessunTestTrovato: 'No test found',
    messaggio: 'Message',
    fileAllegati: 'Attached files',
    allegaFile: 'Attach file',
    messaggioBozzaNora: "Nora's draft message: ",
    copia: 'Copy',
    nessunMessaggio: 'No messages',
    leggiJson: 'Read JSON',
    risultatoElaborazione: 'Processing Result',
    step: 'Step',
    combTariffaCompagniaDuplicata: 'This fare and company combination already exists',
    duplicato: 'Duplicate',
    apriChiudiMenu: 'Open or close navigation menu',
    chiudiMenu: 'Close navigation menu',
    nuovaProposta: 'NEW PROPOSAL',
    formatoDataPlaceholder: 'dd/mm/yyyy',
    executionTime: 'Execution Time',
    // Statistics
    stPresetOggi: 'Today',
    stPreset7Giorni: '7 days',
    stPreset30Giorni: '30 days',
    stPresetQuestoMese: 'This month',
    stPreset3Mesi: '3 months',
    stPresetAnno: 'Year',
    stStatusAperta: 'Open',
    stStatusTerminata: 'Ended',
    stStatusGestitaOperatore: 'Handled by operator',
    stChartTrasferteCreate: 'Created trips',
    stChartInoltrateOperatore: 'Forwarded to operator',
    stChartNoraEsclusa: 'Nora excluded',
    stChartConversazioniIgnorate: 'Ignored conversations',
    stChartInCaricoOperatore: 'Assigned to an operator',
    stChartCorrettamenteGestite: 'Correctly handled',
    stCardElaborate: 'Processed conversations',
    stCardConsegnateGestioneManuale: 'Delivered for manual handling',
    stCardEscluseErrori: 'Excluded / errors',
    stDettagliElaborate: 'Details % processed',
    stDettagliInoltrate: 'Details % forwarded',
    stDettagliErrori: 'Details % errors',
    stPercTotale: '% of total conv.',
    stPeriodoSelezionato: 'Selected period:',
    stDashboardEuro: 'Dashboard €',
    stEsportaReport: 'Export Report',
    stSegnaFatturato: 'Mark as invoiced',
    stPieGenerale: 'General',
    stPieOpenPausa: 'Open or paused',
    stPieErroriGestiti: 'Handled errors',
    stPieNoraEsclusaOp: 'Nora excluded by op.',
    stTornaStatistiche: 'Back to Statistics',
    stCostoConversazioniTempo: 'Conversation cost over time',
    stCostoMedioPeriodo: 'Average cost in period:',
    // Process Performance
    pfStatoProcessi: 'Process status',
    pfProcessiLower: 'processes',
    pfProcessiCreatiPerOra: 'Processes created per hour',
    pfNessunDatoNelPeriodo: 'No data in period',
    pfServerCanali: 'Servers & channels',
    pfStatoInTempoReale: 'Real-time status',
    pfOperatori: 'operators',
    pfTokenMin: 'Token/min',
    pfRichiesteMin: 'Requests/min',
    pfInCoda: 'In queue:',
    pfNessunDatoServer: 'No server data available',
    pfConnSuffix: ' conn.',
    pfLegendaRosso: '- **Red**: `Err% > 10` (many errors).',
    pfLegendaGiallo:
      '- **Yellow**: `P90÷Average ≥ ${threshold}` (high variance: slow tail vs average).',
    pfVarianzaP90Media: 'Variance P90 ÷ Average',
    pfRapportoP90Media: 'Ratio between P90 and the arithmetic mean over the selected period.',
    pfValoriAltiCoda: 'High values indicate a slow tail compared to the average time.',
    pfMediaAssolutaColonne: 'Absolute average and Δ columns (ms)',
    pfBaselineCalcolata:
      'The baseline is computed over the last 12 months of hourly cache, excluding the buckets of the selected period.',
    pfColonneDeltaMostrano:
      'The Δ columns show (period − baseline) in ms: positive = slower, negative = faster.',
    pfAndamentoNelTempo: 'Trend over time',
    pfSelezionaUnitTabella: 'Select unit from the table',
    pfSelezionaUnaPiuUnit: 'Select one or more units from the table to display the chart',
    pfNessunDatoNelPeriodoSelezionato: 'No data in the selected period',
    pfEsecuzioniSommaUnit: 'Executions (unit sum):',
    pfMedia: 'average',
    pfAndamentoGiornaliero: 'Daily trend',
    pfSelezionaUnaPiuUnitGiornaliero: 'Select one or more units for the daily chart',
    pfBarreEsecuzioniLinee: 'Bars: executions · Lines: average time ± standard deviation',
    pfEsecuzioni: 'Executions',
    pfTempoMedioMs: 'Average time (ms)',
    pfEsecuzioniSigmaUnit: 'Executions (Σ unit)',
    pfNessunDatoGiornaliero: 'No daily data in period (try a cache backfill or a wider range)',
    pfTempoMedioPerUnit: 'Average time per unit',
    pfSecondiTop: 'Seconds · top',
    pfDistribuzioneTempiProcessi: 'Process time distribution',
    pfOgniPuntoProcesso: 'Each point is a completed process. Click to open details.',
    pfProcessoHash: 'Process #',
    pfTempo: 'Time: ',
    pfNessunProcessoTempo: 'No process with execution time in the period',
    pfVolumeProcessiPanoramica: 'Process volume · daily overview',
    pfTreViste:
      'Three views over the same range: steps per unit, average times, completed processes',
    pfGrafici12Prime:
      'Charts 1 and 2: top ${max} units by volume in the period out of ${total} total; the stack includes "Other units" for the rest.',
    pfStepPerUnitStack: '1 · Steps per unit (daily stack)',
    pfColonneImpilate:
      'Stacked columns: for each day, how many steps were run for each highlighted unit; the grey band sums the other units.',
    pfAltreUnit: 'Other units',
    pfTempoMedioEsecuzionePerUnit: '2 · Average execution time per unit',
    pfLineeMediaGiornaliera:
      'Lines: daily average of step time; vertical bars ± sample standard deviation.',
    pfStepNelGiorno: 'Steps in day (all units):',
    pfProcessCompletatiPerGiorno: '3 · Processes completed per day',
    pfConteggioProcessEndTime:
      'Count of processes with endTime in the day and state 3 (ok) or 5 (error). Days with no closures show 0.',
    pfProcess: 'Process',
    pfProcessCompletati: 'Completed processes',
    pfNessunGiornoNelRange: 'No day in range',
    pfMediaRecente: 'Recent average',
    pfBaseline: 'Baseline',
    pfRapporto: 'Ratio',
    pfErroriRecenti: 'Recent errors: ',
    pfBaselineInfix: ' (baseline: ',
    pfTuttiSistemiNormali: 'All systems operating normally',
    pfAnomalieRilevate: 'anomalies detected',
    pfVistaForm: 'Form view',
    pfVistaJson: 'JSON view',
    pfRieseguiUnit: 'Re-run unit',
    pfConfermaRieseguiUnit:
      'Do you want to re-run this unit with the initial state of the selected step?',
    pfStepPrecedente: 'Previous step',
    pfStepSuccessivo: 'Next step',
    pfRisultatoPrecedente: 'Previous',
    pfRisultatoSuccessivo: 'Next',
    pfCerca: 'Search...',
    pfToken: 'Token ',
    tutteEsecuzioni: 'All',
    nessunErroreTrovato: 'No errors found in the period',
    nomeProcesso: 'Name',
    ggRoomSingola: 'Single (1 adult)',
    ggRoomDoppia: 'Double (2 adults)',
    ggRoomTripla: 'Triple (3 adults)',
    ggComposizioneCamere: 'Room composition',
    ggAggiungiOpzione: 'Add option',
    ggNessunaPreferenzaCamere: 'No room preference (defaults will be used)',
    ggOpzione: 'Option',
    ggCamera: 'Room',
    ggTipoCamera: 'Room type',
    ggCampiPersonalizzati: 'CUSTOM FIELDS',
    ggErroreRicercaCliente: 'Client search error',
    ggPulisci: 'Clear',
    ggNessunaOpzione: 'No options available',
    gfMonthNames: [
      'January',
      'February',
      'March',
      'April',
      'May',
      'June',
      'July',
      'August',
      'September',
      'October',
      'November',
      'December'
    ],
    gfDayNamesShort: ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'],
    admDisabilitato: 'Disabled',
    admSezioneInfoBase: 'Basic information',
    admSezioneImpostazioniAI: 'AI settings',
    admSezioneIntegrazioneB4B: 'B4B integration',
    admSezioneIntegrazioneAtlante: 'Atlante integration',
    admSezioneIntegrazioneDinamico: 'Dynamic integration (PHP and WSDynPkg)',
    admSezioneEmailComunicazioni: 'Email & communications',
    admSezioneGoelett: 'Goelett quote',
    admGoelettPinPreventivo: 'Quote unlock PIN',
    admGoelettPinPreventivoDesc:
      'When on, the Goelett quote opens only with the code sent to the traveller. When off, the page opens from the link.',
    admGoelettScadenzaPreventivo: 'Quote expiry (minutes)',
    admGoelettScadenzaPreventivoDesc:
      'Minutes the quote lives from the search, with the timer on the page. -1 = never expires. Goelett offers last about 15 minutes.',
    admCreaSocieta: 'Create new company',
    admModificaSocieta: 'Edit company',
    admSottotitoloSocieta: 'Configure the settings and integrations for the company',
    admEspandiTutto: 'Expand all',
    admChiudiTutto: 'Collapse all',
    admUsername: 'Username',
    admPassword: 'Password',
    admIdEnvironment: 'Environment Id',
    admRuolo: 'Role',
    admAnagraficaUtente: 'User details',
    admCreaUtente: 'Create user',
    admModificaUtente: 'Edit user',
    admPID: 'PID',
    admEmail: 'Email',
    admTelefono: 'Phone',
    admNome: 'First name',
    admCognome: 'Last name',
    admAnagraficaViaggiatore: 'Traveler details',
    admCreaViaggiatore: 'Create traveler',
    admModificaViaggiatore: 'Edit traveler',
    admImportaViaggiatori: 'Import travelers',
    admSottotitoloImport: 'Upload a CSV file to bulk-import the travelers registry',
    admCaricaCSV: 'Upload CSV',
    admCaricaSuDB: 'Upload to DB',
    admAnteprimaFile: 'Uploaded file preview',
    admViaggiatoriDaImportare: ' travelers to import',
    admNienteDaVisualizzare: 'Nothing to display',
    admTutorialUpload: 'Upload a CSV file containing the travelers to add.',
    admTutorialStruttura: 'The CSV file must be structured as follows: ',
    admTutorialIntestazione:
      'The first header row must contain the fields pid, email, phone number, client code.',
    admTutorialDati: 'From the second row onward, enter the data for the various clients.',
    admTutorialEsempio: 'Here is a sample file to edit and upload.',
    admScarica: 'Download',
    admAggiornaLabelErrori: 'Update error labels',
    admAggiornaLabelErroriHint:
      'Update the error label to categorize them with the latest version of the classifier.',
    admAggiornaErroriTAProfile: 'Update TA profile errors',
    admAggiornaErroriTAProfileHint:
      'Recompute errors related to the TA profile (travelers registry).',
    admAggiornaErroriOutOfOffice: 'Update out-of-office errors',
    admAggiornaErroriOutOfOfficeHint: 'Update the classification of out-of-office emails.',
    admSottotitoloPanel: 'Data maintenance operations',
    admOperazioniManutenzione: 'Maintenance operations',
    admSottotitoloManutenzione: 'Run them carefully · irreversible actions',
    admEsegui: 'Run',
    controlliIA: 'AI Checks',
    cpDuplica: 'Duplicate',
    cpSottotitoloPanel: 'Community Panel · Nora configuration preset',
    cpAggiungiFiltri: 'Add filters',
    cpAggiungiFiltro: 'Add filter…',
    cpNRimborsabili: 'No. refundable',
    cpNNonRimborsabili: 'No. non-refundable',
    cpInserisciParametroRicerca: 'Enter at least one search parameter',
    cpErroreRicercaGruppo: 'Error searching for the group',
    cpGruppoNonTrovato: 'Group not found',
    cpPresetEsistente: 'Existing preset',
    cpGruppoConfigurazioneEsistente: 'This group already has a saved configuration',
    cpClienteNonTrovato: 'Client not found',
    cpClienteConfigurazioneEsistente: 'This client already has a saved configuration',
    cpCreaPreset: 'Create Community Preset',
    cpModificaPreset: 'Edit Community Preset',
    mxElencoPrompts: 'Prompts list',
    mxPromptLLMSubtitle: 'LLM prompts used to extract conversation fields',
    mxCompilaCampi: 'Fill in all fields',
    mxPromptCreato: 'Prompt created',
    mxCreazionePrompt: 'Create Prompt',
    mxModificaPrompt: 'Edit Prompt',
    mxConfigurazionePrompt: 'Prompt configuration',
    mxChiaveCampoJson: 'JSON field key',
    mxSpiegazioneCampo: 'Field explanation (basePrompt)',
    mxValidaTestLabel: 'Do you want to validate the test? The autotest result will be updated',
    mxTestIdPrefix: 'Test ID: ',
    mxValidazioneEstrazione: 'Conversation data extraction validation',
    mxTestPrecedente: 'Previous test',
    mxTestSuccessivo: 'Next test',
    mxEseguiTest: 'Run Test',
    mxValidaTest: 'Validate Test',
    mxConversazioneTest: 'Test conversation',
    mxMessaggiSuffix: ' messages',
    mxRisultatoAtteso: 'Expected result',
    mxRisultatoOttenuto: 'Obtained result',
    mxInEsecuzione: 'Running',
    mxImpostazioneCoefficienti: 'Search coefficients setting',
    mxImpostaCoefficientiPer: 'Set coefficients for ',
    mxTipoPreventivo: 'Quote type ',
    // Demo Goelett
    dgTitle: 'Nora — Goelett Integration',
    dgSubtitle: 'Demo flow: email → AI processing → interactive quote',
    dgPresetLoaded: 'Goelett preset loaded',
    dgEmailPanel: 'Incoming email',
    dgFrom: 'From',
    dgSubject: 'Subject',
    dgBody: 'Email body',
    dgBodyPlaceholder:
      'Write the email content...\n\ne.g. Good morning, I need a trip\nMilan → London on October 15,\nreturn October 18.\nI prefer a direct flight if possible.\nThank you',
    dgSend: 'Send email to Nora',
    dgSending: 'Sending...',
    dgContinue: 'Reply',
    dgNewConversation: 'New conversation',
    dgReset: 'Reset conversation',
    dgConversation: 'Nora Conversation',
    dgStatusWaiting: 'Waiting',
    dgStatusLoading: 'Processing...',
    dgStatusSuccess: 'Connected',
    dgStatusError: 'Error',
    dgEmpty: 'No messages yet. Send an email to get started.',
    dgAsyncMessage: '[Async] Request received. Processing...',
    dgMissingBody: 'Please write the email content',
    dgSendError: 'Error sending the message',
    dgMenuLabel: 'Goelett Demo',
    dgFromPlaceholder: 'email@example.com',
    dgSubjectPlaceholder: 'e.g. Travel request Milan - London',
    dgOpenConversation: 'Open conversation',
    dgPresetLabel: 'Preset',
    dgPresetGroupClient: 'Client configurations',
    dgPresetGroupSaved: 'Saved presets',
    dgSavedPreset: 'Saved preset'
  },
  FR: {
    cnMultiTratta: 'Voyages à plusieurs étapes',
    cnMultiTrattaDesc:
      'Un circuit comme Milan-Paris-Londres-Milan devient une seule demande : chaque vol avec son trajet et un hôtel par étape. Désactivé, Nora propose de procéder un trajet à la fois. Non disponible avec Goelett, qui recherche un seul service par type.',
    // ── Import dati (pagina admin) — prefisso `id` ──────────────────────────
    idTitolo: 'Import de données',
    idSottotitolo:
      'Jeux de données externes utilisés par Nora : mise à jour par le bouton ou automatiquement, à intervalles.',
    idRotteTitolo: 'Routes aériennes',
    idRotteTesto:
      'Vols directs entre aéroports, extraits de flightsfrom.com : utilisés par le planificateur. Un passage complet dure quelques heures.',
    idGeoTitolo: 'Villes (GeoNames)',
    idGeoTesto:
      "Localités d'au moins 1 000 habitants et leurs noms en plusieurs langues : Nora reconnaît que «Milan» et «Milano» sont le même lieu.",
    idAvviaOra: 'Lancer maintenant',
    idAvviato: 'Import lancé',
    idFerma: 'Arrêter',
    idFermaInviato: 'Arrêt demandé',
    idNonDisponibile: 'Import non disponible sur cette installation.',
    idInCorso: 'en cours',
    idCompletato: 'terminé',
    idFallito: 'échoué',
    idFermato: 'arrêté',
    idInterrotto: 'interrompu',
    idDataset: 'Jeu de données',
    idRighe: 'lignes',
    idVuoto: 'vide',
    idAggiornato: 'Mis à jour le',
    idUltimoImport: 'Dernier import',
    idProssimo: 'Prochain',
    idManuale: 'manuel',
    idPianificato: 'planifié',
    idAutomatico: 'Mettre à jour automatiquement',
    idOgni: 'tous les',
    idGiorno: 'jour',
    idGiorni: 'jours',
    idStorico: 'Historique',
    idStoricoSotto:
      "Derniers imports, manuels et planifiés. Cliquez sur une ligne avec un message pour l'ouvrir.",
    idNessunImport: "Aucun import pour l'instant.",
    idColQuando: 'Quand',
    idColDataset: 'Jeu de données',
    idColAvvio: 'Lancé par',
    idColStato: 'État',
    idColDurata: 'Durée',
    idColRighe: 'Lignes',
    aeFerma: "Arrêter l'exécution",
    aeFermata: 'arrêtée',
    aeFermaFallito: 'Exécution non arrêtée',
    aeNuovaRun: 'Nouvelle exécution',
    aeChiudiForm: 'Fermer',
    aeDettaglio: "Détail de l'exécution",
    aeScegliRun: 'Choisissez une exécution dans la liste pour voir le détail.',
    // ── Eval dell'agente (pagina admin) — prefisso `ae` ──────────────────────
    aeTitolo: "Évaluation de l'agent",
    aeSottotitolo:
      "Lancez les scénarios du dépôt sur un environnement et comparez les exécutions : ce qui change quand le harness ou le modèle change, et la fiabilité de l'agent.",
    aeLancia: 'Lancer une exécution',
    aeLanciaSotto:
      'Les scénarios sont des fichiers JSON dans Executor/API/agentEval/scenari : ils se modifient là.',
    aeEnvironment: 'Environnement',
    aeScenari: 'Scénarios',
    aeTutti: 'tous',
    aeTuttiApplicabili: 'tous ceux qui tournent ici',
    aeScegliEnvPrima: 'Choisissez un environnement : son flux décide quels scénarios ont du sens.',
    aeFlussoEnv: "Flux de l'environnement",
    aeFlussoRun: "Flux de l'exécution",
    aeFlussoDellEnvironment: "celui de l'environnement",
    aeFlussoOverride:
      'La conversation simulée naît avec ce flux. La configuration Nora ne change pas.',
    aeSoloEsclusivi: 'Seulement les scénarios écrits pour ce flux',
    aeCapabilityAccese: 'capabilities actives',
    aeNessunaCapability: 'aucune capability',
    aeNonApplicabili: 'Ne tournent pas sur cet environnement',
    aeSoloPer: 'seulement pour',
    aeCapabilitySpenta: 'capability désactivée',
    aeNonAgentico: 'environnement sans mode agentique pour l’app',
    aeRichiedeViaggio: 'vérifie des données de voyage, que cet environnement n’a pas',
    aePassaggi: 'Étapes',
    aeControlli: 'Contrôles',
    aeCopione: 'Script',
    aeAttesa: 'coup attendu',
    aeVietata: 'coup interdit',
    aeRifiutoAtteso: 'refus attendu',
    aeNonValido: 'Invalide :',
    aeRipetizioni: 'Répétitions',
    aeRipetizioniScenario: 'celles du scénario',
    aeRicerca: 'Recherche',
    aeRicercaFinta: "Simulée (mesure l'agent)",
    aeRicercaReale: 'Réelle (fournisseurs réels, lecture seule)',
    aeNome: "Nom de l'exécution",
    aeNomeEsempio: 'ex. aller simple après le nouveau prompt',
    aeRipeti: 'Répéter',
    aeCosto: 'coût',
    aeCostoTotale: 'Coût des exécutions',
    aeCostoTotaleSotto:
      'Somme estimée, répartie par modèle et fournisseur, sur la période choisie.',
    aeCostoSenzaDettaglio:
      'Les exécutions de cette période n’ont pas le détail par modèle et fournisseur.',
    aeCostoDettaglio: 'Détail du coût',
    aePerRun: 'par exécution',
    aePerPasso: 'par pas',
    aeErroriProvider: 'erreurs du fournisseur',
    aeRossiAgente: 'échecs de l’agent',
    aeUltimoGiorno: 'Dernier jour',
    aeUltimi7: '7 jours',
    aeUltimi30: '30 jours',
    aeTutto: 'Tout',
    aeNessunaInCorso: 'aucune en cours',
    aePassi: 'Pas exécutés',
    aeProveClassificate: 'Essais avec résultat connu',
    aeNonClassificati: 'pas historiques non classés',
    aeScenariSaltati: 'Scénarios ignorés',
    aeProveSaltate: 'essais ignorés',
    aeHarness: 'Harness',
    aeTuttiHarness: 'Toutes les versions',
    aeSenzaVersione: 'sans version',
    aeFirma: 'signature',
    aeGuidaApri: 'Comprendre les résultats',
    aeGuidaTitolo: 'Comprendre les résultats',
    aeGuidaIntro:
      'Cette page montre trois unités différentes : exécutions, scénarios et essais. Leurs nombres ne s’additionnent pas.',
    aeGuidaSogliaTitolo: 'Au-dessus et en dessous du seuil',
    aeGuidaSoglia:
      'La personne qui écrit le scénario fixe le seuil dans son fichier JSON. S’il est absent, la valeur est 80 % pour les conversations et 90 % pour les décisions. Le taux est essais réussis ÷ essais comptabilisés : PASS s’il atteint le seuil, FAIL s’il est inférieur. Exemple avec un seuil de 80 % :',
    aeGuidaEsempioPass: 'atteint le seuil',
    aeGuidaEsempioFail: 'sous le seuil',
    aeGuidaSogliaNota:
      'Un scénario FAIL peut contenir des essais réussis. Sans essai valide, le scénario ne passe pas.',
    aeGuidaConteggiTitolo: 'Ce que compte chaque colonne',
    aeGuidaVerdi: 'Essais où tous les contrôles passent ou la décision attendue est correcte.',
    aeGuidaRossi: 'Essais valides qui échouent à un contrôle ou à la décision attendue.',
    aeGuidaErrori:
      'Essais interrompus par une erreur technique, comme un délai dépassé ; ce ne sont pas des échecs de l’agent.',
    aeGuidaNonValidi:
      'Décisions dont le scénario préparatoire n’a pas produit le refus attendu. Exclues du taux du scénario.',
    aeGuidaSaltati:
      'Scénarios inapplicables au flux ou aux capacités. Cette colonne compte des scénarios, pas des répétitions.',
    aeGuidaAvanzamento:
      'Essais effectués plus répétitions ignorées, sur le total prévu. Un scénario ignoré fait avancer l’exécution sans essai.',
    aeGuidaStorico:
      'Pour les anciennes exécutions, les échecs et répétitions ignorées ne sont pas reconstructibles : — signifie indisponible.',
    aeAltriFiltri: 'Autres filtres',
    aeAzzeraFiltriExtra: 'Effacer ces filtres',
    aeColQuando: 'Quand',
    aeColNome: 'Nom',
    aeColEnv: 'Environnement',
    aeColFlusso: 'Flux',
    aeColPassi: 'Progression',
    aeColVerdi: 'Essais réussis',
    aeColErrori: 'Erreurs techniques',
    aeColNonValidi: 'Invalides',
    aeColRossi: 'Essais échoués',
    aeColCosto: 'Coût',
    aeColEsito: 'Résultat',
    aeColScenario: 'Scénario',
    aeColQuota: 'Taux',
    aeColFallite: 'Essais échoués',
    aeColSottoSoglia: 'Exécutions sous le seuil',
    aeColRun: 'Exécutions',
    aeColCade: 'Où ça échoue',
    aeScenariEseguiti: 'résultats de scénario (exécution × scénario)',
    aeSottoPieno: 'sous 100 %',
    aeProveFallite: 'd’essais échoués',
    aeDiCuiInterrotte: 'coupés par le fournisseur',
    aeNessunaDifficolta: 'Aucun scénario sous 100 % sur cette période.',
    aeInCorso: 'en cours',
    aeInCoda: 'en file',
    aeCompletata: 'terminée',
    aeCerca: 'Chercher par nom',
    aeTuttiEnv: 'Tous les environnements',
    aeTuttiFlussi: 'Tous les flux',
    aeTuttiStati: 'Tous les résultats',
    aeDal: 'Du',
    aeAl: 'Au',
    aeNessunaFiltrata: 'Aucune exécution avec ces filtres.',
    aePaginaPrima: 'Page précédente',
    aePaginaDopo: 'Page suivante',
    aeAnalisi: 'Scénarios en difficulté',
    aeApriDettaglio: 'Ouvrir le détail',
    aeAnalisiSotto:
      'Exécutions terminées de la période : un scénario peut apparaître dans plusieurs exécutions. Les taux utilisent les essais admissibles; les scénarios ignorés et les décisions invalides sont exclus.',
    aeAvvia: "Lancer l'exécution",
    aeEnvironments: 'Environnements',
    aeEnvironmentsAiuto:
      'Choisissez-en un ou plusieurs. Avec plusieurs environnements, les scénarios communs ne tournent que sur le premier choisi, ceux de flux sur chacun.',
    aePrimoComuni: 'communs ici',
    aeCatalogoEnvNonLetto:
      "Le catalogue d'un environnement n'a pas pu être lu : vérifiez sa Configuration Nora.",
    aePreset: 'Sélection rapide',
    aePreset_tutti: 'Tous',
    aePreset_comuni: 'Communs seulement',
    aePreset_flussi: 'Flux seulement',
    aePreset_falliti: 'Échoués à la dernière exécution',
    aeNessunFallito: 'Aucun scénario sous le seuil dans la dernière exécution terminée',
    aeComuni: 'Communs',
    aeComuniAiuto:
      'Ils ne dépendent pas du flux : dans une campagne ils tournent une fois, sur le premier environnement.',
    aeDiFlusso: 'De flux',
    aeDiFlussoAiuto:
      'Ils dépendent du flux : ils tournent sur chaque environnement choisi dont le flux est le leur.',
    aeNonGiraQui: 'ne tourne pas sur les environnements choisis',
    aeRicercaRealeAvviso:
      'Utilise les vrais fournisseurs : coûte plus et peut échouer pour des causes externes (VPN, disponibilité).',
    aeTrascrizioni:
      'Enregistrer aussi les transcriptions complètes dans des fichiers (agentEval/trascrizioni). Les exécutions rouges restent lisibles ici.',
    aeAvviaCampagna: 'Lancer la campagne',
    aeNessunoScelto: 'Choisissez au moins un environnement',
    aeMinuti: 'min',
    aeNienteDaLanciare: 'Aucun scénario ne tourne sur les environnements choisis',
    aeCampagnaAvviata: 'Campagne lancée',
    aeCampagnaParziale: 'Campagne lancée en partie',
    aeCampagna: 'Campagne',
    aeStrumenti: 'Outils',
    aeRipetiFalliti: 'Relancer les échoués',
    aeSottoSoglia: 'Sous le seuil',
    aeSopraSogliaTitolo: 'Au-dessus du seuil',
    aeSaltatiTitolo: 'Ignorés',
    aeRunInCorso: 'Exécution en cours',
    aeRun: 'Exécutions',
    aeRunSotto:
      'Progression = exécutions effectuées + répétitions ignorées. Les anciennes exécutions ne distinguent pas toutes les catégories.',
    aeNessunaRun: 'Aucune exécution.',
    aeFallita: 'échouée',
    aeElimina: "Supprimer l'exécution",
    aeEliminaConferma: "Supprimer l'exécution",
    aeRunNonEliminata: 'Exécution non supprimée',
    aeRunAvviata: 'Exécution lancée',
    aeEsecuzioni: 'exécutions',
    aeRunNonAvviata: 'Exécution non lancée',

    aeExecutorNonRaggiungibile: 'Executor injoignable',
    aeRunIllegibile: 'Exécution illisible.',
    aeFlusso: 'flux',
    aeSopraSoglia: 'scénarios atteignant le seuil',
    aeSoglia: 'seuil',
    aePrima: 'avant',
    aeSaltato: 'IGNORÉ',
    aeInterrotta: 'interrompue',
    aeNessunTool: 'aucun outil',
    aeRichiestaFinale: 'Demande finale',
    aeNonConta: 'ne compte pas (script sans le refus attendu)',
    gf45Porte: '4-5 portes',
    gfAllInclusive: 'All Inclusive',
    gfAndataRitorno: 'Aller-retour',
    gfAutomatico: 'Automatique',
    gfBedAndBreakfast: 'Bed and Breakfast',
    gfBenzina: 'Essence',
    gfCena: 'Dîner',
    gfCentrale: 'Milieu',
    gfCompact: 'Compact',
    gfCorridoio: 'Couloir',
    gfCrossover: 'Crossover',
    gfDiesel: 'Diesel',
    gfEconomy: 'Économique',
    gfElettrica: 'Électrique',
    gfFinestrino: 'Hublot',
    gfFormatoData: 'Format dd/mm/yyyy',
    gfFullSize: 'Grande taille',
    gfGpl: 'GPL',
    gfIbrida: 'Hybride',
    gfIntermediate: 'Intermédiaire',
    gfLuxury: 'Luxe',
    gfManuale: 'Manuelle',
    gfMezzaPensione: 'Demi-pension',
    gfMini: 'Mini',
    gfMonovolume: 'Monospace',
    gfNo: 'Non',
    gfNonPrecedentePartenza: 'Ne peut pas être antérieur au départ',
    gfNonSpecificato: 'Non spécifié',
    gfPensioneCompleta: 'Pension complète',
    gfPranzo: 'Déjeuner',
    gfPremium: 'Premium',
    gfSi: 'Oui',
    gfSolaAndata: 'Aller simple',
    gfSoloNumeri: 'Chiffres uniquement',
    gfSoloStanza: 'Chambre seule',
    gfSportiva: 'Sportive',
    gfStandard: 'Standard',
    gfStationWagon: 'Break',
    gfSuv: 'SUV',
    gfVan: 'Van',
    mxAllInclusive: 'All Inclusive',
    mxBedAndBreakfast: 'Bed and Breakfast',
    mxCenaInclusa: 'Dîner inclus',
    mxCoeffDistanza: 'Coefficient de distance',
    mxCoeffDurata: 'Coefficient de durée',
    mxCoeffScostamento: "Coefficient d'écart",
    mxGruppoBase: 'Base',
    mxGruppoCorporate: 'Corporate',
    mxGruppoLivelliHotel: 'Niveaux de programme hôtelier',
    mxGruppoTrattamento: 'Formule',
    mxLivello0: 'Niveau 0',
    mxLivello1: 'Niveau 1',
    mxLivello2: 'Niveau 2',
    mxLivello3: 'Niveau 3',
    mxMezzaPensione: 'Demi-pension',
    mxPensioneCompleta: 'Pension complète',
    mxPranzoIncluso: 'Déjeuner inclus',
    mxRoomOnly: 'Chambre seule',
    mxTariffaAgenzia: 'Tarif agence',
    mxTariffaCliente: 'Tarif client',
    mxTariffaPubblica: 'Tarif public',
    pfPreset24h: '24 dernières heures',
    pfPreset30Giorni: '30 derniers jours',
    pfPreset6h: '6 dernières heures',
    pfPreset7Giorni: '7 derniers jours',
    pfPresetUltimaOra: 'Dernière heure',
    pfStatoAttenzione: 'Avertissement',
    pfStatoCritico: 'Critique',
    pfStatoNormale: 'Normal',
    pfStepCompletato: 'Terminé',
    admAbilitazioneArrivoEntro: "Activer l'arrivée avant",
    admAbilitazioneArrivoEntroDesc:
      "Permet de définir l'heure de départ des services à 00:01 si elle n'est pas spécifiée mais que l'indication d'arrivée avant est présente...",
    admAbilitazioneAtlante: 'Activer Atlante',
    admAbilitazioneAtlanteDesc: "Active l'utilisation d'Atlante.",
    admAbilitazioneB4B: 'Activer B4B',
    admAbilitazioneB4BDesc: "Active l'intégration avec le système B4B",
    admAbilitazioneCarnet: 'Activer le carnet',
    admAbilitazioneCarnetDesc: "Active l'utilisation des carnets.",
    admAbilitazioneMidOffice: 'Activer Mid Office',
    admAbilitazioneMidOfficeDesc: "Active l'utilisation de Mid Office.",
    admAbilitazioneRimborsabile: 'Activer la gestion remboursable',
    admAbilitazioneRimborsabileDesc:
      'Active la gestion des trains remboursables ou non remboursables.',
    admBloccaEmailErroreOperatori: "Bloquer l'envoi d'e-mails d'erreur aux opérateurs",
    admBloccaEmailErroreOperatoriDesc: "Bloque l'envoi d'e-mails d'erreur aux opérateurs",
    admCodiceMastroCliente: 'Code maître client',
    admCodiceMastroClienteDesc:
      'Code maître pour identifier le client (ex. : 20 1 2 127, où 20 est le maître)',
    admCodiceOperatore: 'Code opérateur',
    admCodiceOperatoreDesc: 'Code opérateur pour la recherche dans les tables génériques ATP',
    admCodiceProvenienza: 'Code de provenance',
    admCodiceProvenienzaDesc: 'Code de provenance pour les tables de billets ATP',
    admCodiceSocieta: 'Code société',
    admCodiceSocietaDesc: 'Code unique pour identifier la société',
    admCodiceTomcat: 'Code Tomcat',
    admCodiceTomcatDesc: 'Code du serveur Tomcat associé',
    admConfigurazioneEmailReport: 'Configuration des e-mails de rapport',
    admConfigurazioneEmailReportDesc:
      'Configuration JSON pour les identifiants et les paramètres d\'envoi d\'e-mails depuis la plateforme. Exemple : {"host": "smtp.gmail.com", "port": 587, "secure": false, "auth": {"user": "email@example.com", "pass": "password"}}',
    admElencoEmailCCReport: 'Liste des e-mails en CC pour les rapports (séparés par des virgules)',
    admElencoEmailCCReportDesc:
      'Liste des e-mails en CC pour les rapports (séparés par des virgules)',
    admEstrapolazioneCampi1a10: "Activer l'extraction AI des champs 1 à 10",
    admEstrapolazioneCampi1a10Desc: "Active l'extraction AI pour les champs 1 à 10",
    admFlussoRichiestaInfoGeneriche: "Activer le flux de demande d'informations génériques",
    admFlussoRichiestaInfoGenericheDesc: "Active le flux de demande d'informations génériques",
    admGestioneAuto: 'Activer la gestion des voitures',
    admGestioneAutoDesc: 'Active la gestion des voitures de location.',
    admGestioneGruppiPasseggeri: 'Activer la gestion des groupes de passagers',
    admGestioneGruppiPasseggeriDesc: 'Active la gestion des groupes de passagers.',
    admGoogleApiKey: 'Clé API Google',
    admGoogleApiKeyDesc: 'Clé API pour les services Google',
    admInviaNotificaFormDati: 'Envoyer la notification de complétion du formulaire de données',
    admInviaNotificaFormDatiDesc: 'Envoie une notification de complétion du formulaire de données',
    admInvioEmailRiassuntivoOperatore: "Activer l'envoi d'e-mail récapitulatif à l'opérateur",
    admInvioEmailRiassuntivoOperatoreDesc: "Active l'envoi d'e-mails récapitulatifs aux opérateurs",
    admLetturaAllegatiEmail: 'Activer la lecture des pièces jointes des e-mails',
    admLetturaAllegatiEmailDesc: 'Active la lecture des pièces jointes des e-mails',
    admLetturaOggettoEmail: "Activer la lecture de l'objet des e-mails",
    admLetturaOggettoEmailDesc:
      "Active la lecture et l'analyse de l'objet de l'e-mail et la fusion éventuelle avec les données extraites du corps du message.",
    admLetturaStoricoViaggiatore: "Activer la lecture de l'historique du profil voyageur",
    admLetturaStoricoViaggiatoreDesc: "Active la lecture de l'historique du profil voyageur",
    admNomeDbB4B: 'Nom de la base B4B',
    admNomeDbB4BDesc: 'Nom de la base de données B4B',
    admNomeDbDinamico: 'Nom de la base Dynamique',
    admNomeDbDinamicoDesc: 'Nom de la base de données Dynamique',
    admNomeDesc: 'Nom identifiant de la société',
    admNumeroMassimoMessaggiAI: 'Nombre maximum de messages AI',
    admNumeroMassimoMessaggiAIDesc: 'Nombre maximum de messages AI autorisés (par défaut : 5)',
    admPasswordB4B: 'Mot de passe B4B',
    admPasswordB4BDesc:
      'Mot de passe pour la base de données B4B (mot de passe chiffré avec un script externe)',
    admPasswordDbDinamico: 'Mot de passe base Dynamique',
    admPasswordDbDinamicoDesc:
      'Mot de passe pour la base de données Dynamique (mot de passe chiffré avec un script externe)',
    admPasswordJavaWsDinamico: 'Mot de passe Java WS Dynamique',
    admPasswordJavaWsDinamicoDesc:
      'Mot de passe pour DynJavaWS (mot de passe chiffré avec un script externe)',
    admPasswordWS: 'Mot de passe WS',
    admPasswordWSDesc:
      "Mot de passe pour l'authentification du service web (mot de passe chiffré avec un script externe)",
    admPortaB4B: 'Port B4B',
    admPortaB4BDesc: 'Port de la base de données B4B',
    admPortaDbDinamico: 'Port base Dynamique',
    admPortaDbDinamicoDesc: 'Port de la base de données Dynamique',
    admPresaInCarico: 'Activer la prise en charge',
    admPresaInCaricoDesc: 'Active la possibilité de prendre en charge une conversation',
    admPuliziaPPI: 'Activer le nettoyage PPI',
    admPuliziaPPIDesc: 'Active le nettoyage des informations personnelles identifiables (PPI).',
    admResocontoOperatore: 'Activer le rapport opérateur',
    admResocontoOperatoreDesc:
      "Active la création du rapport de transfert à envoyer à l'opérateur en cas de succès comme en cas d'erreur.",
    admSaltoRicercaTreni: 'Ignorer la recherche de trains sur Dynamique',
    admSaltoRicercaTreniDesc: 'Ignore la recherche de trains sur Dynamique',
    admSanitizzazioneEmailSenzaAI: 'Activer la sanitisation des e-mails sans AI',
    admSanitizzazioneEmailSenzaAIDesc: "Active la sanitisation des e-mails sans utiliser l'AI",
    admTargetPacchettoDinamico: 'Cible du forfait dynamique',
    admTargetPacchettoDinamicoDesc: 'Cible du forfait dynamique (Test/Production)',
    admTelefonoWhatsapp: 'Téléphone WhatsApp',
    admTelefonoWhatsappDesc: 'Numéro de téléphone pour WhatsApp',
    admUrlAtlante: 'URL Atlante',
    admUrlAtlanteDesc: 'URL du service Atlante pour les réservations',
    admUrlB4B: 'URL B4B',
    admUrlB4BDesc: 'URL de la base de données B4B',
    admUrlDbDinamico: 'URL base Dynamique',
    admUrlDbDinamicoDesc: 'URL de la base de données Dynamique',
    admUrlDinamicoPhp: 'URL PHP Dynamique',
    admUrlDinamicoPhpDesc: 'URL du service PHP Dynamique',
    admUrlJavaWsDinamico: 'URL Java WS Dynamique',
    admUrlJavaWsDinamicoDesc: 'URL du service Java WS Dynamique',
    admUtenteB4B: 'Utilisateur B4B',
    admUtenteB4BDesc: "Nom d'utilisateur pour la base de données B4B",
    admUtenteDbDinamico: 'Utilisateur base Dynamique',
    admUtenteDbDinamicoDesc: "Nom d'utilisateur pour la base de données Dynamique",
    admUtenteJavaWsDinamico: 'Utilisateur Java WS Dynamique',
    admUtenteJavaWsDinamicoDesc: "Nom d'utilisateur pour Dynamic Java REST",
    admUtenteWS: 'Utilisateur WS',
    admUtenteWSDesc: "Nom d'utilisateur pour l'authentification du service web",
    admVisualizzaBottoneReport: 'Afficher le bouton de rapport',
    admVisualizzaBottoneReportDesc: 'Affiche le bouton pour les rapports',
    cerca: 'Rechercher...',
    conversazioni: 'Conversations',
    cpCompilatoDaNora: 'complété par Nora',
    data: 'Date',
    errAeroportoIATAnotFound: 'Aéroport IATA introuvable',
    errAttachmentsInEmail: "Pièces jointes internes dans l'e-mail",
    errCanceled: "Annulé par l'opérateur",
    errCarnetError: 'Erreur de recherche carnet',
    errDefault: 'Autre',
    errDepartureCarJsonNotFound: 'Données de départ/arrivée voiture introuvables',
    errDestinationHotelNotFound: 'Destination hôtel introuvable',
    errDuplicazioneProfiloTrovato: 'Profil en double trouvé',
    errEmailMancanteProfiloViaggiatore: 'E-mail manquante sur le profil voyageur',
    errErroreCreazionePreventivi: 'Erreur de création des devis',
    errErroreCreazioneServizi: 'Erreur de création des services',
    errErroreCreazioneTrasferta: 'Erreur de création du transfert',
    errErroreElaborazioneServizi: 'Erreur de traitement des services',
    errErroreRicercaDinamico: 'Erreur de recherche Dynamique',
    errErroreRicercaDinamicoVuoto: 'Aucun résultat de recherche de service',
    errErrorSavingAttachments: "Erreur lors de l'enregistrement des pièces jointes",
    errGenericError: 'Erreur générique',
    errLoopError: 'Erreur de boucle',
    errMaxAIMessagesReachedInGC: 'Contenu générique (pas un transfert)',
    errMoreThanOneTransfer: "Plus d'un transfert trouvé",
    errNessunProfiloTrovato: 'Aucun profil trouvé',
    errNessunProfiloTrovatoTA: 'TA manquant sur le voyageur',
    errNoAirportFound: 'Aéroport introuvable',
    errNoFinalizzazioneCorretta: "La finalisation n'a pas eu lieu",
    errNoKeyServizioGenerato: 'Clé de service manquante',
    errNoNoraTransfer: 'Transfert non créé par Nora',
    errNonTrovatoRiferimentoServizioSuMidOffice: 'Référence de service introuvable dans Mid Office',
    errNoProfileInfoTrovato: 'Profil introuvable',
    errNoTransferFound: 'Aucun transfert trouvé',
    errOutOfOffice: 'Absent du bureau',
    errPasseggeriMultipli: 'Passagers multiples',
    errProfiloMittenteNonTA: "Le profil de l'expéditeur n'est pas Travel Arranger",
    errProfiloNoPresenteSuGDS: 'Profil absent du GDS',
    errRichiestaAggiornamentoTrasferta: 'Demande de mise à jour du transfert',
    errRichiestaModificaOCancellazioneTrasferta: 'Demande de modification/annulation du transfert',
    errSollecito: 'Relance',
    errTooManyDaysHotel: 'Séjour hôtelier trop long',
    errTooManyMessages: 'Limite de messages atteinte',
    errTooMuchServiceBoth: 'Trop de services train et avion',
    errTooMuchServicePlane: 'Trop de services avion',
    errTooMuchServiceTrain: 'Trop de services train',
    gfDi: 'de',
    gfNumerico: 'numérique',
    gfReturnLeg: 'Trajet retour',
    gfSeleziona: 'Sélectionner',
    gfSelezionaData: 'Sélectionner une date',
    gfServizioCopertoDaCarnet: 'Service couvert par CARNET',
    gfTransferDepartureDate: 'Date de départ',
    gfTransferDeparturePlace: 'Lieu de départ',
    gfTransferDestinationPlace: 'Lieu de destination',
    gfTransferNumPax: 'Nombre de passagers',
    gfTransferReturnDate: 'Date de retour',
    mcApri: 'ouvrir',
    mcAutotestAggiornato: 'Autotest mis à jour',
    mcConversazioneIniziataIl: 'Conversation démarrée le',
    mcCopiatoNegliAppunti: 'Copié dans le presse-papiers',
    mcCredenzialiErrate: 'Identifiants incorrects',
    mcDebug: 'Debug',
    mcErroreImprevisto: "Désolé, une erreur inattendue s'est produite.",
    mcFilenameLabel: 'nom de fichier',
    mcMe: 'Moi',
    mcNameLabel: 'nom',
    mcOggetto: 'Objet',
    mcOoops: 'Oups !',
    mcPayloadCopiato: 'Le payload a été copié dans le presse-papiers',
    mcRichiestaViaggio: 'Demande de voyage',
    mcScriviMessaggio: 'Écrire un message...',
    mcTestNonTrovato: 'Test introuvable',
    mxErroreImportazioneViaggiatori: "Erreur lors de l'importation des voyageurs",
    mxGestisciNoraAI: 'Gérer Nora AI',
    mxTitoloPanelOperations: 'Opérations du panneau',
    mxTrovati: 'Trouvés',
    mxViaggiatori: 'voyageurs',
    pfCanale: 'canal',
    pfCosto: 'Coût',
    pfDatiCacheProcessOverview:
      'Données de la table cache processOverviewHourly (alignées sur les conversations de la période).',
    pfFinalState: 'État final',
    pfInitialState: 'État initial',
    pfMediaBin: 'Moy./bin',
    pfOrdinateDecrescente: 'triées par ordre décroissant',
    pfProcessi: 'Processus',
    pfScatterCacheHint:
      'Points de la table cache processOverviewHourly (échantillons par heure). Cliquez pour ouvrir le processus.',
    pfScatterCacheHintLong:
      'Points de la table cache processOverviewHourly (échantillons par heure, 5000 points maximum au total). Cliquez pour ouvrir le processus.',
    pfStato: 'État',
    pfStep: 'étapes',
    pfTokenRichieste: 'Jetons/Requêtes',
    pfTotaleCache: 'Total (cache)',
    pfUnitSelezionate: 'unités sélectionnées',
    stCosto: 'Coût',
    tdAereo: 'Avion',
    tdAeroportoArrivo: "Aéroport d'arrivée",
    tdAeroportoArrivoNonValido: "Aéroport d'arrivée invalide",
    tdAeroportoPartenza: 'Aéroport de départ',
    tdAeroportoPartenzaNonValido: 'Aéroport de départ invalide',
    tdAnteprimaRisultatiDinamico: 'Aperçu des résultats Dynamique',
    tdArrivo: 'Arrivée',
    tdCamera: 'Chambre',
    tdCerca: 'Rechercher',
    tdCitta: 'Ville',
    tdCittaNonValida: 'Ville invalide',
    tdClasse: 'Classe',
    tdCompagnia: 'Compagnie',
    tdCoordinate: 'Coordonnées',
    tdDataArrivo: "Date d'arrivée",
    tdDataCancellazione: "Date d'annulation",
    tdDataCheckIn: "Date d'arrivée",
    tdDataCheckOut: 'Date de départ',
    tdDataPartenza: 'Date de départ',
    tdDistanza: 'Distance',
    tdDurata: 'Durée',
    tdEchoToken: 'Echo Token',
    tdFormatoDataOraNonValido: 'Format date/heure invalide',
    tdFormatoDateNonValido: 'Format de date invalide',
    tdHotel: 'Hôtel',
    tdIdCommunity: 'Id de la communauté',
    tdIndirizzo: 'Adresse',
    tdKgBagaglio: 'Kg bagages',
    tdLat: 'Lat',
    tdLatitudine: 'Latitude',
    tdLng: 'Lng',
    tdLongitudine: 'Longitude',
    tdMetri: 'mètres',
    tdMiniRules: 'Mini règles',
    tdOraArrivo: "Heure d'arrivée",
    tdOraPartenza: 'Heure de départ',
    tdPartenza: 'Départ',
    tdPreferenzaPosto: 'Préférence de siège',
    tdPrezzo: 'Prix',
    tdPrezzoAncillary: 'Prix + services auxiliaires',
    tdRisultati: 'résultats',
    tdServiziAggiuntivi: 'Services supplémentaires',
    tdSottotitoloAnteprima: 'Afficher les résultats bruts renvoyés par le moteur de recherche',
    tdStazioneArrivo: "Gare d'arrivée",
    tdStazioneArrivoNonValida: "Gare d'arrivée non valide",
    tdStazionePartenza: 'Gare de départ',
    tdStazionePartenzaNonValida: 'Gare de départ non valide',
    tdTariffa: 'Tarif',
    tdTipo: 'Type',
    tdTipoRicerca: 'Type de recherche',
    tdTratta: 'Trajet',
    tdTrattamento: 'Traitement',
    tdTrattaN: 'N° de trajet',
    tdTreno: 'Train',
    tdTypeRoom: 'Type de chambre',
    abilitaMessaggiFirmati: 'Activer les messages signés avec le nom Nora',
    abilitaMessaggiFirmatiDescrizione:
      "Si activé, les messages envoyés à l'utilisateur seront signés avec le nom « Nora » pour garantir une expérience plus personnalisée.",
    abilitaMessaggioFinale: "Activer l'envoi d'un message final au demandeur de transfert",
    abilitaMessaggioFinaleDescrizione:
      'Si activé, un message informatif est envoyé au demandeur de transfert à la fin de la procédure (textuel ou avec le lien en cas de devis générés automatiquement).',
    abilitato: 'Activé',
    abilitazioneStepAvanzamento: 'Activer les étapes de progression :',
    active: 'Actif',
    aggiungiFarreTreno: 'Ajouter un tarif',
    aggiungiInformazioniMeteo: 'Ajouter les informations météo au message',
    aggiungiInformazioniMeteoDescrizione:
      'Si activé, le message inclura les prévisions météo pour la période du transfert, fournissant des détails utiles pour la planification.',
    aggiungiServizio: 'Ajouter un service',
    aereo: 'Avion',
    aic: 'AIC',
    adminCoefficients: 'Coefficients admin',
    annulla: 'Annuler',
    attachmentsInEmail: "Pièces jointes dans l'e-mail",
    auto: 'Voiture',
    autoTest: 'Test automatique',
    azioni: 'Actions',
    bestBuy: 'Meilleur prix',
    cancellata: 'Annulé',
    caricamento: 'Chargement...',
    chat: 'Chat',
    chooseClientGroupClient: 'Client',
    chooseClientGroupDefault: 'Sélectionnez une option...',
    chooseClientGroupGroup: 'Groupe',
    clickToPreviewMessage:
      'Cliquez sur « Aperçu du message » pour afficher le corps dans une nouvelle fenêtre',
    codice: 'Code',
    codiceCliente: 'Code client',
    codiceGruppo: 'Code groupe',
    communityPanel: 'Panneau communauté',
    communityPresetsList: 'Liste des préréglages communauté',
    compagniaTreno: 'Compagnie ferroviaire',
    compilareCampiObbligatori: 'Remplissez tous les champs obligatoires',
    conferma: 'Confirmer',
    confermaInvio: "Confirmer l'envoi",
    conto: 'Compte',
    controllaPreventivi: 'Vérifier les devis',
    controllaPreventiviDescrizione:
      "Si activé, les devis ne sont pas envoyés au voyageur mais sont créés à l'état « en cours » pour révision",
    conversations: 'Conversations',
    createNew: 'Créer',
    creationDate: 'Date de création',
    creato: 'Créé',
    creazionePreventivo: 'Créer un devis',
    creazioneTrasfertaServizi: 'Créer le transfert et les services',
    currentIsola: 'Île actuelle',
    datiTrasferta: 'Données du transfert',
    datiViaggiatore: 'Données du voyageur',
    defaultPreset: 'Préréglage par défaut',
    deleteDefaultPresetError: 'Impossible de supprimer le préréglage par défaut',
    deleteServiceHeader: 'Suppression du service',
    deleteServiceLabel: 'Voulez-vous supprimer ce service ?',
    deleteSuccess: 'Suppression réussie',
    descrizione: 'Description',
    distance: 'Distance',
    duplicazioneProfiloTrovato: 'Profil voyageur en double, homonymie détectée',
    duration: 'Durée',
    dynamicTest: 'Test dynamique',
    elaborazioneMessaggioInCorso: 'Traitement du message en cours',
    elaborazioneMessaggioInCorsoDetails:
      "Traitement du message en cours… veuillez patienter jusqu'à la fin.",
    error: 'Erreur',
    errore: 'Erreur',
    escludiNora: 'Exclure Nora',
    formale: 'Formel',
    formaleDefault: 'formel (par défaut)',
    gestireDaMidoffice: 'Gérer depuis Mid Office',
    gestireManualmente: 'Gérer manuellement depuis Mid Office',
    gestisciNoraAI: 'Gérer Nora AI',
    gruppo: 'Groupe',
    hotel: 'Hôtel',
    hotelAutomatico: 'Hôtel automatique',
    hotelAutomaticoDescrizione:
      "Si le transfert dure plusieurs jours, l'hôtel est ajouté automatiquement.",
    id: 'Id',
    identificativoAnno: 'Identifiant année',
    identificativoPratica: 'Identifiant de pratique',
    identificativoRichiesta: 'Identifiant de demande',
    ignorata: 'Ignoré',
    impostazionePreventiviGenerati: 'Paramètre des devis générés',
    impostazioni: 'Paramètres',
    impostazioniSistema: 'Paramètres système',
    salvataggioEffettuato: 'Enregistrement réussi',
    stateDiffDescrizione:
      "Si activé, les nouvelles conversations utiliseront le format State Diff pour l'historique des processus. Les conversations existantes ne sont pas affectées.",
    nessunRecordSistema: 'Aucun enregistrement système trouvé dans la base de données.',
    inAttesaDiConferma: 'En attente de confirmation',
    inEsecuzione: 'En cours',
    inactive: 'Inactif',
    indicateFormalityLevel: 'Indiquer le niveau de formalité',
    indietro: 'Retour',
    informale: 'Informel',
    inserireDatiViaggiatore: 'Saisir les données du voyageur',
    logicaCameraNonInPenale: 'Logique chambres sans pénalité',
    logicaCameraNonInPenaleDescrizione1:
      "Si l'hôtel est soumis à des pénalités, la première chambre sans pénalité dans le même hôtel sera recherchée.",
    logicaCameraNonInPenaleDescrizione2:
      'Si indisponible, la chambre « meilleur prix » sera sélectionnée.',
    login: 'Connexion',
    logout: 'Déconnexion',
    mastro: 'Grand livre',
    messaggioLink: 'Dans le message où il apparaît :',
    messaggioLinkPreventivi: '- « #link » : le lien pour consulter les devis sera inséré',
    messaggioMeteo:
      "- « #meteo » : les informations météo seront insérées (si la demande de transfert est dans les 5 jours précédant le départ). Pour afficher la phrase, l'option « Inclure les informations météo » doit être activée.",
    messaggioPreimpostatoUtente: "Message prédéfini pour l'utilisateur",
    messaggioPreimpostatoUtenteDescrizione:
      'Si sélectionné, le voyageur sera informé que sa demande est prise en charge par un opérateur réel.',
    messaggioPreventivi: 'Message pour les devis :',
    messaggioReindirizzamentoOperatore: "Message pour la redirection vers l'opérateur :",
    messaggioReindirizzamentoOperatoreDescrizione:
      "Message prédéfini à envoyer à l'utilisateur en cas de redirection vers l'opérateur",
    modificaViaggiatore: 'Modifier le voyageur',
    moltoFormale: 'Très formel',
    nProposte: 'N. devis',
    nessunProfiloTrovato: 'Profil non trouvé',
    nessunProfiloTrovatoTA: 'Lien voyageur et TA non trouvé',
    profiloMittenteNonTA: "Profil expéditeur n'est pas Travel Arranger",
    nessunServizioInserito: 'Aucun service saisi',
    nessunServizioTrenoInserito: 'Aucun service train saisi',
    nessunServizioHotelInserito: 'Aucun service hôtel saisi',
    nessunServizioAereoInserito: 'Aucun service vol saisi',
    nessunServizioAutoInserito: 'Aucun service voiture saisi',
    servizioEmptyHint: "Ajoutez-le uniquement s'il est demandé dans la conversation",
    no: 'Non',
    noConversationsFound: 'Aucune conversation trouvée',
    noPresetFound: 'Aucun préréglage trouvé',
    noProfileInfoTrovato: 'Profil voyageur non trouvé',
    noraEsclusa: 'Nora exclue',
    operations: 'Opérations',
    operatoreCreazionePratica: 'Opérateur de création de pratique',
    outOfOffice: 'Absent du bureau',
    sollecito: 'Relance',
    maxAIMessagesReachedInGC: 'Contenu générique (pas une demande de voyage)',
    panelOperations: 'Opérations du panneau',
    performanceMonitor: 'Moniteur de performance',
    passeggeriMultipli: 'Plusieurs passagers identifiés',
    pocoFormale: 'Peu formel',
    prendiInCarico: 'Prendre en charge',
    presetAbilitato: 'Préréglage activé',
    previewMessage: 'Aperçu du message',
    price: 'Prix',
    processes: 'Processus',
    prontoARipartire: 'En cours',
    pubblicaLoStesso: 'Publier quand même',
    pubblicaLoStessoDescrizione:
      "Si aucun résultat n'est trouvé pour l'un des services demandés, les devis sont quand même publiés",
    raccoltaInformazioni: "Collecte d'informations",
    ragioneSociale: 'Raison sociale',
    requester: 'Demandeur',
    ricercaCliente: 'Recherche client',
    ricercaGruppo: 'Recherche groupe',
    ricercaPer: 'Rechercher par',
    richiediMezzoTrasporto: 'Demander le transport si non spécifié',
    richiediMezzoTrasportoDescrizione:
      "Si activé, l'utilisateur sera invité à indiquer s'il souhaite un service aérien ou ferroviaire pour atteindre la destination si ce n'est pas déjà spécifié.",
    richiestaModificaOCancellazioneTrasferta:
      "Demande de modification ou d'annulation du transfert",
    richiestaAggiornamentoTrasferta: 'Demande de mise à jour des informations du transfert',
    salva: 'Enregistrer',
    selectEmail: "Sélectionner l'e-mail",
    selectEmailRedirect: "Sélectionner l'e-mail de redirection vers l'opérateur",
    selectEnvironment: "Sélectionner l'environnement",
    selectEnvironmentPlaceholder: "Sélectionner l'environnement",
    selectFormalityLevel: 'Sélectionner le niveau de formalité',
    selectPID: 'Sélectionner le PID',
    selectUnit: "Sélectionner l'unité à exécuter",
    selectUnitToExecute: "Sélectionner l'unité à exécuter",
    selectedDate: 'Date sélectionnée',
    seleziona: 'Sélectionner',
    selezionaPrioritaServizio: 'Sélectionner la priorité du service',
    selezionaPrioritaTariffa: 'Sélectionner la priorité du tarif train',
    selezionaRicerca: 'Sélectionner la recherche',
    tariffeRimborsabili: 'Tarifs remboursables',
    tariffeNonRimborsabili: 'Tarifs non remboursables',
    selezionato: 'Sélectionné',
    serviziAereo: 'Services aériens',
    serviziAuto: 'Services voiture',
    serviziHotel: 'Services hôtel',
    serviziTreno: 'Services train',
    servizio: 'Service',
    societyList: 'Liste des sociétés',
    soloCamereNonInPenale: 'Uniquement les chambres sans pénalité',
    soloCamereNonInPenaleDescrizione:
      "Si aucune chambre sans pénalité n'est trouvée dans un hôtel, passer à l'hôtel suivant et répéter jusqu'à 10 tentatives.",
    sottoConto: 'Sous-compte',
    state: 'Statut',
    stepNascostoB4B:
      "Cette étape est sélectionnée mais l'intégration B4B est désactivée. Sélectionnez une autre étape ou réactivez B4B.",
    statistics: 'Statistiques',
    success: 'Succès',
    terminato: 'Terminé',
    time: 'Heure',
    tipo: 'Type',
    tipologiaTariffa: 'Type de tarif',
    titolo: 'Titre',
    titoloPreset: 'Titre du préréglage',
    tolleranzaGiorniPenale: 'Tolérance jours de pénalité',
    tonoEmail: "Ton de l'e-mail :",
    tornaIndietro: 'Retour',
    trasfertaCreata: 'Transfert créé',
    travellersList: 'Liste des voyageurs',
    treno: 'Train',
    usaPresetDefault: 'Utiliser le préréglage par défaut',
    userList: 'Liste des utilisateurs',
    users: 'Utilisateurs',
    verificaConfermaDatiIA: "Vérifier et confirmer les données générées par l'AI",
    verificaConfermaDatiIADescrizione:
      "Après la collecte des données, l'opérateur doit examiner et confirmer les informations saisies par l'AI dans la section « Formulaire opérateur ».",
    vuoiConfermareDati: 'Voulez-vous confirmer les données ?',
    gfRifaiRicerca: 'Relancer la recherche',
    gfRifaiRicercaTitolo: 'Relancer la recherche ?',
    gfRifaiRicercaConferma:
      'Une nouvelle recherche sera lancée avec les données du formulaire et le voyageur recevra un nouveau devis. Voulez-vous continuer ?',
    vuoiPrendereInCarico: 'Voulez-vous prendre en charge la conversation ?',
    gfAttendiCompletamentoTrasferta: 'Attendre la fin pour modifier le transfert',
    gfAvviata: 'Démarré',
    gfCampi: 'champs',
    gfCampiDaCompilare: 'à remplir',
    gfCampiDaRivedere: 'à revoir',
    gfCampiObbligatoriDaCompilare: 'obligatoires à remplir',
    gfCampiObbligatoriMancanti: 'CHAMPS OBLIGATOIRES MANQUANTS',
    gfCampiPersonalizzati: 'Champs personnalisés',
    gfCampo: 'champ',
    gfCampoObbligatorio: 'Champ obligatoire',
    gfCampoObbligatorioMancante: 'CHAMP OBLIGATOIRE MANQUANT',
    gfCaricamentoProfilo: 'Chargement du profil',
    gfCaricamentoProfiloDettaglio:
      'Veuillez patienter pendant la récupération des données du voyageur sélectionné…',
    gfCerca: 'Rechercher',
    gfChiudiAnteprima: "Fermer l'aperçu",
    gfAllegati: 'Pièces jointes',
    gfAllegatoFile: 'Fichier',
    gfAllegatiNelCorpoEmail:
      "Images intégrées dans le corps de l'e-mail (généralement affichées en ligne dans le message ci-dessus)",
    gfInCorpoEmail: "corps de l'e-mail",
    gfChatComposerPlaceholder:
      'Écrire un message… Entrée pour envoyer, Maj+Entrée pour une nouvelle ligne',
    gfChatSend: 'Envoyer le message',
    gfAudio: 'Audio',
    gfComprimi: 'Réduire',
    gfContieneErrori: 'contient des erreurs',
    gfContieneErroriTitle: 'Contient des erreurs',
    gfConversazioneNonTrovata: 'Conversation introuvable',
    gfDaRivedere: 'À revoir',
    gfEspandi: 'Développer',
    gfImmagine: 'Image',
    gfLetto: 'lu',
    gfConversazione: 'Conversation',
    gfConversazioneConNora: 'Conversation avec Nora',
    gfConversazionePrecedente: 'Conversation précédente',
    gfConversazioneSuccessiva: 'Conversation suivante',
    gfConv: 'Conv.',
    gfCreaTest: 'Créer un test',
    gfDa: 'de',
    gfDeleteServiceLabelIrreversible:
      'Voulez-vous supprimer ce service ? Cette action est irréversible.',
    gfEliminaServizio: 'Supprimer le service',
    gfElaborazioneInCorso: 'Traitement en cours',
    gfErroreAggiornamentoState: "Erreur de mise à jour de l'état",
    gfErroreCaricamentoViaggiatore: 'Erreur lors du chargement du voyageur',
    gfErroreConfermaForm: 'Erreur de confirmation du formulaire',
    gfRispostaOperatore: "Réponse d'un opérateur",
    gfErroreCreazioneTest: "Une erreur s'est produite lors de la création du test",
    gfErroreInvioSegnalazione: "Erreur lors de l'envoi du signalement",
    gfErroreRicercaViaggiatore: 'Erreur lors de la recherche du voyageur',
    gfEsclusioneNora: 'Exclure Nora',
    gfEscludiNoraSub: 'Les prochains messages doivent être traités uniquement par le Mid Office.',
    gfFiltrato: 'Filtré',
    gfFormInviatoSuccesso: 'Formulaire envoyé avec succès',
    gfHaPrecompilato: 'prérempli',
    gfHintRicercaViaggiatore: "Saisissez le prénom et le nom et/ou l'e-mail pour rechercher",
    gfInvia: 'Envoyer',
    gfInviaSegnalazione: 'Envoyer le signalement',
    gfModificaTrasferta: 'Modifier le transfert',
    gfMostraTutteSezioni: 'Afficher toutes les sections',
    gfMostraSoloSezioniDaRivedere: 'Afficher uniquement les sections avec des champs à revoir',
    gfNessunViaggiatoreTrovato: 'Aucun voyageur trouvé',
    gfNessunViaggiatoreTrovatoHint:
      "Essayez de modifier le prénom, le nom ou l'e-mail et relancez la recherche.",
    gfNoteSegnalazione: 'Notes de signalement',
    gfNuovaTrasferta: 'Nouveau transfert',
    gfNuovaConversazione: 'Nouvelle conversation',
    gfOperazioneSuccesso: 'Opération terminée avec succès',
    gfPerCreareTrasferta: 'pour créer le transfert',
    gfPerModificareConversazione: 'Prenez en charge la conversation pour la modifier',
    gfProntaDaCreare: 'Prêt à créer',
    gfProcessi: 'Processus',
    gfPulisciCampi: 'Effacer les champs',
    gfRicercaInCorso: 'Recherche en cours',
    gfRicercaInCorsoDettaglio: 'Recherche de profils correspondant à vos critères…',
    gfRicercaPuntini: 'Recherche en cours…',
    gfRicercaViaggiatore: 'RECHERCHE DE VOYAGEUR',
    gfRimuovi: 'Supprimer',
    gfRimuoviServizio: 'Supprimer le service',
    gfRisultatoTrovato: 'résultat trouvé',
    gfRisultatiTrovati: 'résultats trouvés',
    gfRisolviErroriIn: 'Corriger les erreurs dans',
    gfSalvaBozza: 'Enregistrer le brouillon',
    gfSelezionaViaggiatore: 'Sélectionner un voyageur',
    gfSegnalazioneInviata: 'Signalement envoyé',
    gfSegnalazioneInviataSuccesso: 'Le signalement a été envoyé avec succès',
    gfSezioniForm: 'Sections du formulaire',
    gfServizio: 'service',
    gfServizi: 'services',
    gfSolaLettura: 'lecture seule',
    gfSoloDaRivedere: 'À revoir uniquement',
    gfStateAggiornatoSuccesso: 'État mis à jour avec succès',
    gfTestCreato: 'Test créé',
    gfTestCreatoSuccesso: 'Le test a été créé avec succès',
    gfTrasferta: 'Transfert',
    gfTuttiCampiObbligatoriCompilati: 'Tous les champs obligatoires sont renseignés.',
    gfVaiAProcessi: 'Aller aux processus',
    gfViaggiatore: 'Voyageur',
    gfVuoiEscludereNora: 'Voulez-vous exclure Nora de la conversation ?',
    gfVuoto: 'Vide',
    loginTitle: 'Connexion au tableau de bord',
    loginButton: 'Connexion',
    poweredBy: 'Propulsé par',
    societyListTitle: 'Liste des sociétés',
    societyCode: 'Code société',
    societyNameCol: 'Nom de la société',
    urlAtlante: 'URL Atlante',
    noSocietyFound: 'Aucune société trouvée',
    deleteSocietyHeader: 'Suppression de la société',
    deleteSocietyMessage: 'Voulez-vous supprimer cette société ?',
    userListTitle: 'Liste des utilisateurs',
    noUserFound: 'Aucun utilisateur trouvé',
    deleteUserHeader: "Suppression de l'utilisateur",
    deleteUserMessage: 'Voulez-vous supprimer cet utilisateur ?',
    travellersListTitle: 'Liste des voyageurs',
    noTravellerFound: 'Aucun voyageur trouvé',
    deleteTravellerHeader: 'Suppression du voyageur',
    deleteTravellerMessage: 'Voulez-vous supprimer ce voyageur ?',
    importTravellers: 'Importer des voyageurs',
    phone: 'Téléphone',
    client: 'Client',
    processListTitle: 'Liste des processus',
    goToForm: 'Aller au formulaire',
    pricing: 'Tarification',
    noProcessFound: 'Aucun processus trouvé',
    processId: 'ID processus',
    openStep: "Ouvrir l'étape",
    conversation: 'Conversation',
    messages: 'messages',
    readOnly: 'Lecture seule',
    continueExecution: "Continuer l'exécution",
    processErrors: 'Erreurs de processus',
    processStats: 'Statistiques de processus',
    processComparison: 'Comparaison de processus',
    filters: 'Filtres',
    date: 'Date',
    island: 'Île',
    allIslands: 'Toutes les îles',
    allStates: 'Tous les états',
    search: 'Rechercher',
    searchPlaceholder: 'Rechercher par nom, e-mail, AIC...',
    searchConversations: 'Recherche globale de conversations',
    clearSearch: 'Effacer la recherche',
    resetFilters: 'Réinitialiser les filtres',
    removeAllFilters: 'Supprimer tous les filtres',
    activeFilterOne: 'actif',
    activeFilterMany: 'actifs',
    viewDetail: 'Voir le détail de la conversation',
    open: 'Ouvrir',
    warningConversationPending: 'Attention : conversation en attente',
    conversationPending: 'Conversation en attente',
    tripsInProgress: 'Transferts en cours',
    switchToLight: 'Passer au thème clair',
    switchToDark: 'Passer au thème sombre',
    dashboardPricing: 'Tarification du tableau de bord',
    prompts: 'Prompts',
    home: 'Accueil',
    conversationSingular: 'conversation',
    conversationPlural: 'conversations',
    removeFilterDate: 'Supprimer le filtre de date',
    removeFilterIsland: "Supprimer le filtre d'île",
    removeFilterState: "Supprimer le filtre d'état",
    removeSearch: 'Supprimer la recherche',
    linkMissing: 'Lien manquant',
    linkMissingDetail: '« #link » manquant dans le message de devis',
    weatherInfoMissing: 'Informations météo manquantes',
    weatherInfoMissingDetail: '« #meteo » manquant dans le message de devis',
    titleMissing: 'Titre manquant',
    selectGroupOrClient:
      'Sélectionnez un groupe ou un client ou choisissez comme préréglage par défaut',
    groupNotFound: 'Groupe introuvable',
    testChat: 'Chat de test',
    testChatSubtitle: 'Exécuter une unité spécifique en simulant une conversation complète',
    testParameters: 'Paramètres de test',
    testConversation: 'Conversation de test',
    dbcTitle: 'Console Debug',
    dbcSubtitle: 'Console complète pour tester tous les flux Nora, canaux et paramètres',
    dbcEnvironment: 'Environnement et identité',
    dbcCodSociety: 'Code société',
    dbcTomcatCode: 'Code Tomcat',
    dbcUserEmail: 'E-mail utilisateur',
    dbcOperatorEmail: 'E-mail opérateur',
    dbcExecution: 'Exécution',
    dbcCallType: "Type d'appel",
    dbcUnit: 'Unité / Processus',
    dbcSearchUnit: 'Rechercher une unité...',
    dbcChannel: 'Canal de communication',
    dbcIsDebug: 'Mode Debug (sans BD)',
    dbcPdfQuotes: 'Devis PDF',
    dbcChannelParams: 'Paramètres du canal',
    dbcIdConversazione: 'ID conversation BTM',
    dbcCodiceCliente: 'Code client',
    dbcIsola: 'Île',
    dbcWhatsappFrom: 'WhatsApp From',
    dbcWhatsappId: 'WhatsApp ID',
    dbcMailRefId: 'ID conversation e-mail',
    dbcMailRefIsola: 'E-mail île',
    dbcMailRefSubject: "Objet de l'e-mail",
    dbcSubject: 'Objet',
    dbcBody: 'Corps',
    dbcAdvanced: 'Avancé',
    dbcCustomJson: 'JSON personnalisé (remplace les champs du payload)',
    dbcAudioMessage: 'Message audio',
    dbcShowPreview: "Afficher l'aperçu du payload",
    dbcPayloadPreview: 'Aperçu du payload',
    dbcNoResponse: 'Aucune réponse pour le moment. Envoyez un message.',
    dbcSending: 'Envoi en cours...',
    dbcCopyJson: 'Copier le JSON',
    dbcCopied: 'Copié',
    dbcCopiedJson: 'JSON copié dans le presse-papiers',
    dbcCopyFailed: 'Échec de la copie',
    dbcSentPayload: 'Payload envoyé',
    dbcElapsed: 'Temps de réponse',
    dbcTokens: 'Tokens',
    dbcConvId: 'ID conversation',
    dbcOpenConversation: 'Ouvrir le détail de la conversation',
    dbcSteps: 'Étapes du processus',
    dbcMessageToSend: 'Message généré',
    dbcSelectPreset: 'Sélectionner un préréglage...',
    dbcLoad: 'Charger',
    dbcDelete: 'Supprimer',
    dbcSave: 'Enregistrer',
    dbcCancel: 'Annuler',
    dbcSavePreset: 'Enregistrer le préréglage',
    dbcPresetName: 'Nom du préréglage...',
    dbcReset: 'Réinitialiser',
    dbcClearChat: 'Effacer le chat',
    dbcPresetLoaded: 'Préréglage chargé',
    dbcPresetSaved: 'Préréglage enregistré',
    dbcPresetDeleted: 'Préréglage supprimé',
    campiObbligatori: 'Champs manquants',
    attenzione: 'Attention',
    warning: '⚠️',
    yes: 'Oui',
    modifica: 'Modifier',
    elimina: 'Supprimer',
    chiudi: 'Fermer',
    dataInizio: 'Date de début',
    dataFine: 'Date de fin',
    giornoPrecedente: 'Jour précédent',
    giornoSuccessivo: 'Jour suivant',
    dataDa: 'Date du',
    dataA: 'Date au',
    periodo: 'Période',
    tutti: 'Tous',
    media: 'Moyenne',
    errori: 'Erreurs',
    nessunDatoDisponibile: 'Aucune donnée disponible',
    totale: 'Total',
    processo: 'Processus',
    rimuovi: 'Supprimer',
    secondi: 'secondes',
    minuti: 'minutes',
    eWord: 'et',
    nonTerminato: 'Non terminé',
    filtraPerDataIsolaStato: 'Filtrer par date, île, état ou recherche libre',
    listaConversazioni: 'Liste des conversations',
    gestioneConversazioniPerData: 'Gérer les conversations par date',
    filtraPerData: 'Filtrer par date',
    viaggiatore: 'Voyageur',
    conversazioneChiusa: 'Conversation fermée',
    erroreChiusuraConversazione: 'Erreur lors de la fermeture de la conversation',
    processStepsVisualizer: "Visualiseur d'étapes de processus",
    differenzeStati: "Différences d'état",
    statoStep: "État de l'étape",
    selezionaTipoOperazione: "Sélectionnez le type d'opération",
    workflow: 'Workflow',
    riesecuzioneUnit: "Réexécution d'unité",
    selezionaRieseguiStep: 'Sélectionnez Réexécuter sur une étape',
    finalState: 'État final',
    rieseguiUnaUnit: 'Réexécuter une unité',
    esecuzioneInCorso: 'Exécution en cours…',
    rieseguiUnit: "Réexécuter l'unité",
    visualizzaErrore: "Afficher l'erreur",
    errorePrefix: 'Erreur : ',
    logLabel: 'Logs',
    initialState: 'État initial',
    initialStack: 'Pile initiale',
    finalStack: 'Pile finale',
    inCorso: 'en cours…',
    statisticheErroriPerIntervallo: "Statistiques d'erreurs par intervalle de dates",
    intervalloDate: 'Intervalle de dates',
    processiInErrore: 'Processus en erreur',
    unitInErrore: 'Unités en erreur',
    nonCiSonoErrori: 'Aucune erreur trouvée',
    dettaglioProcessiErrore: 'Détail des processus en erreur',
    panoramica: "Vue d'ensemble",
    performanceUnitTab: 'Performance des unités',
    trendAnalisi: 'Tendances et analyses',
    statisticheErrori: "Statistiques d'erreurs",
    selezionaRange: 'Sélectionnez un intervalle ou utilisez les préréglages rapides',
    cacheAggiornata: 'Cache mise à jour',
    erroreBackfillCache: 'Erreur de backfill du cache',
    erroreSconosciuto: 'erreur inconnue',
    nessunDatoCache:
      'Aucune donnée dans le cache processOverviewHourly pour cet intervalle. Exécutez « Backfill du cache » avec le même intervalle (ou attendez le cron toutes les 10 minutes pour les dernières heures).',
    backfillCache: 'Backfill du cache',
    aggiornamentoCache: 'Mise à jour du cache...',
    backfillCacheStatistiche: 'Backfill du cache statistiques',
    precomputaDescrizione:
      "Précalculer unitStatsHourly et processOverviewHourly (cache de performance et de vue d'ensemble).",
    preset: 'Préréglage',
    oreCustom: 'Heures personnalisées',
    rangePagina: 'Plage de pages',
    oreDaRicalcolare: 'Heures à recalculer',
    eseguiBackfill: 'Exécuter le backfill',
    selezioneGrafico: 'Sélection du graphique : utilisez le bouton « Graphique » dans le tableau.',
    caricamentoDatiCache: 'Chargement des données du cache…',
    cache: 'Cache',
    unit: 'unité',
    dettaglio: 'Détail :',
    mostraTutti: 'Afficher tout',
    soloLenti: 'Lents uniquement',
    nessunaEsecuzioneTrovata: 'Aucune exécution trouvée',
    tempo: 'Temps',
    inizio: 'Début',
    conv: 'Conv.',
    statistichePerUnit: 'Statistiques par unité',
    unitNelPeriodo: 'unités sur la période',
    legenda: 'Légende',
    cercaUnit: 'Rechercher une unité...',
    evidenziazioneRighe: 'Mise en évidence des lignes',
    tutte: 'Toutes',
    soloEvidenziate: 'Mises en évidence uniquement',
    soloNonEvidenziate: 'Non mises en évidence uniquement',
    aggiungiAlGrafico: 'Ajouter au graphique',
    drillDown: 'Exploration détaillée',
    legendaColoriRegole: 'Légende des couleurs et règles',
    nelPeriodo: 'Sur la période',
    deltaVsMediaComplessiva: 'Δ vs moyenne globale',
    colAzioni: 'Actions',
    colN: 'N.',
    colErrPerc: 'Err%',
    colP90Media: 'P90÷Avg',
    colDeltaMedia: 'Δ Avg',
    colDeltaP50: 'Δ P50',
    colDeltaP90: 'Δ P90',
    colDeltaP95: 'Δ P95',
    colDeltaP99: 'Δ P99',
    costoLlmProcessi: 'Coût LLM pour les processus de conversation',
    filtraProvider: 'Filtrer les fournisseurs',
    selezionaProviderVisualizzare: 'Sélectionner les fournisseurs à afficher',
    dettaglioCostiUnit: 'Détails des coûts par unité',
    ripartizioneCosti: 'Répartition des coûts',
    perProvider: 'Par fournisseur',
    nessunCostoVisualizzare: 'Aucun coût à afficher pour les fournisseurs sélectionnés.',
    statoProcessSteps: 'État des étapes du processus',
    processStepsInErrore: 'Étapes du processus avec erreurs',
    riepilogoCosti: 'Récapitulatif des coûts',
    tempiDiEsecuzione: "Temps d'exécution",
    tempoDiEsecuzione: "Temps d'exécution :",
    tempiUnit: 'Temps par unité',
    min: 'Min',
    max: 'Max',
    sommaUnit: 'Somme des unités :',
    ordineEsecuzione: "Ordre d'exécution",
    durata: 'Durée',
    prompt: 'Prompt',
    campo: 'Champ',
    spiegazione: 'Explication',
    nessunPromptInserito: 'Aucun prompt trouvé',
    selezionaPeriodoAnalisi:
      "Sélectionnez la période d'analyse ou utilisez les préréglages rapides",
    selezionaPeriodoLabel: 'Sélectionner la période :',
    filtraPerIsolaUnitaCliente: 'Filtrer par île, unité opérationnelle ou client',
    unitaOperativa: 'Unité opérationnelle',
    tutteLeUnitaOp: 'Toutes les unités opérationnelles',
    tuttiIClienti: 'Tous les clients',
    cercaCliente: 'Rechercher un client...',
    reset: 'Réinitialiser',
    totaleFatturatiNelPeriodo: 'Total facturé sur la période',
    nConversazioni: 'n° conversations :',
    costoAConversazione: 'Coût par conversation :',
    gestiteDaNora: 'Géré par Nora',
    escluseConversazioniInoltrate: "* hors conversations transférées à l'opérateur",
    nessunaConversazioneNelPeriodo: 'Aucune conversation sur la période',
    costoTotale: 'Coût total',
    conversazioniTotali: 'Conversations totales',
    elaborate: 'Traitées :',
    inoltrate: 'Transférées :',
    datiChatNonDisponibili: 'Données de chat non disponibles',
    importazioneCompletata: 'Importation terminée',
    conversazioniInserite: 'conversations insérées',
    saltateGiaPresenti: 'ignorées (déjà présentes)',
    erroreDuranteImportazione: "Erreur lors de l'importation ou de l'exécution du test :",
    autoTestTitle: 'Test automatique',
    autoTestSubtitle: "Tests automatisés pour valider l'extraction de données des conversations",
    caricamentoInCorso: 'Chargement...',
    caricaTestConv: 'Charger TESTCONV.json',
    lanciaTuttiITest: 'Lancer tous les tests',
    test: 'Test',
    nessunTestTrovato: 'Aucun test trouvé',
    messaggio: 'Message',
    fileAllegati: 'Fichiers joints',
    allegaFile: 'Joindre un fichier',
    messaggioBozzaNora: 'Message brouillon de Nora : ',
    copia: 'Copier',
    nessunMessaggio: 'Aucun message',
    leggiJson: 'Lire JSON',
    risultatoElaborazione: 'Résultat du traitement',
    step: 'Étape',
    combTariffaCompagniaDuplicata: 'Cette combinaison tarif et compagnie existe déjà',
    duplicato: 'Doublon',
    apriChiudiMenu: 'Ouvrir ou fermer le menu de navigation',
    chiudiMenu: 'Fermer le menu de navigation',
    nuovaProposta: 'NOUVELLE PROPOSITION',
    formatoDataPlaceholder: 'dd/mm/yyyy',
    executionTime: "Temps d'exécution",
    stPresetOggi: "Aujourd'hui",
    stPreset7Giorni: '7 jours',
    stPreset30Giorni: '30 jours',
    stPresetQuestoMese: 'Ce mois',
    stPreset3Mesi: '3 mois',
    stPresetAnno: 'Année',
    stStatusAperta: 'Ouverte',
    stStatusTerminata: 'Terminée',
    stStatusGestitaOperatore: "Gérée par l'opérateur",
    stChartTrasferteCreate: 'Transferts créés',
    stChartInoltrateOperatore: "Transférées à l'opérateur",
    stChartNoraEsclusa: 'Nora exclue',
    stChartConversazioniIgnorate: 'Conversations ignorées',
    stChartInCaricoOperatore: 'Prise en charge par un opérateur',
    stChartCorrettamenteGestite: 'Correctement gérées',
    stCardElaborate: 'Conversations traitées',
    stCardConsegnateGestioneManuale: 'Remises pour gestion manuelle',
    stCardEscluseErrori: 'Exclues / erreurs',
    stDettagliElaborate: 'Détails % traitées',
    stDettagliInoltrate: 'Détails % transférées',
    stDettagliErrori: 'Détails % erreurs',
    stPercTotale: '% du total des conv.',
    stPeriodoSelezionato: 'Période sélectionnée :',
    stDashboardEuro: 'Tableau de bord €',
    stEsportaReport: 'Exporter le rapport',
    stSegnaFatturato: 'Marquer comme facturé',
    stPieGenerale: 'Général',
    stPieOpenPausa: 'Ouvertes ou en pause',
    stPieErroriGestiti: 'Erreurs gérées',
    stPieNoraEsclusaOp: 'Nora exclue par op.',
    stTornaStatistiche: 'Retour aux statistiques',
    stCostoConversazioniTempo: 'Coût des conversations dans le temps',
    stCostoMedioPeriodo: 'Coût moyen sur la période :',
    pfStatoProcessi: 'État des processus',
    pfProcessiLower: 'processus',
    pfProcessiCreatiPerOra: 'Processus créés par heure',
    pfNessunDatoNelPeriodo: 'Aucune donnée sur la période',
    pfServerCanali: 'Serveurs et canaux',
    pfStatoInTempoReale: 'État en temps réel',
    pfOperatori: 'opérateurs',
    pfTokenMin: 'Token/min',
    pfRichiesteMin: 'Requêtes/min',
    pfInCoda: "En file d'attente :",
    pfNessunDatoServer: 'Aucune donnée serveur disponible',
    pfConnSuffix: ' conn.',
    pfLegendaRosso: '- **Rouge** : `Err% > 10` (nombreuses erreurs).',
    pfLegendaGiallo:
      '- **Jaune** : `P90÷Average ≥ ${threshold}` (variance élevée : queue lente vs moyenne).',
    pfVarianzaP90Media: 'Variance P90 ÷ Moyenne',
    pfRapportoP90Media: 'Rapport entre P90 et la moyenne arithmétique sur la période sélectionnée.',
    pfValoriAltiCoda: 'Les valeurs élevées indiquent une queue lente par rapport au temps moyen.',
    pfMediaAssolutaColonne: 'Moyenne absolue et colonnes Δ (ms)',
    pfBaselineCalcolata:
      'La baseline est calculée sur les 12 derniers mois de cache horaire, en excluant les buckets de la période sélectionnée.',
    pfColonneDeltaMostrano:
      'Les colonnes Δ affichent (période − baseline) en ms : positif = plus lent, négatif = plus rapide.',
    pfAndamentoNelTempo: 'Évolution dans le temps',
    pfSelezionaUnitTabella: 'Sélectionner une unité dans le tableau',
    pfSelezionaUnaPiuUnit:
      'Sélectionnez une ou plusieurs unités dans le tableau pour afficher le graphique',
    pfNessunDatoNelPeriodoSelezionato: 'Aucune donnée sur la période sélectionnée',
    pfEsecuzioniSommaUnit: 'Exécutions (somme des unités) :',
    pfMedia: 'moyenne',
    pfAndamentoGiornaliero: 'Tendance journalière',
    pfSelezionaUnaPiuUnitGiornaliero:
      'Sélectionnez une ou plusieurs unités pour le graphique journalier',
    pfBarreEsecuzioniLinee: 'Barres : exécutions · Lignes : temps moyen ± écart-type',
    pfEsecuzioni: 'Exécutions',
    pfTempoMedioMs: 'Temps moyen (ms)',
    pfEsecuzioniSigmaUnit: 'Exécutions (Σ unité)',
    pfNessunDatoGiornaliero:
      'Aucune donnée journalière sur la période (essayez un remplissage du cache ou une plage plus large)',
    pfTempoMedioPerUnit: 'Temps moyen par unité',
    pfSecondiTop: 'Secondes · top',
    pfDistribuzioneTempiProcessi: 'Distribution des temps de processus',
    pfOgniPuntoProcesso: 'Chaque point est un processus terminé. Cliquez pour ouvrir les détails.',
    pfProcessoHash: 'Processus n°',
    pfTempo: 'Temps : ',
    pfNessunProcessoTempo: "Aucun processus avec temps d'exécution sur la période",
    pfVolumeProcessiPanoramica: 'Volume des processus · vue journalière',
    pfTreViste: 'Trois vues sur la même plage : étapes par unité, temps moyens, processus terminés',
    pfGrafici12Prime:
      'Graphiques 1 et 2 : top ${max} unités par volume sur la période sur ${total} au total ; la pile inclut « Autres unités » pour le reste.',
    pfStepPerUnitStack: '1 · Étapes par unité (pile journalière)',
    pfColonneImpilate:
      "Colonnes empilées : pour chaque jour, combien d'étapes ont été exécutées pour chaque unité mise en évidence ; la bande grise cumule les autres unités.",
    pfAltreUnit: 'Autres unités',
    pfTempoMedioEsecuzionePerUnit: "2 · Temps d'exécution moyen par unité",
    pfLineeMediaGiornaliera:
      "Lignes : moyenne journalière du temps d'étape ; barres verticales ± écart-type de l'échantillon.",
    pfStepNelGiorno: 'Étapes dans la journée (toutes unités) :',
    pfProcessCompletatiPerGiorno: '3 · Processus terminés par jour',
    pfConteggioProcessEndTime:
      'Nombre de processus avec endTime dans la journée et état 3 (ok) ou 5 (erreur). Les jours sans clôtures affichent 0.',
    pfProcess: 'Processus',
    pfProcessCompletati: 'Processus terminés',
    pfNessunGiornoNelRange: 'Aucun jour dans la plage',
    pfMediaRecente: 'Moyenne récente',
    pfBaseline: 'Baseline',
    pfRapporto: 'Rapport',
    pfErroriRecenti: 'Erreurs récentes : ',
    pfBaselineInfix: ' (baseline : ',
    pfTuttiSistemiNormali: 'Tous les systèmes fonctionnent normalement',
    pfAnomalieRilevate: 'anomalies détectées',
    pfVistaForm: 'Vue formulaire',
    pfVistaJson: 'Vue JSON',
    pfRieseguiUnit: "Réexécuter l'unité",
    pfConfermaRieseguiUnit:
      "Voulez-vous réexécuter cette unité avec l'état initial de l'étape sélectionnée ?",
    pfStepPrecedente: 'Étape précédente',
    pfStepSuccessivo: 'Étape suivante',
    pfRisultatoPrecedente: 'Précédent',
    pfRisultatoSuccessivo: 'Suivant',
    pfCerca: 'Rechercher...',
    pfToken: 'Token ',
    tutteEsecuzioni: 'Toutes',
    nessunErroreTrovato: 'Aucune erreur trouvée sur la période',
    nomeProcesso: 'Nom',
    ggRoomSingola: 'Simple (1 adulte)',
    ggRoomDoppia: 'Double (2 adultes)',
    ggRoomTripla: 'Triple (3 adultes)',
    ggComposizioneCamere: 'Composition des chambres',
    ggAggiungiOpzione: 'Ajouter une option',
    ggNessunaPreferenzaCamere:
      'Aucune préférence de chambre (les valeurs par défaut seront utilisées)',
    ggOpzione: 'Option',
    ggCamera: 'Chambre',
    ggTipoCamera: 'Type de chambre',
    ggCampiPersonalizzati: 'CHAMPS PERSONNALISÉS',
    ggErroreRicercaCliente: 'Erreur de recherche client',
    ggPulisci: 'Effacer',
    ggNessunaOpzione: 'Aucune option disponible',
    gfMonthNames:
      'Janvier,Février,Mars,Avril,Mai,Juin,Juillet,Août,Septembre,Octobre,Novembre,Décembre',
    gfDayNamesShort: 'Dim,Lun,Mar,Mer,Jeu,Ven,Sam',
    admDisabilitato: 'Désactivé',
    admSezioneInfoBase: 'Informations de base',
    admSezioneImpostazioniAI: 'Paramètres AI',
    admSezioneIntegrazioneB4B: 'Intégration B4B',
    admSezioneIntegrazioneAtlante: 'Intégration Atlante',
    admSezioneIntegrazioneDinamico: 'Intégration Dinamico (PHP et WSDynPkg)',
    admSezioneEmailComunicazioni: 'E-mail et communications',
    admSezioneGoelett: 'Devis Goelett',
    admGoelettPinPreventivo: 'PIN de déblocage du devis',
    admGoelettPinPreventivoDesc:
      "Si activé, le devis Goelett ne s'ouvre qu'avec le code envoyé au voyageur. Si désactivé, la page s'ouvre depuis le lien.",
    admGoelettScadenzaPreventivo: 'Expiration du devis (minutes)',
    admGoelettScadenzaPreventivoDesc:
      "Minutes de vie du devis depuis la recherche, avec le minuteur sur la page. -1 = n'expire pas. Les offres Goelett durent environ 15 minutes.",
    admCreaSocieta: 'Créer une nouvelle société',
    admModificaSocieta: 'Modifier la société',
    admSottotitoloSocieta: 'Configurer les paramètres et intégrations de la société',
    admEspandiTutto: 'Tout développer',
    admChiudiTutto: 'Tout réduire',
    admUsername: "Nom d'utilisateur",
    admPassword: 'Mot de passe',
    admIdEnvironment: 'Id environnement',
    admRuolo: 'Rôle',
    admAnagraficaUtente: 'Fiche utilisateur',
    admCreaUtente: 'Créer un utilisateur',
    admModificaUtente: "Modifier l'utilisateur",
    admPID: 'PID',
    admEmail: 'E-mail',
    admTelefono: 'Téléphone',
    admNome: 'Prénom',
    admCognome: 'Nom',
    admAnagraficaViaggiatore: 'Fiche voyageur',
    admCreaViaggiatore: 'Créer un voyageur',
    admModificaViaggiatore: 'Modifier le voyageur',
    admImportaViaggiatori: 'Importer des voyageurs',
    admSottotitoloImport:
      'Téléverser un fichier CSV pour importer en masse le registre des voyageurs',
    admCaricaCSV: 'Téléverser CSV',
    admCaricaSuDB: 'Téléverser vers la BDD',
    admAnteprimaFile: 'Aperçu du fichier téléversé',
    admViaggiatoriDaImportare: ' voyageurs à importer',
    admNienteDaVisualizzare: 'Rien à afficher',
    admTutorialUpload: 'Téléversez un fichier CSV contenant les voyageurs à ajouter.',
    admTutorialStruttura: 'Le fichier CSV doit être structuré comme suit : ',
    admTutorialIntestazione:
      "La première ligne d'en-tête doit contenir les champs pid, email, numéro de téléphone, code client.",
    admTutorialDati: 'À partir de la deuxième ligne, saisissez les données des différents clients.',
    admTutorialEsempio: 'Voici un fichier exemple à modifier et téléverser.',
    admScarica: 'Télécharger',
    admAggiornaLabelErrori: "Mettre à jour les libellés d'erreur",
    admAggiornaLabelErroriHint:
      "Mettre à jour le libellé d'erreur pour les catégoriser avec la dernière version du classificateur.",
    admAggiornaErroriTAProfile: 'Mettre à jour les erreurs de profil TA',
    admAggiornaErroriTAProfileHint:
      'Recalculer les erreurs liées au profil TA (registre des voyageurs).',
    admAggiornaErroriOutOfOffice: "Mettre à jour les erreurs d'absence du bureau",
    admAggiornaErroriOutOfOfficeHint:
      "Mettre à jour la classification des e-mails d'absence du bureau.",
    admSottotitoloPanel: 'Opérations de maintenance des données',
    admOperazioniManutenzione: 'Opérations de maintenance',
    admSottotitoloManutenzione: 'Exécutez-les avec précaution · actions irréversibles',
    admEsegui: 'Exécuter',
    controlliIA: 'Contrôles AI',
    cpDuplica: 'Dupliquer',
    cpSottotitoloPanel: 'Panneau communautaire · préréglage de configuration Nora',
    cpAggiungiFiltri: 'Ajouter des filtres',
    cpAggiungiFiltro: 'Ajouter un filtre…',
    cpNRimborsabili: 'N° remboursables',
    cpNNonRimborsabili: 'N° non remboursables',
    cpInserisciParametroRicerca: 'Saisissez au moins un paramètre de recherche',
    cpErroreRicercaGruppo: 'Erreur lors de la recherche du groupe',
    cpGruppoNonTrovato: 'Groupe introuvable',
    cpPresetEsistente: 'Préréglage existant',
    cpGruppoConfigurazioneEsistente: 'Ce groupe possède déjà une configuration enregistrée',
    cpClienteNonTrovato: 'Client introuvable',
    cpClienteConfigurazioneEsistente: 'Ce client possède déjà une configuration enregistrée',
    cpCreaPreset: 'Créer un préréglage communautaire',
    cpModificaPreset: 'Modifier le préréglage communautaire',
    mxElencoPrompts: 'Liste des prompts',
    mxPromptLLMSubtitle: 'Prompts LLM utilisés pour extraire les champs de conversation',
    mxCompilaCampi: 'Remplissez tous les champs',
    mxPromptCreato: 'Prompt créé',
    mxCreazionePrompt: 'Créer un prompt',
    mxModificaPrompt: 'Modifier le prompt',
    mxConfigurazionePrompt: 'Configuration du prompt',
    mxChiaveCampoJson: 'Clé de champ JSON',
    mxSpiegazioneCampo: 'Explication du champ (basePrompt)',
    mxValidaTestLabel: "Voulez-vous valider le test ? Le résultat de l'autotest sera mis à jour",
    mxTestIdPrefix: 'ID test : ',
    mxValidazioneEstrazione: "Validation de l'extraction de données de conversation",
    mxTestPrecedente: 'Test précédent',
    mxTestSuccessivo: 'Test suivant',
    mxEseguiTest: 'Lancer le test',
    mxValidaTest: 'Valider le test',
    mxConversazioneTest: 'Conversation de test',
    mxMessaggiSuffix: ' messages',
    mxRisultatoAtteso: 'Résultat attendu',
    mxRisultatoOttenuto: 'Résultat obtenu',
    mxInEsecuzione: 'En cours',
    mxImpostazioneCoefficienti: 'Paramétrage des coefficients de recherche',
    mxImpostaCoefficientiPer: 'Définir les coefficients pour ',
    mxTipoPreventivo: 'Type de devis ',
    // Demo Goelett
    dgTitle: 'Nora — Intégration Goelett',
    dgSubtitle: 'Démo flux email → traitement IA → devis interactif',
    dgPresetLoaded: 'Preset Goelett chargé',
    dgEmailPanel: 'Email entrant',
    dgFrom: 'De',
    dgSubject: 'Objet',
    dgBody: "Corps de l'email",
    dgBodyPlaceholder:
      "Écrivez le contenu de l'email...\n\nex. Bonjour, j'aurais besoin d'un voyage\nMilan → Londres le 15 octobre,\nretour le 18 octobre.\nJe préfère un vol direct si possible.\nMerci",
    dgSend: 'Envoyer email à Nora',
    dgSending: 'Envoi en cours...',
    dgContinue: 'Répondre',
    dgNewConversation: 'Nouvelle conversation',
    dgReset: 'Réinitialiser la conversation',
    dgConversation: 'Conversation Nora',
    dgStatusWaiting: 'En attente',
    dgStatusLoading: 'Traitement...',
    dgStatusSuccess: 'Connecté',
    dgStatusError: 'Erreur',
    dgEmpty: 'Aucun message. Envoyez un email pour commencer.',
    dgAsyncMessage: '[Async] Demande reçue. Traitement en cours...',
    dgMissingBody: "Écrivez le contenu de l'email",
    dgSendError: "Erreur lors de l'envoi",
    dgMenuLabel: 'Démo Goelett',
    dgFromPlaceholder: 'email@exemple.com',
    dgSubjectPlaceholder: 'ex. Demande de voyage Milan - Londres',
    dgOpenConversation: 'Ouvrir conversation',
    dgPresetLabel: 'Preset',
    dgPresetGroupClient: 'Configurations client',
    dgPresetGroupSaved: 'Presets sauvegardés',
    dgSavedPreset: 'Preset sauvegardé'
  }
}
